<template>
  <!-- ChatGPT-like Main Container -->
  <div class="chatgpt-container" v-if="Status_Error == false">
    <div class="main-scrollable-content-area" ref="MainScrollArea">
      <!-- Messages Area (scrollable) -->
      <div class="messages-container" ref="ChatContainerRef" v-show="listMessage.length > 0">
        <div class="messages-wrapper">
          <div id="ChatScreId" class="messages-scroll-area" ref="ChatScreRef">
            <div class="messages-content">
              <v-col cols="12" v-if="Loading_History_Status == true">
                <v-progress-linear indeterminate :color="selectedColor" class="mb-0"></v-progress-linear>
              </v-col>
              <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index" style="
                  font-family: Roboto, sans-serif !important;
                  font-style: normal;
                ">
                <v-row style="margin: 0px" v-if="item.messageUser != null">
                  <v-col col="12">
                    <div class="d-flex align-end justify-end" v-if="
                      item.messageUser != null &&
                      (index > 0
                        ? listMessage[index - 1].messageBot
                        : item.messageBot != null)
                    " :class="xsOnly ? 'flex-row' : ''">
                      <div style="
                          float: right;
                          align-self: center;
                          margin-right: 6px;
                        ">
                        <span style="
                            font-size: 10px;
                            color: rgb(113, 113, 122);
                            margin-bottom: 0px;
                          ">
                          {{ item.requestTime }}
                        </span>
                      </div>
                    </div>
                    <div :class="xsOnly ? 'd-flex flex-row justify-end' : ''" style="
                        line-break: anywhere;
                        padding: 5px 10px;
                        border-radius: 16px 3px 16px 16px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #71717a;
                        line-height: 22px;
                        display: flex;
                        width: fit-content;
                        float: right;
                        min-height: 35px;
                      " :style="getUserMessageBubbleStyle()">
                      <MarkdownIt :content="item.messageUser" :style="{ color: fullstreamUserFontColor }" />
                      <!-- {{ item.messageUser }} -->
                    </div>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" v-if="
                  item.status_Process != 'VoiceStart' &&
                  item.status_Process != 'ChatChain' &&
                  item.messageBot != null
                ">
                  <v-col col="12">
                    <div v-if="
                    item.messageBot != null && (index > 0
                        ? listMessage[index - 1].messageUser
                        : item.messageUser != null)"
                        :style="{ marginLeft: xsOnly ? '14px' : '65px', marginBottom: '4px' }">
                      <span style="
                          font-size: 10px;
                          color: rgb(113, 113, 122);
                          margin-bottom: 0px;
                        ">
                        {{ item.responseTime }}
                      </span>
                    </div>
                    <div class="d-flex flex-row align-start" :class="xsOnly ? 'justify-start' : ''">
                      <template v-if="!xsOnly">
                        <div v-if="item.messageBot != null && (index > 0
                            ? listMessage[index - 1].messageUser
                            : item.messageUser != null)"
                          class="bot-message-avatar">
                          <div class="rotating-element" v-if="item.status_Process == 'Process'" style="display: flex; justify-content: center; align-items: center; position: relative;margin-top: -5px;scale: .8;">
                              <div class="botloader"></div>
                              <div class="botringloader" style="position: absolute;"></div>
                          </div>
                          <v-icon v-else-if="hasFullstreamChatbotIcon && !fullstreamIsImageIcon" style="font-size: 30px;margin-top: -5px;" :style="'color:' + fullstreamHeaderIconColor + ';'">
                            {{ fullstreamChatbotIconValue }}
                          </v-icon>
                          <v-img v-else-if="hasFullstreamChatbotIcon && fullstreamIsImageIcon" style="height: 36px; width: 36px; border-radius: 50%" :src="fullstreamChatbotImageUrl" />
                        </div>
                        <div v-else style="width: 50px; flex-shrink: 0;"></div>
                      </template>
                      <div v-if="item.status_Process == 'Process'" style="
                          font-size: 16px;
                          font-weight: 400;
                          float: left;
                          width: 135px;
                        ">
                        <div v-if="isTextToImageLocal" style="display: flex; justify-content: center; align-items: center; position: relative;height: 180px; margin-left: 90px; margin-bottom: 16px;">
                          <div class="imgloader" style="position: absolute;"></div>
                          <div class="frameloader" style="position: absolute;"></div>
                        </div>
                      </div>

                      <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'">
                        <!-- Quota warning box -->
                        <div v-if="isQuotaWarning(item.messageBot)" class="fullstream-quota-warning"
                          style="line-break: anywhere; border-radius: 8px; font-size: 15px; font-weight: 400;
                                 line-height: 22px; width: fit-content; float: left; max-width: 90%;
                                 background: #FFF3F3; border: 1.5px solid #FCA5A5; padding: 12px 16px;">
                          <div class="d-flex align-center mb-1" style="gap: 6px;">
                            <v-icon color="#DC2626" size="18">mdi-alert-circle</v-icon>
                            <span style="color: #DC2626; font-weight: 600; font-size: 13px;">Quota Exceeded</span>
                          </div>
                          <MarkdownIt :key="rerenderKey" :content="cleanQuotaMsg(item.messageBot)" style="color: #7F1D1D;" />
                        </div>
                        <!-- Normal bot message -->
                        <div v-else
                          class="bot-message-bubble"
                          style="padding: 0px 15px 10px 15px; border-radius: 8px; font-size: 16px; color: #71717a; line-height: 22px; display: flex; width: fit-content; float: left; max-width: 100%;"
                          @click="botMessageClick($event)" :style="xsOnly ? 'max-width: 100%;' : 'max-width: 80%;'">
                          <MarkdownIt style="padding-top: 5px !important;" :key="rerenderKey" :content="item.messageBot" />
                        </div>
                      </div>

                      <!-- Error -->
                      <div v-else class="bot-message-bubble bot-message-bubble--error" style="line-break: anywhere;padding: 16px 20px;background: rgb(249, 249, 249);border-radius: 8px;font-size: 16px;font-weight: 400;
                        line-height: 22px;white-space: pre-line;width: fit-content;float: left;"
                        :style="xsOnly ? 'max-width: 100%; background: rgb(255,255,255);' : 'max-width: 80%; background: rgb(249,249,249);'">
                        <MarkdownIt :content="item.messageBot" />
                        <span>...{{ item.status_Process }}</span>
                      </div>
                    </div>
                    <div v-if="
                      item.status_Process == 'END' ||
                      (((!Snippet_Username == false && Snippet_StatusData) ||
                        !Snippet_StatusData) &&
                        item.isFeedback &&
                        item.status_Process == 'END' &&
                        ![
                          ':model',
                          ':userid',
                          ':clearmemory',
                          ':memory',
                          ':help'
                        ].some((keyword) =>
                          item.messageUser
                            .toLowerCase()
                            .includes(keyword.toLowerCase())
                        ))
                    " class="bot-message-actions-row">
                      <div v-if="item.status_Process == 'END'" class="bot-message-actions-group">
                        <v-btn size="small" variant="text" icon :color="selectedColor" @click="Clipboard(item)">
                          <v-icon size="15px">mdi-content-copy</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="
                        ((!Snippet_Username == false && Snippet_StatusData) ||
                          !Snippet_StatusData) &&
                        item.isFeedback &&
                        item.status_Process == 'END' &&
                        ![
                          ':model',
                          ':userid',
                          ':clearmemory',
                          ':memory',
                          ':help'
                        ].some((keyword) =>
                          item.messageUser
                            .toLowerCase()
                            .includes(keyword.toLowerCase())
                        )
                      " class="bot-message-actions-group">
                        <v-btn v-if="item.status == null || item.status == 0" size="small" variant="text" icon
                          :color="selectedColor" @click="ThisFeedBackResponse(item, 1)">
                          <v-icon size="15px">mdi-thumb-up-outline</v-icon>
                        </v-btn>
                        <v-btn v-else-if="item.status == 1" size="small" variant="text" icon :color="selectedColor"
                          @click="
                            item.status = null;
                          closeDialog(item);
                          ">
                          <v-icon size="15px">mdi-thumb-up</v-icon>
                        </v-btn>

                        <v-btn :value="0" v-if="item.status == null || item.status == 1" size="small" variant="text" icon
                          :color="selectedColor" @click="openCommentDialog(item, index)">
                          <v-icon size="15px">mdi-thumb-down-outline</v-icon>
                        </v-btn>

                        <v-btn :value="0" v-else-if="item.status == 0" size="small" variant="text" icon
                          :color="selectedColor" @click="
                            item.status = null;
                          closeDialog(item);
                          ">
                          <v-icon size="15px">mdi-thumb-down</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                  <v-expand-transition v-show="item.commentDialog">
                    <div style="
                        width: calc(100vi - 24px);
                        position: sticky;
                        bottom: 4px;
                      ">
                      <v-card class="mx-auto" outlined>
                        <v-card-title>
                          Tell us more:
                          <v-spacer></v-spacer>
                          <v-btn @click="
                            item.commentDialog = false;
                          item.status = null;
                          " style="float: right; margin-top: -20px" size="small" icon>
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-subtitle>
                          Provide additional feedback
                        </v-card-subtitle>
                        <v-card-text :class="!item.moreComment ? 'pb-4' : 'pb-0'" class="py-0">
                          <!-- {{item.SelectComment}} -->
                          <v-chip-group column v-model="item.SelectComment">
                            <!-- {{item.SelectComment }} -->
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment != `Don't like the style`
                                ? `Don't like the style`
                                : ''
                              ">
                              Don't like the style
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment != `Not factually correct`
                                ? `Not factually correct`
                                : ''
                              ">
                              Not factually correct
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment !=
                                `Didn't fully follow instructions`
                                ? `Didn't fully follow instructions`
                                : ''
                              ">
                              Didn't fully follow instructions
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment !=
                                `Refused when it shouldn't have`
                                ? `Refused when it shouldn't have`
                                : ''
                              ">
                              Refused when it shouldn't have
                            </v-chip>
                            <v-chip class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment = '';
                            item.moreComment = !item.moreComment;
                            ">
                              More...
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                        <v-card-text v-show="item.moreComment">
                          <v-textarea @click.stop="" rows="2" auto-grow row-height="5" v-model="item.comment"
                            counter="100" maxlength="100" outlined solo label="More details"></v-textarea>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end">
                          <v-btn dense plain :disabled="item.comment == null || item.comment == ''
                            " rounded :color="selectedColor" class="mb-4 mr-4" @click="ThisFeedBackResponse(item, 0)">
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-expand-transition>
                </v-row>
              </div>
              <div ref="ChatRef"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Welcome Screen when no messages -->
      <div v-show="!(listMessage.length > 0) && Loading_History_Status == false" class="welcome-screen">
        <div class="welcome-content">
          <h1 class="welcome-title">{{ fullstreamWelcomeTitleText }}</h1>
          <p class="welcome-subtitle">{{ fullstreamWelcomeSubtitleText }}</p>
        </div>

        <!-- Shortcut Menu -->
        <div v-if="ShortcutMenu.length > 0">
          <v-container fluid class="d-flex justify-center align-center overflow-x-auto px-12 carousel-container">
            <v-btn icon class="scroll-btn" @click="scrollLeft" v-show="showLeftButton">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <div ref="scrollContainer" class="d-flex overflow-x-auto carousel-track" @scroll="onScroll">
              <div v-for="(item, index) in ShortcutMenu" v-bind:key="index">
                <v-card class="rounded-xl text-center content-button" v-on:click="selectCard(item.command)" @keydown.enter.prevent="selectCard(item.command)" flat
                  color="#F0F4F6" width="250px">
                  <v-card-text>
                    <v-avatar class="mx-auto mb-2" size="40">
                      <img v-if="item.imageURL" :alt="'shortcut-comand-img' + index" height="40" :src="item.imageURL"
                        width="40" />
                      <v-icon v-else size="40" color="yellow darken-3 ">
                        mdi-lightbulb-on-outline
                      </v-icon>
                    </v-avatar>
                    <h2 class="text-lg font-semibold">
                      {{ item.nameDisplay }}
                    </h2>
                    <p class="text-gray-600">
                      {{ item.command }}
                    </p>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <v-btn icon class="scroll-btn" @click="scrollRight" v-show="showRightButton">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-container>
        </div>
      </div>

      <!-- Product Recommendations (now positioned properly) -->
      <div v-show="products && products.length > 0 && !hideProducts" class="product-recommendations-section">
        <div class="product-recommendations" >
          <h3 class="recommendations-title">Recommended Products</h3>
          <div class="product-grid">
            <div v-for="(product, index) in products" :key="index" class="product-card">
              <div class="product-content" @click="showProductDetail(product)">
                <img v-if="product.ProductImg" :src="product.ProductImg" :alt="product.name" class="product-image" />
                <div  v-else class="container-product-image">
                  <img src="../assets/images/product_default.png" :alt="product.name" class="product-default-image-recommendation" />
                </div>
                <div class="product-info">
                  <h4 class="product-name">{{ product.ProductName }}</h4>
                  <p class="product-description">{{ product.description }}</p>
                  <div class="product-price">
                    {{
                      product.ProductPrice
                        ? `฿${product.ProductPrice.toLocaleString()}`
                        : "ติดต่อสอบถาม"
                    }}
                  </div>
                  <v-btn rounded="lg" class="product-button" color="#FB8C00" @click.stop="selectProduct(product)">
                    สนใจ
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fixed Bottom Input Area (ChatGPT-style) -->
    <div class="fixed-input-container">
      <div class="scroll-bottom-btn" @click="SetBottom_Page" v-show="showScrollToBottomButton">
        <v-icon color="rgba(0, 0, 0, 0.5)">mdi-arrow-down</v-icon>
      </div>
      <div class="input-wrapper-chatgpt">
        <!-- File Preview Area -->
        <div v-if="fileDataUrl != null || pickedFileType != null" class="file-preview-container">
          <!-- Image Preview -->
          <div v-if="fileDataUrl != null" class="image-preview-wrapper">
            <div class="image-preview-card">
              <img :src="fileDataUrl" alt="img-upload" class="preview-image" />
              <v-progress-circular v-show="loadingImage == true" class="preview-loading" indeterminate color="primary"
                size="24"></v-progress-circular>
              <v-btn v-show="loadingImage == false" icon size="small" class="preview-close-btn" @click="ClearImage()">
                <v-icon size="16">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- File Preview -->
          <div v-if="pickedFileType != null" class="file-preview-wrapper">
            <div class="file-preview-card">
              <div class="file-preview-content">
                <div class="file-icon-section">
                  <img :src="pickedFileType" alt="file-type" class="file-type-icon" />
                  <v-progress-circular v-if="isFileUploadPending" indeterminate color="primary" size="20" width="2"
                    class="file-loading-overlay"></v-progress-circular>
                </div>
                <div class="file-info-section">
                    <div class="file-name-text">
                    {{ pickedFileName.length > 30 ? pickedFileName.substring(0, 30) + '...' : pickedFileName }}
                    </div>
                  <div v-if="isFileUploadPending" class="file-progress-section">
                    <v-progress-linear :model-value="fileUploadProgressPercent" :indeterminate="dataAll <= 0"
                      color="primary" background-color="rgba(0,0,0,0.1)" class="file-upload-progress" height="2"
                      rounded></v-progress-linear>
                    <div class="file-progress-text">
                      <span>{{ dataAll > 0 ? fileUploadProgressPercent + '%' : 'Processing...' }}</span>
                      <span v-if="dataAll > 0">{{ dataUpdate }} / {{ dataAll }}</span>
                    </div>
                  </div>
                  <div v-else class="file-ready-text">
                    <v-icon size="12" color="success">mdi-check-circle</v-icon>
                    <span>Ready</span>
                  </div>
                </div>
              </div>
              <v-btn icon size="small" class="preview-close-btn" @click="ClearUploadedFile()">
                <v-icon size="16">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <!-- Main Input Row -->
        <div class="input-row-container">
          <!-- Central Textarea -->
          <div class="textarea-container-chatgpt">
            <v-textarea id="D_MessageData2" ref="RefMessageData" v-model="messageData" class="chatgpt-textarea"
              variant="outlined" hide-details rows="1" auto-grow :max-rows="6" placeholder="Ask anything..."
              @paste="onPaste" @click:clear="messageData = ''" :maxlength="maximumChatInput"
              @keydown.enter.exact.prevent="SendOpenAi('Enter')"></v-textarea>
          </div>
        </div>

        <!-- AI Disclaimer -->
        <div class="footer-chatbox-section">
          <!-- Left Action Buttons -->
          <div class="input-actions-left">
            <!-- Model Selection Menu -->
            <div>
              <v-menu v-model="showMenu" location="top start" offset-y rounded="lg"
              :close-on-content-click="false" :disabled="ModelQuick.length == 0" style="padding-bottom: 0; margin-bottom: 0;min-width: 220px;max-width:250px">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn variant="text" v-bind="menuProps" :style="{ '--model-accent-color': fullstreamChatAccentColor }"
                    class="input-action-btn model-selector-trigger" :class="{ 'model-selector-trigger--active': showMenu, 'model-selector-trigger--readonly': ModelQuick.length == 0 }" title="Select model">
                    <span class="model-selector-trigger__content">
                      <svg xmlns="http://www.w3.org/2000/svg" class="model-selector-trigger__icon" :style="{ color: fullstreamChatAccentColor }" width="512" height="512" viewBox="0 0 512 512"><path fill="currentColor" d="M204 240H68a36 36 0 0 1-36-36V68a36 36 0 0 1 36-36h136a36 36 0 0 1 36 36v136a36 36 0 0 1-36 36m240 0H308a36 36 0 0 1-36-36V68a36 36 0 0 1 36-36h136a36 36 0 0 1 36 36v136a36 36 0 0 1-36 36M204 480H68a36 36 0 0 1-36-36V308a36 36 0 0 1 36-36h136a36 36 0 0 1 36 36v136a36 36 0 0 1-36 36m240 0H308a36 36 0 0 1-36-36V308a36 36 0 0 1 36-36h136a36 36 0 0 1 36 36v136a36 36 0 0 1-36 36"/></svg>
                      <span class="model-selector-trigger__label">{{ ModelFirst ? 'Model ' + ModelFirst : 'Select model' }}</span>
                      <v-icon v-if="ModelQuick.length > 0" size="16" class="model-selector-trigger__chevron">mdi-chevron-down</v-icon>
                    </span>
                  </v-btn>
                </template>
                  <v-card flat class="pa-0 model-card-container" :style="{ '--model-accent-color': fullstreamChatAccentColor }">
                    <div class="model-card-header">
                      <div class="model-card-header-icon">
                        <Icon icon="lucide:sparkles" />
                      </div>
                      <div class="model-card-header-text">
                        <span>Select Model</span>
                        <small>{{ filteredModels.length }} available</small>
                      </div>
                    </div>

                    <v-text-field
                      v-model="modelSearchQuery"
                      variant="solo-filled"
                      density="compact"
                      hide-details
                      placeholder="Search models..."
                      class="mx-2 mt-2 modern-model-search"
                      clearable
                      :color="fullstreamChatAccentColor"
                    >
                      <template #prepend-inner>
                        <Icon icon="lucide:search" class="model-search-icon" />
                      </template>
                    </v-text-field>
                    
                    <v-divider class="my-1 divider-light"></v-divider>
                    
                    <!-- Streamlined model list -->
                    <div style="min-height: 280px; max-height: 280px; overflow-y: auto;" class="model-list-container pa-0">
                      <div 
                        v-for="(item, index) in filteredModels" 
                        :key="index" 
                        class="model-item d-flex align-center justify-start px-2 py-2"
                        :class="{'model-item-active': isActiveModel(item)}"
                        :style="isActiveModel(item) ? `background-color: ${fullstreamChatAccentColor}10 !important` : ''"
                        @click="selectModel(item)"
                      >
                        <div class="model-avatar-wrapper mr-2 my-0">
                          <div 
                            class="model-avatar" 
                            :style="`background-color: ${isActiveModel(item) ? fullstreamChatAccentColor+'22' : 'white'}`"
                          >
                            <img 
                              v-if="item.imageBase64 != '' && item.imageBase64 != null" 
                              :src="item.imageBase64" 
                              alt="model-avatar"
                              style="width: 12px; height: 12px;"
                            />
                            <Icon v-else icon="lucide:bot" class="model-avatar-icon" />
                          </div>
                        </div>
                        <div class="model-content py-0">
                          <div 
                            class="model-title text-caption text-truncate" 
                            :class="{'font-weight-medium': isActiveModel(item)}"
                            :style="`color: ${isActiveModel(item) ? fullstreamChatAccentColor : '#424242'} !important`"
                          >
                            {{ item.modelName }}
                          </div>
                        </div>
                        <div v-if="isActiveModel(item)" class="model-action ma-0 mr-1 my-0">
                          <Icon icon="lucide:check" class="model-check-icon" />
                        </div>
                      </div>
                    </div>
                    
                    <v-divider class="divider-light mb-1"></v-divider>
                    
                    <!-- Compact card actions -->
                    <div class="py-0 px-2 custom-card-actions">
                      <v-checkbox
                        v-if="ModelQuick.length != 0 ? (
                        (ModelQuick.some(i => i.typeModel == 1) && 
                        ModelQuick.some(i => i.typeModel == 2)) ? true : false)
                        : false"
                        v-model="menuGroupModel"
                        :color="selectedColor"
                        dense
                        hide-details
                        class="mt-0 model-view-toggle"
                        @change="handleMenuToggle"
                      >
                        <template v-slot:label>
                          <span class="text-caption">Show all models</span>
                        </template>
                      </v-checkbox>
                      <div style="flex-grow: 1;"></div>
                      <v-btn class="model-close-btn" variant="text" size="small" :color="fullstreamChatAccentColor" @click="showMenu = false">Close</v-btn>
                    </div>
                  </v-card>
              </v-menu>
            </div>
            <div v-if="showReasoningEffortButton" class="reasoning-effort-button-wrapper">
              <v-menu
                v-model="showReasoningEffortMenu"
                transition="slide-y-transition"
                location="top start"
                offset="8"
                :close-on-content-click="false">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn
                    v-bind="menuProps"
                    class="input-action-btn reasoning-effort-trigger"
                    :class="{ 'reasoning-effort-trigger--active': showReasoningEffortMenu }"
                    variant="text"
                    :style="[
                      { '--reasoning-accent-color': fullstreamChatAccentColor },
                      getReasoningEffortToneStyle(appliedReasoningEffort),
                    ]"
                    :title="'Reasoning effort: ' + appliedReasoningEffortLabel">
                    <span class="reasoning-effort-trigger__content">
                      <Icon
                        icon="mdi:brain"
                        class="fullstream-input-icon reasoning-effort-trigger__icon" />
                      <span class="reasoning-effort-trigger__label">{{ appliedReasoningEffortLabel }}</span>
                      <span class="reasoning-effort-trigger__dot"></span>
                    </span>
                  </v-btn>
                </template>
                <v-card
                  class="reasoning-effort-menu"
                  elevation="8"
                  rounded="16"
                  :style="[
                    { '--reasoning-accent-color': fullstreamChatAccentColor },
                    getReasoningEffortToneStyle(appliedReasoningEffort),
                  ]">
                  <div class="reasoning-effort-menu__header">
                    <span class="reasoning-effort-menu__title">Reasoning effort</span>
                    <span class="reasoning-effort-menu__badge">{{ appliedReasoningEffortLabel }}</span>
                  </div>
                  <div class="reasoning-effort-menu__options">
                    <button
                      v-for="option in reasoningEffortOptions"
                      :key="option.value"
                      type="button"
                      class="reasoning-effort-option"
                      :class="{ 'reasoning-effort-option--active': appliedReasoningEffort === option.value }"
                      :style="getReasoningEffortToneStyle(option.value)"
                      @click="selectReasoningEffort(option.value)">
                      <span class="reasoning-effort-option__icon">
                        <v-icon size="18">{{ option.icon }}</v-icon>
                      </span>
                      <span class="reasoning-effort-option__copy">
                        <span class="reasoning-effort-option__label">{{ option.label }}</span>
                        <span class="reasoning-effort-option__meta">{{ option.meta }}</span>
                      </span>
                      <v-icon
                        v-if="appliedReasoningEffort === option.value"
                        size="16"
                        class="reasoning-effort-option__status">
                        mdi-check-circle
                      </v-icon>
                    </button>
                  </div>
                </v-card>
              </v-menu>
            </div>
            <!-- Attachment Menu -->
            <div class="attachment-button-wrapper" v-if="
              (!Snippet_Username == false && Snippet_StatusData) ||
              (!Snippet_StatusData &&
                fileDataUrl == null &&
                pickedFileType == null)
            ">
              <v-menu transition="slide-y-transition" location="top start" offset="8">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn icon size="40" v-bind="menuProps" class="input-action-btn" variant="text">
                    <v-icon size="20">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card class="attachment-menu" elevation="8" rounded="12">
                  <v-list class="attachment-list">
                    <v-list-item v-for="(item, index) in attachItems" :key="index" class="attachment-list-item"
                      @click="handleAttachmentItemClick(item.id)" rounded="8">
                      <template v-slot:prepend>
                        <v-icon :color="selectedColor" size="18">
                          {{ item.icon }}
                        </v-icon>
                      </template>
                      <v-list-item-title class="attachment-item-text">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </div>
          <span class="limit-input-text" style="font-size: 10px; color: #71717a">
            {{ messageData.length }} / {{ maximumChatInput }}
          </span>
          <span class="disclaimer-text">
            {{ fullstreamDisclaimerText }}
          </span>

          <!-- Right Action Buttons -->
          <div class="input-actions-right">
            <!-- ปุ่ม๝สดงสินค้า๝นะนำ -->
            <v-btn v-show="products && products.length > 0" icon style="
                scale: 0.9;
                margin-top: -10px;
                font-size: 20px;
                margin-right: 20px;
                width: 21px;
                height: 18px;
                background-color: transparent;
                box-shadow: none;
              " :style="'color:' + selectedColor + '; cursor: pointer;'" v-on:click="hideProducts = !hideProducts" @keydown.enter.prevent="hideProducts = !hideProducts">
              <v-badge :content="products.length" :value="showProductBadge" color="red" overlap>
                <v-icon>mdi-shopping</v-icon>
              </v-badge>
            </v-btn>

            <!-- Voice Controls -->
            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              !(
                listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process ==
                'VoiceStart'
              )
              " icon size="40" class="input-action-btn" variant="text" :style="{ '--fullstream-action-color': fullstreamChatAccentColor }" :disabled="listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process != 'END' &&
                listMessage[listMessage.length - 1].status_Process != 'Stop' &&
                listMessage[listMessage.length - 1].status_Process != 'Error'
                " @click="click_account_voice">
              <Icon icon="lucide:mic" class="fullstream-input-icon" :style="{ color: fullstreamChatAccentColor }" />
            </v-btn>

            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              listMessage.length > 0 &&
              listMessage[listMessage.length - 1].status_Process ==
              'VoiceStart'
              " icon size="40" class="input-action-btn" variant="text" @click="
                TypeInputAudio = 'M';
              Click_StopVoice();
              ">
              <Icon icon="lucide:circle-stop" class="fullstream-input-icon fullstream-input-icon--error" />
            </v-btn>
            <!-- Upload File Audio Button (ปุ่มใหม่) -->
            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              !(
                messageData.trim().length > 0 ||
                fileDataUrl != null ||
                pickedFileType != null
              )
              " icon size="40" class="input-action-btn" variant="text" :style="{ '--fullstream-action-color': fullstreamChatAccentColor }" :disabled="listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process != 'END' &&
                listMessage[listMessage.length - 1].status_Process != 'Stop' &&
                listMessage[listMessage.length - 1].status_Process != 'Error'
                " @click="click_music_box()">
              <Icon icon="lucide:file-audio" class="fullstream-input-icon" :style="{ color: fullstreamChatAccentColor }" />
            </v-btn>

            <!-- Send Button -->
            <v-btn class="send-button-chatgpt themed-send-button" icon size="32" :style="{ '--send-color': fullstreamChatAccentColor }" v-show="messageData.trim().length > 0 ||
              fileDataUrl != null ||
              pickedFileType != null
              " @click="SendOpenAi('Click')" @keydown.enter.prevent="SendOpenAi('Click')" :disabled="isSendMessageDisabled" elevation="0">
              <v-icon :color="fullstreamChatContrastColor" size="16">mdi-arrow-up</v-icon>
            </v-btn>
            
            <!-- ปุ่ม Stop -->
            <v-btn 
              class="send-button-chatgpt stop-button-variant" 
              icon 
              size="32" 
              :style="{ '--send-color': fullstreamChatAccentColor }"
              v-on:click="StopMessage" 
              v-show="listMessage.length > 0 ?
                listMessage[listMessage.length - 1].status_Process == 'Process' ||
                listMessage[listMessage.length - 1].status_Process == 'Send_Message' ||
                listMessage[listMessage.length - 1].status_Process == 'VoiceStart' : false" 
              :disabled="(listMessage.length > 0 && (
                listMessage[listMessage.length - 1].status_Process == 'Stop' ||
                listMessage[listMessage.length - 1].status_Process == 'END' ||
                listMessage[listMessage.length - 1].status_Process == 'Error'
              )) || (listMessage.length == 0)" @keydown.enter.prevent="StopMessage"
              elevation="0">
              <v-icon color="white" size="16">mdi-stop</v-icon>
            </v-btn>
            <!-- ปุ่ม Skip -->
            <v-btn 
              class="send-button-chatgpt skip-button-variant" 
              icon 
              size="32" 
              @keydown.enter.prevent="SkipTextRendering"
              @keydown.space.prevent="SkipTextRendering"
              v-on:click="SkipTextRendering" 
              v-show="(listMessage.length > 0 && messageRes.length > 0 &&
                      listMessage[listMessage.length - 1].status_Process == 'END'
                      && listMessage[listMessage.length - 1].messageBot != null) && 
                      (listMessage[listMessage.length - 1].messageBot.length < messageRes[messageRes.length - 1].length)" 
              elevation="0">
              <v-icon color="white" size="16">mdi-skip-next</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden Components (preserve functionality) -->
    <DragDropFile ref="imageDragDrop" v-show="false" style="display: none !important" :dialog="true" :DragDrop="false"
      :ShowListFile="false" :IconBtn="true" :allowType="['image/jpeg', 'image/png', 'image/svg+xml']"
      @filesUploaded="processUploadImage($event)" />
    <DragDropFile ref="fileDragDrop" v-show="false" style="display: none !important" :dialog="true" :DragDrop="false"
      :ShowListFile="false" :IconBtn="true" :allowType="[
        'text/csv',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ]" @filesUploaded="processUploadFile($event)" />
    <input id="inputFileVoid" type="file" aria-label="Upload audio file" @change="Chang_InputFileVoid" style="visibility: hidden; display: contents"
      accept="audio/wav,audio/mpeg,audio/x-m4a" />
  </div>

  <!-- Error states -->
  <div v-else-if="Status_Error == null" class="error-container">
    {{ Text_Status }}
  </div>

  <div v-else class="access-denied-container">
    <h1 style="
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;
      ">
      Access Denied
    </h1>
  </div>

  <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="500px" class="modern-dialog">
    <v-card class="upload-dialog-card" elevation="24">
      <!-- Header Section -->
      <div class="dialog-header">
        <div class="header-icon">
          <Icon v-if="TypeInputAudio == 'F'" icon="lucide:file-audio" class="dialog-header-icon" />
          <Icon v-else icon="lucide:mic" class="dialog-header-icon" />
        </div>
        <div class="header-content">
          <h3 v-if="TypeInputAudio == 'F'" class="dialog-title">
            {{ $t("StreamPopupFileHeader") }}
          </h3>
          <h3 v-else class="dialog-title">
            {{ $t("StreamPopupVoiceHeader") }}
          </h3>
          <p class="dialog-subtitle">{{ $t("StreamPopuplang") }}</p>
        </div>
      </div>

      <!-- Content Section -->
      <v-card-text class="dialog-content">
        <v-container fluid class="pa-0">
          <v-form ref="form" lazy-validation>
            <div class="form-group">
              <label class="form-label" for="fullstream-upload-language">{{ $t("StreamPopuplang") }}</label>
              <v-autocomplete id="fullstream-upload-language" :items="DDGPTModel" item-title="name" item-value="value" v-model="LangPop"
                variant="outlined" density="comfortable" class="language-selector" :placeholder="$t('StreamPopuplang')"
                hide-details>
                <template v-slot:prepend-inner>
                  <v-icon size="20" color="primary">mdi-translate</v-icon>
                </template>
              </v-autocomplete>
            </div>
          </v-form>
        </v-container>
      </v-card-text>

      <!-- Actions Section -->
      <v-card-actions class="dialog-actions">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" color="grey" class="action-btn secondary-btn" @click="Uploaddialog = false">
          <v-icon left size="18">mdi-close</v-icon>
          {{ $t("close") }}
        </v-btn>

        <v-btn v-if="TypeInputAudio == 'M'" color="primary" class="action-btn primary-btn" @click="
          Click_StartVoice();
        Uploaddialog = false;
        ">
          <v-icon left size="18">mdi-record</v-icon>
          {{ $t("StreamPopupRecord") }}
        </v-btn>

        <v-btn v-else color="primary" class="action-btn primary-btn" @click="
          Click_FileButtonVoid();
        Uploaddialog = false;
        ">
          <v-icon left size="18">mdi-upload</v-icon>
          {{ "Upload" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showImage" max-width="1000">
    <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
      <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
    </v-card>
    <div style="
        position: fixed;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        gap: 8px;
        z-index: 1000;
        opacity: 0;
        animation: fadeUp 0.3s ease forwards 0.3s;
      ">
      <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
        <v-icon color="white">mdi-download</v-icon>
      </div>
      <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="closeImage">
        <v-icon color="white">mdi-close</v-icon>
      </div>
    </div>
  </v-dialog>

  <!-- Private Memory -->

  <v-dialog ref="form" v-model="PrivateMemoryDialog_ListFile" persistent max-width="1050px" scrollable>
    <v-card>
      <v-card-title>
        <v-row style="padding-top: 5px">
          <v-col cols="12" sm="6" md="6" style="text-align: start; padding-left: 22px">
            <p class="headline" style="color: #1d4f81; margin-bottom: 0px">
              {{ $t("StreamUploadPrivateMemory") }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6" style="text-align: end; padding-right: 22px; padding-top: 0px"
            class="btn_PrivateMemoryDialog_ListFile">
            <v-row>
              <v-col cols="6" sm="6" md="6" style="padding-left: 0px">
                <v-btn class="primary white--text mt-3" style="margin-left: 0em"
                  @click="OpenPopup_Private_Memory(null)">
                  <v-icon size="20" style="padding-right: 5px">
                    mdi-upload
                  </v-icon>
                  Upload
                </v-btn>
              </v-col>
              <v-col cols="6" sm="6" md="6" style="padding-left: 0px">
                <v-btn class="white--text mt-3" style="background: #faa91b"
                  @click="PrivateMemoryDialog_ListFile = false">
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text id="PrivateMemory_ListFile">
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-data-table class="v_data_table_Private_Memory" :items-per-page="itemsPerPage_ListFilePM"
              :server-items-length="searchTotalTable_ListFilePM" v-model:options="options_ListFilePM"
              :items="dataTable_ListFilePM" :headers="headers_ListFilePM" :loading="loadingTable_ListFilePM"
              loading-text="Loading...">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="width: 90px; text-align: center">
                    {{ item.number }}
                  </td>
                  <td>
                    {{ item.fileName }}
                  </td>
                  <td>
                    <v-menu location="bottom">
                      <template v-slot:activator="{ on: menu }">
                        <v-btn icon v-on="{ ...menu }">
                          <v-icon size="22">mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="Version(item.fileId)">
                          <v-list-item-title>
                            {{ $t("gpt_model_management_version_history") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="OpenPopup_Private_Memory(item)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="edit" :src="images.edit" v-bind="attrs" v-on="on" />
                        </template>
                        <span>edit</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn icon @click="Delete_ListFilePM_ById_FullStream(item.fileId)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="delete" :src="images.delete" v-bind="attrs" v-on="on" />
                        </template>
                        <span>delete</span>
                      </v-tooltip>
                    </v-btn>
                    <v-switch style="
                        display: inline-block;
                        padding-left: 0.5em;
                        padding-top: 0;
                      " @change="PrivateVectorOnOffByFileID(item)" v-model="item.isActive" inset></v-switch>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="PrivateMemoryDialog" persistent max-width="1200px" scrollable>
    <v-card>
      <v-card-title>
        <!-- {{ requestVector }} //  -->
        <p class="headline" style="color: #1d4f81">
          {{ $t("StreamPrivateMemory") }}
          {{
            requestVector.fileId == null || requestVector.fileId == -1
              ? $t("StreamPrivateMemoryAdd")
              : $t("StreamPrivateMemoryEdit")
          }}
        </p>
      </v-card-title>
      <v-card-text id="PrivateMemory">
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <!--Document Name-->
              <v-col cols="12" sm="12" md="2">
                <v-text-field @keypress="handleKeypress" :label="$t('StreamFileNamePrivateMemory')"
                  :rules="[checkValidate()]" :disabled="actionEdit" v-model="requestVector.searchVectorDBName2" outlined
                  dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoVectorDatabaseName") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <!--Text Replacement-->
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete :label="'Text Replacement'" :items="DDGroupReplace" item-text="name" item-value="id"
                  multiple chips deletable-chips clearable outlined dense v-model="tempgroupReplaceID">
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoGroupReplaceText") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <!--Process type-->
              <v-col cols="12" sm="12" md="2">
                <v-select :label="$t('process_type')" :items="modeType" item-text="name" item-value="value" outlined
                  v-model="requestVector.deleteAll" dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoProcess_type") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Custom Max Character-->
              <v-col cols="12" sm="12" md="2">
                <v-text-field :rules="[rules.required]" @keypress="numericKey" :label="$t('_InfoCustomMaxCharacter')"
                  v-model="requestVector.MaxLimitedCharacter" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoCustomMaxCharacter") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <!--DetectLanguage-->
              <v-col cols="12" sm="12" md="3">
                <v-switch id="fullstream-detect-language" v-model="requestVector.DetectLanguage" inset :label="`DetectLanguage : ${requestVector.DetectLanguage ? 'auto' : 'not auto'
                  }`">
                  <template v-slot:label>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <label for="fullstream-detect-language" v-bind="attrs" v-on="on">
                          {{
                            `DetectLanguage : ${requestVector.DetectLanguage ? "auto" : "not auto"
                            }`
                          }}
                        </label>
                      </template>
                      <span>{{ $t("_InfoDetectLanguage") }}</span>
                    </v-tooltip>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row style="margin-top: -1rem">
              <!--Doctype-->
              <v-col cols="12" sm="12" md="2">
                <v-select :rules="[rules.required]" :label="$t('doctype')" :items="datadoctype" item-text="name"
                  item-value="value" v-model="doctype" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoDoctype") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Vectortype-->
              <v-col cols="12" sm="12" md="2">
                <v-select :rules="[rules.required]" :label="$t('vectortype')" :items="filterdatavectortype"
                  item-text="name" item-value="value" v-model="vectortype" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoVectortype") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Type-->
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete :label="$t('type')" :items="filterDDType" item-text="name" item-value="value" clearable
                  outlined dense :rules="[rules.required]" v-model="requestVector.modelType">
                  <template v-slot:item="data">
                    <template v-if="data.item !== 'object'">
                      <v-list-item-content>{{ data.item }}</v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-list-item-icon v-on="on">
                            <v-icon>mdi-information</v-icon>
                          </v-list-item-icon>
                        </template>
                        <span>
                          <img :src="data.item.image" alt="tooltip-preview" width="300" />
                        </span>
                      </v-tooltip>
                    </template>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfofillterModelType") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="2" v-show="requestVector.modelType == 3">
                <v-text-field :label="'Custom Character'" v-model="requestVector.customCharacter" outlined
                  :rules="[checkCustomCharacterValidate()]">
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        ADD คือฝระบวนฝารเพิ่มข้อมูลลง Vector, Raplace
                        คือฝระบวนฝาร๝ฝ้ไขคำตอบ
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-row justify="end">
                <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end">
                  <v-btn class="primary white--text mt-3" style="margin-left: 1rem" @click="TemplateVectorDialog()">
                    Template
                  </v-btn>
                  <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :accept="accept" :allowType="[]"
                    @filesUploaded="processUpload($event)" />
                </v-col>
              </v-row>>
            </v-row>
            <v-row style="margin-top: -1rem">
              <v-col cols="12" sm="12" md="4">
                <v-text-field :label="'text_org'" v-model="searchtext_org"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="1">
                <v-btn fab class="primary white--text mt-3" @click="Search()">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-row justify="end">
                <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end">
                  <v-btn class="white--text mt-3" style="
                      margin-left: 1rem;
                      border-radius: 25.342px;
                      background: #9747ff;
                      width: 100px;
                    " @click="ReProcess()">
                    REPROCESS
                  </v-btn>
                  <v-btn class="white--text mt-3" style="
                      margin-left: 1rem;
                      border-radius: 25.342px;
                      background: #139fd7;
                    " @click="ReFresh()">
                    {{ dataUpdate }} of {{ dataAll }}
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-btn class="primary white--text mt-3" style="margin-left: 1rem" @click="AddVectorperChunk()">
                    <v-icon size="20" style="padding-right: 5px">
                      mdi-plus-circle-outline
                    </v-icon>
                    {{ $t("add") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-row>
              <v-col cols="12" style="display: inline-flex; justify-content: right">
                <v-checkbox v-model="checkBoxShowAllText" :label="`${$t('_ShowAllText')}: ${checkBoxShowAllText
                  ? $t('_ShowAllTextOn')
                  : $t('_ShowAllTextOff')
                  }`"></v-checkbox>
              </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="2" style="display: inline-flex; justify-content: end"></v-col>

            <!-- {{ showTable }} -->
            <v-data-table v-show="showTable == true" :items-per-page="itemsPerPage"
              :server-items-length="searchTotalTable" v-model:options="options" :items="dataTable" :headers="headers"
              :loading="loadingTable" loading-text="Loading..." fixed-header mobile-breakpoint="300"
              class="elevation-1 responsive-table">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    {{ item.number }}
                  </td>
                  <td>
                    <div class="text-container">
                      <span :class="[
                        item.show ? 'text-content-show' : 'text-content',
                      ]" v-html="formatText(item.textORG)"></span>
                    </div>
                  </td>
                  <td>
                    <div class="text-container">
                      <span :class="[
                        item.show ? 'text-content-show' : 'text-content',
                      ]" v-html="formatText(item.textEN)"></span>
                      <v-btn icon rounded @click="item.show = !item.show">
                        <v-icon style="color: black">
                          {{
                            item.show ? "mdi-chevron-up" : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="EditVectorperChunk(item)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="edit" :src="images.edit" v-bind="attrs" v-on="on" />
                        </template>
                        <span>edit</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn icon @click="DeleteById(item.id)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="delete" :src="images.delete" v-bind="attrs" v-on="on" />
                        </template>
                        <span>delete</span>
                      </v-tooltip>
                    </v-btn>
                    <v-switch style="
                        display: inline-block;
                        padding-left: 0.5em;
                        padding-top: 0;
                      " @change="VectorOnOff(item)" v-model="item.activeFlag" inset></v-switch>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-banner>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="error" style="margin-right: 3em; margin-top: 1em"
                      @click="DeleteByName(KeyTopic)" v-if="showTable == true" :disabled="searchTotalTable == 0">
                      {{ $t("deleteAll") }}
                    </v-btn>
                    <v-btn class="white--text mt-3" v-if="showTable == true" style="
                        margin-left: 1em;
                        border-radius: 25.342px;
                        background: #faa91b;
                        width: 120px;
                      " @click="SaveFileName_PrivateMemoryFullStream">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-banner>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="EditVector" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Edit Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea :label="'text_org'" outlined counter auto-grow rows="15" v-model="Edit.textORG"
                  required></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeUploaddialog">
          {{ $t("close") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="SaveEdit()">
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="AddVector" max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Add Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea :label="'text_org'" outlined counter auto-grow rows="15" v-model="Add.textORG"
                  required></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeUploaddialogAdd">
          {{ $t("close") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="SaveAdd()">
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="TemplateVector" max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Template Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table class="v_data_table_Private_Memory" :items="dataTemplate" :headers="headersTemplate"
            loading-text="Loading..." hide-default-footer disable-sort>
            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 81px; text-align: center">
                  {{ item.modeType }}
                  <template v-if="item.modeType == 'CustomSplit'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information
                        </v-icon>
                      </template>
                      <span>
                        Template CustomSplit use "||!" Example SplitChunkContent
                      </span>
                    </v-tooltip>
                  </template>
                </td>
                <td style="text-align: center" v-if="
                  item.modeType != 'CustomSplit' && item.modeType != 'Article'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.CSV)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file</v-icon>
                      </template>
                      <span>{{ item.modeType }} - CSV</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'CustomSplit' && item.modeType != 'Article'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Excel)" v-if="
                    item.modeType != 'HeaderAllChunk' &&
                    item.modeType != 'HeaderFirstChunk'
                  ">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file-excel</v-icon>
                      </template>
                      <span>{{ item.modeType }} - Excel</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn icon @click="linkDownload(item.modeType, item.ExcelMultiColumn)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-excel-box
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - Excel (Multiple column)</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.PDF)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-pdf-box
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - PDF</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Word)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file-word</v-icon>
                      </template>
                      <span>{{ item.modeType }} - Word</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.PowerPoint)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-powerpoint
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - PowerPoint</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Text)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-document
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - Text</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="TemplateVector = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog_version" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">
          {{ $t("gpt_model_management_version_history") }}
        </p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table :items-per-page="itemsPerPage_version" :server-items-length="searchTotalTable_version"
            v-model:options="options_version" :items="menus_version" :headers="headers_version_history"
            :footer-props="{ 'items-per-page-options': [5] }">
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.version }}</td>
                <td style="text-align: center">{{ item.createDate }}</td>
                <td style="text-align: center">
                  <v-menu location="bottom">
                    <template v-slot:activator="{ on: menu }">
                      <v-btn icon v-on="{ ...menu }">
                        <v-icon size="22">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :key="item.id" @click="changeRestoreNewVersion(item.id, item.fileId)">
                        <v-list-item-title>Restore</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="
                        viewVersion(item.id, item.fileId, item.keytopic)
                        ">
                        <v-list-item-title>View</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
                <td style="text-align: center">{{ item.createBy }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog_version = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--dialog view private vector version-->
  <v-dialog v-model="dialog_view_private" width="80vw">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">
          {{ $t("gpt_model_management_version_history_detail") }}
        </p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table :items-per-page="itemsPerPage" :server-items-length="searchTotalTable_view_private"
            v-model:options="options_view_private" :items="view_private_version" :headers="header_view_private_version"
            class="elevation-1 responsive-table"></v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog_view_private = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Dialog สำหรับ๝สดงรายละเอียดสินค้า -->
  <v-dialog v-model="showDetailDialog" max-width="600px" >

    <v-card v-if="selectedProductDetail" class="product-card-header">
      <v-img v-if="selectedProductDetail.ProductImg" :src="selectedProductDetail.ProductImg" height="250px"
        :alt="selectedProductDetail.ProductName"></v-img>
      <img v-else class="product-default-image" height="250px" width="100%" src="../assets/images/product_default.png" :alt="selectedProductDetail.ProductName"></img>
      <v-card-title>{{ selectedProductDetail.ProductName }}</v-card-title>
      <v-card-text>
        <div class="text-h5 primary--text mb-4" color="primary">
          {{
            selectedProductDetail.ProductPrice
              ? `฿${selectedProductDetail.ProductPrice.toLocaleString()}`
              : "ติดต่อสอบถาม"
          }}
        </div>
        <div class="product-full-description">
          {{ selectedProductDetail.ProductDetail }}
        </div>
      </v-card-text>

      <v-card-actions class="product-card-actions">
        <v-spacer></v-spacer>
        <v-btn size="large" class="product-btn-actions"  color="#FB8C00" variant="outlined" @click="showDetailDialog = false">ปิด</v-btn>
        <v-btn
          size="large"
          class="product-btn-actions"
          variant="elevated"
          color="#FB8C00"
          @click="
            selectProduct(selectedProductDetail);
            showDetailDialog = false;
        ">
          สนใจสินค้านี้
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <div v-if="alertDialog" style="
      position: fixed;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
    " :class="{ 'fade-in': alertDialog, 'fade-out': !alertDialog }">
    <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
      The image is downloading...
    </v-alert>
  </div>

  <Loading :flagLoading="Loading_History_Status && startLoading == false" />
  <!-- Loading_History_Status -->

</template>

<script>
import { app, media } from "@microsoft/teams-js";
import { useDisplay } from "vuetify";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import Cookies from "js-cookie";
import DragDropFile from "@/components/DragDropFile.vue";
import Loading from "@/components/Loading.vue";
import MarkdownIt from "@/components/MarkedMarkdown.vue";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import { seedLineSsoSnippetStorage } from '@/utils/lineSsoHandoff';

// Import images for DDType
import Group11Svg from "@/assets/images/Group 11.svg";
import Group12Svg from "@/assets/images/Group 12.svg";
import Group13Svg from "@/assets/images/Group 13.svg";

import modelSVG from "@/assets/images/Model.svg";
import chatImagePreviewMixin from "@/mixins/chatImagePreviewMixin.js";
import vectorTypeWatchersMixin from "@/mixins/vectorTypeWatchersMixin.js";
import snippetIdentityPersistenceMixin from "@/mixins/snippetIdentityPersistenceMixin.js";
import { isInputTooLongError, parseServerCharLimit } from '@/utils/chatInputLimit';
export default {
  name: "FullStream",
  mixins: [chatImagePreviewMixin, vectorTypeWatchersMixin, snippetIdentityPersistenceMixin],
  provide() {
    return {
      ResetTextToImageFlagF: this.ResetTextToImageFlag
    };
  },
  inject: [
    "Click_History_List",
    "Status_Error",
    "Loading_History_Status",
    "User_Id_Show",
    "User_Id",
    "Log_History_TopicID",
    "TopicName",
    "TopicModelID",
    "KeyTopic",
    "isFeedback",
    "TopicModelID_long",
    "GetModelFirst_Value",
    "Flag_Click_History",
    "IsAllowImage",
    "miniVariant",
    "colorThemeChat",
    "FileUploadLimit",
    "NotificationTokenExpired",
    "Region",
    "SubscriptionKey",
    "IsChainMassage",
    "listTopic",
    "Log_History_ID",
    "Log_History_Take",
    "Time_Delay",
    // "maximumChatInput",
    "ModelFirst",
    "GetModelFirst",
    "flagShowTopic",
    "flagGetAllTopic",
    "StatusKeyRename",
    "auth_token",
    "Snippet_StatusData",
    "Snippet_Username",
    "NavbarBtnColorTheme",
    "NavbarTxtColorTheme",
    "FullstreamNavbarBtnColorTheme",
    "FullstreamNavbarTxtColorTheme",
    "FullstreamNavbarIconColorTheme",
    "FullstreamChatColorTheme",
    "isAllowLLMChange",
    "selectedLLMModelInChat",
    "setSelectedLLMModelInChat",
    "ChatbotName",
    "IconChat",
    "ChatbotIcon",
    "isImgIconChat",
    "FullstreamWelcomeTitle",
    "FullstreamWelcomeSubtitle",
    "FullstreamDisclaimerText"
  ],
  components: {
    // VueMarkdown,
    MarkdownIt,
    DragDropFile,
    Loading,
  },
  setup() {
    const { mobile, smAndDown, mdAndUp, xs } = useDisplay();

    return {
      mobile,
      smAndDown,
      mdAndUp,
      xsOnly: xs,
    };
  },
  watch: {
    ModelFirst: {
      handler(newVal) {
          this.CheckCurrentModelTextToImage();
      },
      immediate: true,
    },
    User_Id_Show: function () {
      if (this.Flag_Start) {
        this.User_Id_Show = this.User_Id_Show == null ? "" : this.User_Id_Show;
        this.User_Id = this.User_Id == null ? "" : this.User_Id;
        if (
          this.User_Id_Show != null &&
          this.User_Id_Show != "" &&
          this.User_Id_Show.replaceAll(" ", "") != ""
        ) {
          this.User_Id = this.User_Id_Show;
        } else if (
          this.User_Id_Show.replaceAll(" ", "") == "" &&
          this.User_Id.split("-").length == 6
        ) {
          console.log(
            "User_Id_Show : " +
            this.User_Id_Show +
            " ,User_Id-length : " +
            this.User_Id.split("-").length
          );
        } else {
          this.User_Id = this.GetUuidv4_Fun_User_Id_Null();
        }
      } else {
        /* intentionally empty */
      }
    },
    User_Id: function () {
      if (this.Flag_Start) {
        this.Log_History_TopicID = -1;
        this.TopicName = "";
        this.TopicModelID = "";
        this.KeyTopic = "";
        this.isFeedback = false;
        this.TopicModelID_long = -1;
        this.Chang_History();
        this.GetLogStreamStart_Flag = true;
        this.GetTopicFullStream("Start");

        this.GetModelFirst_Value(null, this.User_Id);
      } else {
        this.Flag_Start = true;
      }
    },
    Flag_Click_History: function () {
      // Save the topicID BEFORE clearing, so we can use it after
      const targetTopicID = this.Log_History_TopicID;

      this.Chang_History();

      if (targetTopicID == -1) {
        // New chat - reset everything
        this.Log_History_TopicID = -1;
        this.KeyTopic = null;
        this.TopicName = "";
        this.TopicModelID = "";
      } else {
        // Switching to an existing topic - keep the topicID for GetTopicFullStream
        this.GetTopicFullStream("ChangHistory");
      }
    },
    options_ListFilePM: {
      handler() {
        this.GetListFile_PrivateMemoryFullStream("");
      },
      deep: true,
    },
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
    options_view_private: {
      handler() {
        this.viewVersion(this.privateID, this.fileID, this.temKeytopic);
      },
      deep: true,
    },
    menuGroupModel: {
      handler() {
        this.$nextTick(() => {
          this.showMenu = !this.showMenu;
        });
      },
      deep: true,
    },
    ColorThemeChat(newVal) {
      this.selectedColor = this.normalizeThemeColor(newVal, "#FFA41E");
    },
    // "$root.miniVariant": function (val){
    //   console.log(self.widthNavDrawer)
    //   console.log(val)
    //   self.widthNavDrawer = val ? '256px' : '56px';
    // },
    // "$root.flagGetAllTopic": function () {
    //   var self = this;
    //   self.GetTopicFullStream("GetAllTopic");
    // },
    showMenu() {
      if (
        this.ModelQuick.some((i) => i.typeModel == 1) &&
        this.ModelQuick.some((i) => i.typeModel == 2) &&
        !this.menuGroupModel
      ) {
        this.showModelQuick = this.ModelQuick.filter(
          (item) => item.typeModel === 1
        );
      } else {
        this.showModelQuick = this.ModelQuick;
      }
    },
    selectedLLMModelInChat: {
      handler() {
        this.syncReasoningEffortSelection(true);
      },
      deep: true,
      immediate: true,
    },
    ModelQuick: {
      handler() {
        this.syncReasoningEffortSelection();
      },
      deep: true,
    },
    checkBoxShowAllText(newVal) {
      if (newVal) {
        this.ShowAll();
      } else {
        this.CloseShowAll();
      }
    },
    drawerWidth(newWidth) {
      document.documentElement.style.setProperty(
        "--drawer-width",
        `${newWidth}`
      );
    },
    products(newProducts) {
      if (newProducts && newProducts.length > 0) {
        // เมื่อมีสินค้าใหม่เข้ามา อาจมีฝาร๝จ้งเตือนหรือ๝สดง badge
        this.showProductBadge = true;
        this.hideProducts = false;
      }
    },
    messageData(newVal) {
      if (this.fileDataUrl == null) return;
      const text = newVal == null ? "" : String(newVal);
      const trimmed = text.trim();
      if (trimmed.length === 0) return;
      const lower = trimmed.toLowerCase();
      if (lower.startsWith(":model")) {
        this.ClearImage();
      }
    },
  },
  created() {
    document.documentElement.style.setProperty(
      "--drawer-width",
      `${this.widthNavDrawer}`
    );
  },
  computed: {
    isFileUploadPending() {
      return this.pickedFileType != null && this.uploadFileComplete == false; //NOSONAR
    },
    isSendMessageDisabled() {
      return (
        this.isFileUploadPending ||
        (this.listMessage.length > 0
          ? !(
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "Stop" ||
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "END" ||
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "Error"
          )
          : false)
      );
    },
    fileUploadProgressPercent() {
      const dataAll = Number(this.dataAll || 0);
      const dataUpdate = Number(this.dataUpdate || 0);
      if (dataAll <= 0) {
        return 0;
      }
      const percent = Math.round((dataUpdate / dataAll) * 100);
      return Math.min(100, Math.max(0, percent));
    },
    filteredModels() {
      return this.showModelQuick.filter(model => {
        // Search filter
        if (this.modelSearchQuery) {
          const normalizedQuery = this.modelSearchQuery.toLowerCase();
          const isMatchByName = model.modelName?.toLowerCase().includes(normalizedQuery);
          const isMatchById = model.modelDisplayID != null && String(model.modelDisplayID).includes(normalizedQuery);

          if (!isMatchByName && !isMatchById) {
            return false;
          }
        }
        
        return true;
      });
    },
            currentQuickModel() {
              const directTopicModelId = Number(this.unwrapInjectedValue(this.TopicModelID));
              const fallbackTopicModelId = Number.parseInt(String(this.unwrapInjectedValue(this.ModelFirst) || "").split(" ")[0], 10);
              const activeModelDisplayId = Number.isFinite(directTopicModelId) && directTopicModelId > 0
                ? directTopicModelId
                : fallbackTopicModelId;

              if (!Number.isFinite(activeModelDisplayId)) {
                return null;
              }

              return this.ModelQuick.find(
                (model) => Number(model.modelDisplayID) === activeModelDisplayId
              ) || null;
            },
            activeSelectedLLMModel() {
              return this.unwrapInjectedValue(this.selectedLLMModelInChat);
            },
            activeSelectedLLMId() {
              if (this.unwrapInjectedValue(this.isAllowLLMChange) !== true) {
                return null;
              }

              return this.getLLMModelId(this.activeSelectedLLMModel);
            },
            showReasoningEffortButton() {
              if (this.isTextToImageLocal) {
                return false;
              }

              if (this.activeSelectedLLMModel != null) {
                return this.activeSelectedLLMModel.useReasoningEffort === true;
              }

              return this.currentQuickModel?.useReasoningEffort === true;
            },
            currentReasoningEffortOption() {
              return this.getReasoningEffortOption(this.appliedReasoningEffort);
            },
            appliedReasoningEffortLabel() {
              return this.formatReasoningEffortLabel(this.appliedReasoningEffort);
            },
    attachItems() {
      if (!this.IsAllowImage) {
        return this.allAttachItems.filter((item) => item.id === "files");
      }
      return this.allAttachItems;
    },
    drawerWidth() {
      return this.miniVariant ? "256px" : "56px";
    },
    ColorThemeChat() {
      return this.FullstreamChatColorTheme || this.colorThemeChat;
    },
    fullstreamWelcomeTitleText() {
      return this.FullstreamWelcomeTitle || "Welcome to Chat Framework";
    },
    fullstreamWelcomeSubtitleText() {
      return this.FullstreamWelcomeSubtitle || "How can I help you today?";
    },
    fullstreamDisclaimerText() {
      return (
        this.FullstreamDisclaimerText ||
        "AI can make mistakes. Please double-check responses."
      );
    },
    fullstreamHeaderBackgroundColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarBtnColorTheme || this.NavbarBtnColorTheme, "#FFFFFF");
    },
    fullstreamHeaderIconColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarIconColorTheme || this.FullstreamNavbarTxtColorTheme || this.NavbarTxtColorTheme, "#FFFFFF");
    },
    fullstreamChatbotIconValue() {
      const value = this.unwrapInjectedValue(this.ChatbotIcon);
      return typeof value === 'string' ? value.trim() : '';
    },
    fullstreamChatbotImageUrl() {
      const value = this.unwrapInjectedValue(this.IconChat);
      return typeof value === 'string' ? value.trim() : '';
    },
    fullstreamIsImageIcon() {
      return this.unwrapInjectedValue(this.isImgIconChat) === true;
    },
    hasFullstreamChatbotIcon() {
      return this.fullstreamIsImageIcon
        ? this.fullstreamChatbotImageUrl !== ''
        : this.fullstreamChatbotIconValue !== '';
    },
    fullstreamHeaderTextColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarTxtColorTheme || this.NavbarTxtColorTheme, "#FFFFFF");
    },
    fullstreamUserFontColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarTxtColorTheme || this.NavbarTxtColorTheme, "#FFFFFF");
    },
    fullstreamHeaderAreaStyle() {
      return {
        backgroundColor: this.fullstreamHeaderBackgroundColor,
      };
    },
    fullstreamHeaderTextStyle() {
      return {
        color: this.fullstreamHeaderTextColor,
        display: "flex",
        alignItems: "center",
      };
    },
    fullstreamChatAccentColor() {
      return this.selectedColor || this.normalizeThemeColor(this.FullstreamChatColorTheme || this.colorThemeChat, "#FFA41E");
    },
    fullstreamChatContrastColor() {
      return this.getReadableTextColor(this.fullstreamChatAccentColor);
    },
    headers_ListFilePM() {
      return [
        { text: this.$t("no"), align: "center", sortable: false },
        {
          text: this.$t("StreamFileNamePrivateMemory"),
          value: "fileName",
          align: "center",
          sortable: true,
        },
        { text: " ", value: " ", align: "center", sortable: false },
        { text: this.$t("manage"), align: "center", sortable: false },
      ];
    },
    headers() {
      return [
        { text: this.$t("no"), align: "center", sortable: false },
        { text: "text_org", value: "TextORG", align: "center", sortable: true },
        { text: "text_en", value: "TextEN", align: "center", sortable: true },
        { text: this.$t("manage"), align: "center", sortable: false },
      ];
    },
    headersTemplate() {
      return [
        { text: "Type", align: "center", width: "25%" },
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
        { text: "PDF", align: "center" },
        { text: "Word", align: "center" },
        { text: "PowerPoint", align: "center" },
        { text: "Text", align: "center" },
      ];
    },
    headers_version_history() {
      return [
        { text: "Version", align: "center", sortable: false, width: "95px" },
        { text: "Modified", align: "center", sortable: false },
        { text: " ", align: "center", sortable: false },
        { text: "Modified By", align: "center", sortable: false },
      ];
    },
    header_view_private_version() {
      return [
        {
          text: this.$t("no"),
          value: "number",
          align: "center",
          justify: "center",
          sortable: false,
          width: "100px",
        },
        { text: "text_org", value: "textORG", align: "center", sortable: true },
        { text: "text_en", value: "textEN", align: "center", sortable: true },
      ];
    },
  },
  data: () => ({
    urlApi: import.meta.env.VITE_APP_API,
    isTextToImageLocal: false,
    modelSearchQuery: "",
    showScrollToBottomButton: false,
    rerenderKey: 0,
    showProductDialog: false,
    showProductBadge: true,
    hideProducts: false,
    showDetailDialog: false,
    selectedProductDetail: null,
    showImage: false,
    alertDialog: false,
    dialogImage: "",
    // User_Id_Old :"",
    TimeOutText_Run: null,
    // KeyTopic: null,

    Flag_Start: false,
    GetLogStreamStart_Flag: true,
    messageImage: "",
    LastScrollTop: null,

    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    //Timeout: 10000,
    // 7 s
    Timeout: 7000,
    // Timeout: 10000,
    SpeechRecognizer: null,

    TypeInputAudio: "",

    LangPop: "th-TH",
    DDGPTModel: [
      { name: "TH", value: "th-TH" },
      { name: "EN", value: "en-US" },
    ],
    Uploaddialog: false,
    UserPrincipalName: "",
    anchorAttrs: {
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    },
    allAttachItems: [
      { id: "images", title: "Images", icon: "mdi-image" },
      { id: "files", title: "Files", icon: "mdi-paperclip" },
    ],
    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    StopForChain: false,
    Axios_Controller: [],
    Axios_ControllerAduio: null,
    listMessage: [],
    messageData: "",
    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: [],
    Count_messageRes: [],
    StatusPro: false,
    messageRun: "",
    Text_Status: "",
    auth_token_local: "",
    parameterURL: [],
    groupModel: "",
    snippet_Status: false,
    username: "",
    ModelQuick: [],
    PrivateMemoryDialog_ListFile: false,
    PrivateMemoryDialog: false,
    PrivateMemory_Disabled_Name: true,
    Axios_VECTOR: null,
    sortBy: [],
    sortDesc: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    AddVector: false,
    flagNew: false,
    Add: {
      id: null,
      textORG: null,
    },
    totalTable: 0,
    loadingTable: false,
    showTable: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    dataTable: [],
    searchTotalTable: 0,
    itemsPerPage: 10,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    TemplateVector: false,
    tempgroupReplaceID: null,
    ImageURL: null,
    fileDataUrl: null,
    pickedFileType: null,
    pickedFileName: null,
    uploadFileComplete: false,
    hasVectorRefreshResponse: false,
    uploadedFileKeyTopic: null,
    isPrivateFileUploadActive: false,
    loadingImage: false,
    DDGroupReplace: [],
    DDType: [
      {
        name: "General",
        value: 1,
        image: Group11Svg,
      },
      {
        name: "MaxCharacter",
        value: 2,
        image: Group12Svg,
      },
      {
        name: "CustomSplit",
        value: 3,
        image: Group13Svg,
      },
      {
        name: "Article",
        value: 4,
        image: Group13Svg,
      },
      {
        name: "HeaderAllChunk",
        value: 5,
        image: Group11Svg,
      },
      {
        name: "HeaderFirstChunk",
        value: 6,
        image: Group12Svg,
      },
      {
        name: "WordImage",
        value: 7,
        image: Group12Svg,
      },
      {
        name: "PDFImage",
        value: 8,
        image: Group12Svg,
      },
    ],
    datadoctype: [
      { name: "CSV", value: 1 },
      { name: "Excel", value: 2 },
      { name: "PDF", value: 3 },
      { name: "Word", value: 4 },
      { name: "Text", value: 5 },
      { name: "PowerPoint", value: 6 },
    ],
    datavectortype: [
      { name: "General", value: 1 },
      { name: "Article", value: 2 },
      { name: "PriceList", value: 3 },
    ],
    dataTemplate: [
      {
        modeType: "General",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "MaxCharacter",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "CustomSplit",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "Article",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "HeaderAllChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "HeaderFirstChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
    ],
    rules: {
      required: (value) => !!value || "Required.",
      // required2 : this.vectornameDuplicate || 'dup'
    },
    MaxLimitedCharacter: null,
    doctype: null,
    vectortype: null,
    filterdatavectortype: [],
    filterDDType: [],
    accept: "",
    VectorDBNameDuplicate: "",
    searchtext_org: null,
    showAllText: false,
    checkBoxShowAllText: false,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      USER_CHANNEL: null,
      TopicID: null,
      // topVDB: null,
      topVDB: 3,
      // cosine: null,
      cosine: -1,
      // fileName: "",
      searchVectorDBName2: "",
      fileId: -1,
      MaxLimitedCharacter: null,
    },
    modeType: [
      {
        name: "Add",
        value: false,
      },
      {
        name: "Replace",
        value: true,
      },
    ],
    EditVector: false,
    Edit: {
      id: null,
      textORG: null,
    },
    requestUpload: {
      entity: null,
      USER_CHANNEL: null,
    },

    isSearch: false,

    products: [],
    productsSelect: [],
    totalTable_ListFilePM: 0,
    isSearch_ListFilePM: false,
    loadingTable_ListFilePM: false,
    sortBy_ListFilePM: [],
    sortDesc_ListFilePM: [],
    options_ListFilePM: {},
    dataTable_ListFilePM: [],
    searchTotalTable_ListFilePM: 0,
    itemsPerPage_ListFilePM: 10,
    selectedColor: "#FFA41E",
    menuGroupModel: false,
    showMenu: false,
    today: null,
    comment: false,
    moreComment: false,
    maximumChatInput: 200000,
    dialog_version: false,
    options_version: {},
    itemsPerPage_version: 5,
    menus_version: [],
    searchTotalTable_version: 0,
    totalTable_version: 0,
    fileID: null,
    loading: false,
    URL_Domain: "",
    modelDisplayID: "",
    userChanel: "",
    tokenParam: "",
    snipet_flag: false,
    sessionContinuity_flag: false, // toggle จาก param session-continuity — เปิด persist identity ข้าม refresh (เฉพาะ snippet)
    svgContent: null,
    SessionID: null,
    loadColor: false,
    showModelQuick: [],
    actionEdit: false,
    showReasoningEffortMenu: false,
    appliedReasoningEffort: "low",
    lastReasoningContextKey: null,
    reasoningEffortOptions: [
      {
        value: "low",
        label: "Low",
        meta: "Quick replies",
        icon: "mdi-lightning-bolt-outline",
        color: "#16a34a",
      },
      {
        value: "medium",
        label: "Medium",
        meta: "Balanced depth",
        icon: "mdi-tune-variant",
        //color: "#d97706",
        color: "#2563eb",
      },
      {
        value: "high",
        label: "High",
        meta: "Deeper thinking",
        icon: "mdi-head-cog-outline",
        //color: "#FF8C00",
        color: "#FF4500"
      },
    ],

    //dialog view private
    dialog_view_private: false,
    searchTotalTable_view_private: 0,
    totalTable_view_private: 0,
    options_view_private: { sortBy: [null], sortDesc: [null] },
    view_private_version: [],
    privateID: null,
    temKeytopic: null,
    role: {
      ID: null,
      Name: null,
    },
    isUseForMSTeam: false,
    flagTopHistory: false,
    widthNavDrawer: "56px",
    ShortcutMenu: [],

    showScrollButtons: false,
    showLeftButton: false,
    showRightButton: true,
    startLoading: false,
    msContext: null,
    isMsTeam: true,
    allLLMModel: [],
    activeProviderTab: 0,
    expandedPanel: 0,
    providers: [
      { id: 'azure', name: 'Azure', icon: 'mdi-microsoft' },
      { id: 'google', name: 'Google', icon: 'mdi-google' },
      { id: 'anthropic', name: 'Anthropic', icon: 'mdi-alpha-a-circle' },
      { id: 'others', name: 'Others', icon: 'mdi-dots-horizontal-circle' }
    ],
    showModelDropdown: false,
    personalInfoToken: null,
    comID: null,
  }),
  methods: {
    ResetTextToImageFlag() {
      this.isTextToImageLocal = false;
    },
    unwrapInjectedValue(value) {
      return value && typeof value === 'object' && Object.hasOwn(value, 'value')
        ? value.value
        : value;
    },
    getLLMModelId(model) {
      return model?.id ?? model?.ID ?? model?.Id ?? model?.iD ?? model?.modelDataID ?? model?.modelDataId ?? null;
    },
    updateSelectedLLMModelInChat(model = null) {
      const selectedModel = model;

      if (typeof this.setSelectedLLMModelInChat === 'function') {
        this.setSelectedLLMModelInChat(selectedModel);
        return;
      }

      if (this.selectedLLMModelInChat && typeof this.selectedLLMModelInChat === 'object' && Object.hasOwn(this.selectedLLMModelInChat, 'value')) {
        this.selectedLLMModelInChat.value = selectedModel;
        return;
      }

      this.selectedLLMModelInChat = selectedModel;
    },
    CheckCurrentModelTextToImage() {
      let tempID = null;
      try {
        tempID = Number.parseInt(this.ModelFirst.split(" ")[0], 10);
      } catch (e) {
        console.error(e);
        tempID = null;
      }
      try {
        if (tempID && this.ModelQuick.length > 0) {
          const currentModel = this.ModelQuick.find(model => 
            model.modelDisplayID === tempID
          );
          this.isTextToImageLocal = currentModel && currentModel.isTextToImage;
          let allowLLMChange = false;
          if (currentModel) {
            allowLLMChange = currentModel.isAllowLLMChange ? currentModel.isAllowLLMChange : false;
          }
          this.isAllowLLMChange = allowLLMChange;
        } else{
          this.isTextToImageLocal = false;
        }
      } catch (e) {
        console.error(e);
        this.isTextToImageLocal = false;
      }

      this.syncReasoningEffortSelection();
    },
    getReasoningEffortOption(reasoningEffort) {
      const normalizedReasoningEffort = this.normalizeReasoningEffort(reasoningEffort);
      return this.reasoningEffortOptions.find((option) => option.value === normalizedReasoningEffort) || this.reasoningEffortOptions[0];
    },
    getReasoningEffortToneStyle(reasoningEffort) {
      const option = this.getReasoningEffortOption(reasoningEffort);
      return {
        '--reasoning-tone-color': option?.color || '#64748b',
      };
    },
    getReasoningEffortContextKey() {
      if (this.activeSelectedLLMId != null) {
        return `llm:${this.activeSelectedLLMId}`;
      }

      if (this.currentQuickModel?.modelDisplayID != null) {
        return `model:${this.currentQuickModel.modelDisplayID}`;
      }

      return null;
    },
    syncReasoningEffortSelection(force = false) {
      const contextKey = this.getReasoningEffortContextKey();

      if (!this.showReasoningEffortButton) {
        this.lastReasoningContextKey = contextKey;
        this.appliedReasoningEffort = "low";
        this.showReasoningEffortMenu = false;
        return;
      }

      const defaultReasoningEffort =
        this.activeSelectedLLMModel?.reasoningEffort ||
        this.currentQuickModel?.reasoningEffort ||
        this.appliedReasoningEffort;

      if (force || this.lastReasoningContextKey !== contextKey) {
        this.appliedReasoningEffort = this.normalizeReasoningEffort(defaultReasoningEffort);
        this.lastReasoningContextKey = contextKey;
      } else {
        this.appliedReasoningEffort = this.normalizeReasoningEffort(this.appliedReasoningEffort);
      }
    },
    selectReasoningEffort(reasoningEffort) {
      if (!this.showReasoningEffortButton) {
        this.showReasoningEffortMenu = false;
        return;
      }

      this.appliedReasoningEffort = this.normalizeReasoningEffort(reasoningEffort);
      this.showReasoningEffortMenu = false;
    },
    getReasoningEffortPayload() {
      return this.showReasoningEffortButton
        ? this.normalizeReasoningEffort(this.appliedReasoningEffort)
        : null;
    },
    normalizeReasoningEffort(reasoningEffort) {
      const normalizedReasoningEffort = reasoningEffort?.toString().trim().toLowerCase();
      return ["low", "medium", "high"].includes(normalizedReasoningEffort)
        ? normalizedReasoningEffort
        : "low";
    },
    formatReasoningEffortLabel(reasoningEffort) {
      const normalizedReasoningEffort = this.normalizeReasoningEffort(reasoningEffort);
      return normalizedReasoningEffort.charAt(0).toUpperCase() + normalizedReasoningEffort.slice(1);
    },
    checkScrollPosition() {
      if (!this.$refs.MainScrollArea) return;
      if (
        this.$refs.MainScrollArea.scrollTop <= this.LastScrollTop &&
        this.$refs.MainScrollArea.scrollTop <= 0 &&
        this.Loading_History_Status == false && //NOSONAR
        this.flagTopHistory
      ) {
        if (this.listMessage.length > 0) {
          this.Log_History_ID = this.listMessage[0].id;
          this.GetHistoryFullStream("ScrollUp");
        }
      }
      const container = this.$refs.MainScrollArea;
      const scrollPosition = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // If we're not at the bottom (with a small buffer of 50px), show the button
      this.showScrollToBottomButton =
        scrollPosition < scrollHeight - clientHeight - 100;
    },
  handleMenuToggle() {
      this.showMenu = false;
      setTimeout(() => {
        this.showMenu = true;
      }, 50);
    },
    FilterShowModel(){
      if (this.ModelQuick.some(i => i.typeModel == 1) && this.ModelQuick.some(i => i.typeModel == 2) && !this.menuGroupModel) {
        this.showModelQuick = this.ModelQuick.filter(item => item.typeModel === 1);
      } else {
        this.showModelQuick = this.ModelQuick;
      }
    },
    isActiveModel(item) {
      return Number(this.TopicModelID) === Number(item.modelDisplayID);
    },
    applySelectedModelState(item) {
      const selectedModelId = Number(item?.modelID ?? item?.id);
      const selectedModelDisplayId = Number(item?.modelDisplayID);
      const selectedModelName = (item?.modelName ?? item?.name ?? '').trim();

      if (!Number.isFinite(selectedModelId) || !Number.isFinite(selectedModelDisplayId)) {
        return null;
      }

      const selectedModelLabel = selectedModelDisplayId + ' (' + selectedModelName + ')';

      this.TopicModelID = selectedModelDisplayId;
      this.TopicModelID_long = selectedModelId;
      this.ModelFirst = selectedModelLabel;
      this.updateSelectedLLMModelInChat(null);

      if (item?.timeDelay != null) {
        this.Time_Delay = item.timeDelay;
      }
      if (item?.isAllowImage != null) {
        this.IsAllowImage = item.isAllowImage;
      }
      if (item?.maximumChatInput != null) {
        this.maximumChatInput = item.maximumChatInput;
      }
      if (item?.isChainMassage != null) {
        this.IsChainMassage = item.isChainMassage;
      }
      if (item?.fileUploadLimit != null) {
        this.FileUploadLimit = item.fileUploadLimit;
      }
      this.isAllowLLMChange = item?.isAllowLLMChange === true;

      const currentTopic = this.listTopic?.find((topic) => topic.topicID === this.Log_History_TopicID)
        ?? (this.Log_History_TopicID === -1 && this.listTopic?.[0]?.topicID === -1 ? this.listTopic[0] : null);

      if (currentTopic) {
        currentTopic.topicModelID = selectedModelLabel;
        currentTopic.topicModelID_long = selectedModelId;
      }

      this.ClearImage();
      this.syncReasoningEffortSelection(true);
      return selectedModelLabel;
    },
    buildModelCommandReply(commandText) {
      const trimmedCommand = String(commandText ?? '').trim();
      if (!trimmedCommand.toLowerCase().startsWith(':model')) {
        return null;
      }

      const requestedModelDisplayId = Number(trimmedCommand.slice(6).trim());
      const availableModels = Array.isArray(this.ModelQuick) ? this.ModelQuick : [];
      const selectedModel = Number.isFinite(requestedModelDisplayId)
        ? availableModels.find((model) => Number(model.modelDisplayID) === requestedModelDisplayId)
        : null;

      if (selectedModel) {
        this.applySelectedModelState(selectedModel);
        return `Model Changed to < ${selectedModel.modelDisplayID}: ${selectedModel.modelName} >\r\n`;
      }

      let replyMessage = 'select model by using this command :model ID<br>';
      availableModels.forEach((model) => {
        replyMessage += `${model.modelDisplayID}: ${model.modelName}<br>`;
      });
      replyMessage += `--- ${(this.ModelFirst || 'Not Set').trim()}---\r\n`;
      return replyMessage;
    },
    selectModel(item) {
      this.applySelectedModelState(item);
      this.modelSearchQuery = "";
      this.showMenu = false;
    },
    showProductDetail(product) {
      this.selectedProductDetail = product;
      this.showDetailDialog = true;
    },

    selectProduct(product) {
      // ส่งคำถามเฝี่ยวฝับสินค้าที่เลือฝไปยัง chatbot
      this.messageData = `ฉันสนใจสินค้า: ${product.ProductName}`;
      this.productsSelect.push(product.ProductID);
      this.SendOpenAi("Click");

      // บันทึฝฝารเลือฝสินค้า
      this.logProductSelection(product);
    },

    logProductSelection(product) {
      this.showProductBadge = false;
    },
    handleAttachmentItemClick(itemId) {
      switch (itemId) {
        case "images":
          // Trigger the image DragDropFile component
          if (this.$refs.imageDragDrop) {
            this.$refs.imageDragDrop.$el
              .querySelector('input[type="file"]')
              ?.click();
          }
          break;
        case "files":
          // Trigger the file DragDropFile component
          if (this.$refs.fileDragDrop) {
            this.$refs.fileDragDrop.$el
              .querySelector('input[type="file"]')
              ?.click();
          }
          break;
        default:
          console.warn("Unknown attachment type:", itemId);
      }
    },
    createDefaultRequestVector(fileId = -1) {
      return {
        modelType: null,
        modelId: null,
        vectordbName: null,
        entity: null,
        deleteAll: false,
        groupReplaceID: null,
        customCharacter: null,
        DetectLanguage: true,
        USER_CHANNEL: null,
        TopicID: null,
        // topVDB: null,
        topVDB: 3,
        // cosine: null,
        cosine: -1,
        searchVectorDBName2: "",
        fileId: fileId,
        MaxLimitedCharacter: null,
      };
    },
    processUploadFile(files) {
      if (files.length === 0) {
        return;
      }
      let fileUploadSizeLimit = 4 * 1024 * 1024; // 4 MB
      if (files[0].size > fileUploadSizeLimit) {
        this.$swal.fire({
          icon: "error",
          title: `ไฟล์มีขนาดใหฝ่เฝิน 4 MB`,
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.isPrivateFileUploadActive = true;
      if (this.KeyTopic == null || this.KeyTopic == "") {
        this.KeyTopic = this.GetUuidv4_Fun();
      }
      this.requestVector = this.createDefaultRequestVector();
      this.actionEdit = true;
      this.searchtext_org = null;

      // Determine file type based on MIME type
      let documentType = 1; // Default to CSV
      const file = files[0];
      const mimeType = file.type;

      // Map MIME types to document types
      if (mimeType === "text/csv") {
        documentType = 1; // CSV
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        mimeType === "application/vnd.ms-excel"
      ) {
        documentType = 2; // Excel
      } else if (mimeType === "application/pdf") {
        documentType = 3; // PDF
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        mimeType === "application/msword"
      ) {
        documentType = 4; // Word
      } else if (mimeType === "text/plain") {
        documentType = 5; // Text
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        mimeType === "application/vnd.ms-powerpoint"
      ) {
        documentType = 6; // PowerPoint
      } else {
        documentType = 7; // Unknown
      }

      this.requestVector.MaxLimitedCharacter = 5500;
      this.requestVector.doctype = documentType;
      this.requestVector.vectortype = 1;
      this.requestVector.modelType = 1;

      this.files = files;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); //NOSONAR
      reader.onload = () => {
        const formDataDoc = new FormData();
        formDataDoc.append("entity", this.files[0]);
        this.uploadedFiles = this.files;
        this.requestVector.entity = formDataDoc;
        this.pickedFileName = this.files[0].name;
        this.pickedFileType = this.GetFileTypeImg(documentType);
        this.uploadFileComplete = false;
        this.hasVectorRefreshResponse = false;
        this.uploadedFileKeyTopic = this.KeyTopic;
        this.dataUpdate = 0;
        this.dataAll = 0;
        this.exceptionFlag = false;
        this.SaveFile();
      };
    },
    ClearUploadedFile() {
      this.pickedFileType = null;
      this.pickedFileName = null;
      this.requestVector.entity = null;
      this.uploadFileComplete = false;
      this.hasVectorRefreshResponse = false;
      this.uploadedFileKeyTopic = null;
      this.isPrivateFileUploadActive = false;
      this.uploadedFiles = [];
      this.files = [];
      this.dataAll = 0;
      this.dataUpdate = 0;
      this.fileID = -1;
    },
    normalizeSnippetFlag(value) {
      return value === true || String(value).toLowerCase() === 'true';
    },

    isQuotaWarning(msg) {
      return typeof msg === 'string' && (msg.startsWith('| QUOTA_WARNING |') || msg.startsWith('| QUOTA_WARN |'));
    },
    cleanQuotaMsg(msg) {
      if (typeof msg !== 'string') return msg;
      const withoutMarker = msg.replace(/^\| QUOTA_WARNING \|/, '').replace(/^\| QUOTA_WARN \|/, '').trim();
      const sections = withoutMarker
        .split(/\n\s*\n+/)
        .map((section) => section.split('\n').map((line) => line.trim()).filter((line) => line.length > 0).join('  \n'))
        .filter((section) => section.length > 0);
      return sections.join('\n\n');
    },
    getChatImageAuthToken() {
      return this.auth_token_local;
    },
    selectCard(text) {
      this.messageData = text;
    },
    confirmSwal(titleAlert, textAlert) {
      return this.$swal.fire({
        title: titleAlert,
        text: textAlert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        reverseButtons: false,
      });
    },
    PrivateVectorOnOffByFileID(item) {
      const titleAlert = item.isActive
        ? this.$t("confirmOn")
        : this.$t("confirmOff");
      const textAlert = item.isActive
        ? this.$t("confirmOnVectorName")
        : this.$t("confirmOffVectorName");
      this.confirmSwal(titleAlert, textAlert)
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              activeFlag: item.isActive,
            };
            this.dialog = true;
            try {
              this.$call.PrivateVectorOnOffByFileID_FullStream(
                temp,
                this.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  item.isActive = !item.isActive;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, "DeleteGroup");
            }
          } else {
            item.isActive = !item.isActive;
          }
        });
    },
    VectorOnOff(item) {
      const titleAlert = item.activeFlag
        ? this.$t("confirmOn")
        : this.$t("confirmOff");
      const textAlert = item.activeFlag
        ? this.$t("confirmOnVectorName")
        : this.$t("confirmOffVectorName");
      this.confirmSwal(titleAlert, textAlert)
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              id: item.id,
              activeFlag: item.activeFlag,
            };
            this.dialog = true;
            try {
              this.$call.PrivateVectorOnOff_FullStream(
                temp,
                this.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  item.activeFlag = !item.activeFlag;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, "DeleteGroup");
            }
          } else {
            item.activeFlag = !item.activeFlag;
          }
        });
    },
    async changeRestoreNewVersion(id, fileId) {
      this.loading = true;
      let req = {
        ID: id,
        fileId: fileId,
      };
      this.$call.SaveReStorePrivateVector_FullStream(
        req,
        this.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.GetListFile_PrivateMemoryFullStream(
              "OpenPopPrivateMemoryDialog_ListFile"
            );
          }
          this.dialog_version = false;
          this.loading = false;
          return null;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          this.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Version(fileId) {
      this.loading = true;
      this.fileID = fileId;

      if (!this.dialog_version) {
        this.options_version.page = 1;
      }

      this.dialog_version = true;

      const { page } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: 5,
        fileId: fileId,
      };

      this.$call.GetTablePrivateVectorVersion_FullStream(
        temp,
        this.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.menus_version = dataResponse.data.data;
            this.searchTotalTable_version = dataResponse.data.total;
            this.totalTable_version = dataResponse.data.total;
          } else {
            this.menus_version = [];
            this.searchTotalTable_version = 0;
            this.totalTable_version = 0;
          }
          this.loading = false;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async viewVersion(id, fileId, keytopic) {
      this.dialog_view_private = true;
      this.loading = true;
      this.privateID = id;
      this.fileID = fileId;
      this.temKeytopic = keytopic;

      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? null : itemsPerPage,
        id: id,
        FileId: fileId,
        name: keytopic,
        text_org: null,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      await this.$call.ReFreshPrivateVector_FullStream(
        temp,
        this.auth_token_local,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.view_private_version = dataResponse.data.table.data;
            this.searchTotalTable_view_private = dataResponse.data.table.total;
            this.totalTable_view_private = dataResponse.data.table.total;
          } else {
            this.view_private_version = [];
            this.searchTotalTable_view_private = 0;
            this.totalTable_view_private = 0;
          }
          this.isSearch = false;
          this.loading = false;
        },
        (errorResource) => {
          this.loading = true;
          this.dialog_view_private = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    OpenPopup_Private_Memory(item) {
      this.ClearValuePrivate_Memory();
      if (item == null) {
        this.requestVector = this.createDefaultRequestVector();
        this.requestVector.MaxLimitedCharacter = this.MaxLimitedCharacter;
        this.requestVector.modelType = null;
        this.dataTable = [];
        this.searchTotalTable = 0;
        this.totalTable = 0;
        this.actionEdit = false;
        this.loadingTable = false;
        this.isSearch = false;
        this.isFirst = false;
        this.showTable = true;
        this.searchtext_org = null;
      } else {
        this.requestVector = this.createDefaultRequestVector(item.fileId);
        this.requestVector.searchVectorDBName2 = item.fileName;
        this.actionEdit = true;
        this.searchtext_org = null;
        this.ReFresh();
        this.GetByVector();
      }
      this.PrivateMemoryDialog = true;
    },

    Click_Private_Memory() {
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process != "END" &&
        this.listMessage[this.listMessage.length - 1].status_Process !=
        "Stop" &&
        this.listMessage[this.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        if (this.KeyTopic == null) {
          this.KeyTopic = this.GetUuidv4_Fun();
        }

        this.GetListFile_PrivateMemoryFullStream(
          "OpenPopPrivateMemoryDialog_ListFile"
        );
      }
    },
    checkCustomCharacterValidate() {
      if (
        this.requestVector.modelType == 3 &&
        (this.requestVector.customCharacter == "" ||
          this.requestVector.customCharacter == null)
      ) {
        return "Required.";
      } else {
        this.customCharacter = null;
      }
      return true;
    },
    formatText(text) {
      // ๝ปลงช่องว่างเป็น &nbsp; เพื่อให้รัฝษาช่องว่างได้
      return text.replaceAll(" ", "&nbsp;");
    },
    TemplateVectorDialog() {
      this.TemplateVector = true;
    },
    linkDownload(modelType, filename) {
      let req = {
        modelType: modelType,
        filename: filename,
      };
      this.$call.DownloadTemplateVector_FullStream(
        req,
        this.auth_token_local,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${this.findTypeName(
              filename
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.TemplateVector = false;
        },
        (errorResource) => {
          this.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = "";
      switch (filename) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },
    setTypeFile(val) {
      switch (val) {
        case 1:
          this.accept = ".csv";
          break;
        case 2:
          this.accept =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case 3:
          this.accept = "application/pdf";
          break;
        case 4:
          this.accept =
            ".doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case 5:
          this.accept = "text/plain";
          break;
        case 6:
          this.accept =
            ".ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation";
          break;
        default:
          this.accept = "";
          break;
      }
    },
    GetDDGroupReplaceDB_FullStream() {
      this.dialog = true;
      this.$call.GetDDGroupReplaceDB_FullStream(
        this.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGroupReplace = dataResponse.data;
          } else {
            this.DDGroupReplace = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddVectorperChunk() {
      this.AddVector = true;
      this.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      this.EditVector = true;
      this.Edit.id = item.id;
      this.Edit.textORG = item.textORG;
    },
    SaveEdit() {
      if (!this.Edit.textORG) {
        alert("Please Fill All The Fields!");
        return;
      }
      let temp = {
        ID: this.Edit.id,
        Content: this.Edit.textORG,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
        groupReplaceID:
          this.tempgroupReplaceID == null
            ? null
            : JSON.stringify(this.tempgroupReplaceID),
        DetectLanguage: this.requestVector.DetectLanguage,
      };
      this.dialog = true;
      try {
        this.$call.SaveEditVector_FullStream(
          temp,
          this.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              this.GetByVector();
              this.closeUploaddialog();
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {

        console.error("catch : DeleteGroup", error);
      }
    },

    closeUploaddialog() {
      this.EditVector = false;
      this.Edit.id = null;
      this.Edit.textORG = null;
    },

    Delete_ListFilePM_ById_FullStream(id) {
      try {
        this.confirmSwal(
          this.$t("confirmDeletion"),
          this.$t("confirmDeletionVector")
        )
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.Delete_ListFilePM_ById_FullStream(
                id,
                this._auth_token,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetListFile_PrivateMemoryFullStream("");
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {

        console.error("catch : DeleteGroup", error);
      }
    },
    DeleteById(id) {
      try {
        this.confirmSwal(
          this.$t("confirmDeletion"),
          this.$t("confirmDeletionVector")
        )
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.DeleteVectorDBNameById_FullStream(
                id,
                this.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetByVector();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {

        console.error("catch : DeleteGroup", error);
      }
    },
    DeleteByName(name_data) {
      try {
        this.confirmSwal(
          this.$t("confirmDeletion"),
          this.$t("confirmDeletionVectorName")
        )
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;

              let DataName_FileId = {
                name: name_data,
                FileId: this.requestVector.fileId,
              };
              this.$call.DeleteVectorDBNameByName_FullStream(
                DataName_FileId,
                this.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.dataUpdate = 0;
                    this.dataAll = 0;
                    this.actionEdit = false;
                    this.requestVector.searchVectorDBName2 = null;
                    this.GetByVector();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {

        console.error("catch : DeleteGroup", error);
      }
    },
    onPaste(event) {
      if (!this.IsAllowImage) return;

      const item = event.clipboardData.items[0]; // เอาเฉพาะ index ๝รฝ

      if (item && item.type.startsWith("image")) {
        const file = item.getAsFile();

        const filesArray = [file];
        this.ValidateImage(filesArray);
        const reader = new FileReader();

        reader.onload = (e) => {
          this.fileDataUrl = e.target.result;
          this.ValidateImage(filesArray);
          this.UploadImage();
        };

        reader.readAsDataURL(file);
        event.preventDefault(); // ป้องฝันฝารวางค่าอื่น ๆ
      } else {
        console.log(this.products)
        console.log("Not an image or unsupported content");
      }
    },
    UploadImage() {
      if (!this.requestUpload.entity) {
        alert("Please Fill All The Fields!");
        return;
      }
      this.requestUpload.USER_CHANNEL = this.User_Id;
      this.loadingImage = true;
      try {
        this.$call.UploadImage_FullStream(
          this.requestUpload,
          this.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.ImageURL = dataResponse.data;
              this.requestUpload.entity = null;
              this.uploadedFiles = [];
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.$t("errorUploadImage"),
                showConfirmButton: false,
                timer: 2500,
              });
              this.ClearImage();
            }
            this.loadingImage = false;
          },
          (errorResource) => {
            this.$swal.fire({
              icon: "error",
              title: this.$t("errorUploadImage"),
              showConfirmButton: false,
              timer: 2500,
            });
            this.loadingImage = false;
            this.ImageURL = null;
            this.fileDataUrl = null;
            this.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.error(error);
        this.GetTopicFullStream("Start");
      }
    },
    ClearImage() {
      this.ImageURL = null;
      this.fileDataUrl = null;
      this.loadingImage = false;
      this.requestUpload.entity = null;
      this.uploadedFiles = [];
    },
    processUploadImage(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestUpload.entity = null;
        this.uploadedFiles = [];
        return;
      }
      if (
        this.FileUploadLimit != null &&
        this.FileUploadLimit != "" &&
        this.FileUploadLimit != undefined &&
        this.FileUploadLimit != 0
      ) {
        const maxSize = this.FileUploadLimit * 1024; // this.FileUploadLimit KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: "error",
            title: `ไฟล์มีขนาดใหฝ่เฝิน ${this.FileUploadLimit} KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      } else {
        const maxSize = 2048 * 1024; // 2048 KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: "error",
            title: `ไฟล์มีขนาดใหฝ่เฝิน 2048 KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      const file = e[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileDataUrl = e.target.result;
        this.ValidateImage(this.files);
        this.UploadImage();
      };
      reader.readAsDataURL(file);
    },
    ValidateImage(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.requestUpload.entity = formDataDoc;
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); //NOSONAR
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
        this.ConfirmProcess();
      };
    },
    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      this.$swal
        .fire({
          icon: "warning",
          title: this.$t("importPrivate_MemoryTitle"),
          // text: "คุณต้องฝารนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.Save();
          }
        });
    },
    validateVectorCommonFields() {
      if (
        this.requestVector.modelType == 3 &&
        !this.requestVector.customCharacter
      ) {
        alert("Please Fill All The Fields!");
        return false;
      }
      if (
        this.requestVector.MaxLimitedCharacter == null ||
        this.requestVector.MaxLimitedCharacter == "" ||
        this.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return false;
      }
      this.requestVector.searchVectorDBName2 =
        this.requestVector.searchVectorDBName2 == null
          ? ""
          : this.requestVector.searchVectorDBName2;
      return true;
    },
    Save() {
      if (
        !this.requestVector.modelType ||
        !this.KeyTopic ||
        !this.requestVector.entity ||
        !this.requestVector.topVDB
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (!this.validateVectorCommonFields()) {
        return;
      }
      if (
        this.requestVector.searchVectorDBName2 == "" ||
        this.requestVector.searchVectorDBName2.replaceAll(" ", "") == ""
      ) {
        if (this.uploadedFiles != null && this.uploadedFiles.length > 0) {
          const indexLast_Name_uploadedFiles =
            this.uploadedFiles[0].name.lastIndexOf(".");

          this.requestVector.searchVectorDBName2 =
            this.uploadedFiles[0].name.substring(
              0,
              indexLast_Name_uploadedFiles == -1
                ? this.uploadedFiles[0].name.length
                : indexLast_Name_uploadedFiles
            );
        }
      }

      this.requestVector.vectordbName = this.KeyTopic;

      this.requestVector.USER_CHANNEL = this.User_Id;
      this.requestVector.TopicID = this.Log_History_TopicID;

      this.dialog = true;
      try {
        this.requestVector.groupReplaceID =
          this.tempgroupReplaceID == null
            ? null
            : JSON.stringify(this.tempgroupReplaceID);
        this.$call.UploadCSV2Vector_FullStream(
          this.requestVector,
          this.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.KeyTopic = this.requestVector.vectordbName;
              this.requestVector.entity = null;
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;
              this.uploadedFiles = [];
              this.requestVector.fileId = dataResponse.data.fileId;
              this.GetByVector();
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.GetTopicFullStream("Start");
            // }
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.GetTopicFullStream("Start");

        console.error("catch : DeleteGroup", error);
      }
    },
    SaveFile() {
  this.isPrivateFileUploadActive = true;
  this.requestVector.modelType = 1;
  this.uploadFileComplete = false;
  this.hasVectorRefreshResponse = false;
  this.dataUpdate = 0;
  this.dataAll = 0;
  this.exceptionFlag = false;
  if (this.KeyTopic == null || this.KeyTopic == "") {
    this.KeyTopic = this.GetUuidv4_Fun();
  }
  this.uploadedFileKeyTopic = this.KeyTopic;
  if (
    this.requestVector.MaxLimitedCharacter == null ||
    this.requestVector.MaxLimitedCharacter == "" ||
    this.requestVector.MaxLimitedCharacter == undefined
  ) {
    alert("Please fill in the Custom Max Character");
    return;
  }
  this.requestVector.fileName = this.GetUuidv4_Fun();
  this.requestVector.searchVectorDBName2 = this.GetUuidv4_Fun();
  this.requestVector.vectordbName = this.uploadedFileKeyTopic;
  this.requestVector.USER_CHANNEL = this.User_Id;
  this.requestVector.TopicID = this.Log_History_TopicID;
  this.dialog = true;
  try {
    this.requestVector.groupReplaceID =
      this.tempgroupReplaceID == null
        ? null
        : JSON.stringify(this.tempgroupReplaceID);
    this.requestVector.fileId = -1;
    this.requestVector.deleteAll = false;
    this.$call.UploadCSV2Vector_FullStream(
      this.requestVector,
      this.auth_token_local,
      (dataResponse) => {
        if (dataResponse.status == 0) {
          this.KeyTopic = this.requestVector.vectordbName;
          this.requestVector.entity = null;
          this.showTable = true;
          this.actionEdit = true;
          this.flagNew = false;
          this.uploadedFiles = [];
          this.uploadedFileKeyTopic = this.requestVector.vectordbName;
          this.requestVector.fileId = dataResponse.data.fileId;
          this.GetByVector();
        }
        this.dialog = false;
      },
      (errorResource) => {
        this.isPrivateFileUploadActive = false;
        this.dialog = false;
        console.error(errorResource);
      }
    );
  } catch (error) {
    this.isPrivateFileUploadActive = false;
    console.error("catch : SaveFile", error);
  }
},
    ClearValuePrivate_Memory() {
      if (this.isPrivateFileUploadActive) {
        return;
      }
      this.showTable = false;

      this.requestVector.entity = null;
      this.requestVector.modelId = null;
      this.requestVector.searchVectorDBName2 = null;
      this.tempgroupReplaceID = null;
      this.doctype = null;
      this.vectortype = null;
      this.requestVector.vectordbName = null;
      this.requestVector.customCharacter = null;
      this.requestVector.modelType = null;
      this.requestVector.DetectLanguage = true;

      this.dataTable = [];
      this.searchTotalTable = 0;
      this.totalTable = 0;

      this.dataUpdate = 0;
      this.dataAll = 0;
      this.exceptionFlag = false;
      this.hasVectorRefreshResponse = false;

      this.loadingTable = false;
      this.isSearch = false;
      this.showTable = true;
      this.options = {
        page: 1,
        itemsPerPage: this.itemsPerPage,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      };
      this.sortBy = [];
      this.sortDesc = [];
      if (this.Axios_VECTOR != null) {
        this.Axios_VECTOR.abort();
      }
    },

    GetByVector() {
      this.$nextTick(() => {
        if (
          this.requestVector.fileId == null ||
          this.requestVector.fileId == -1 ||
          this.requestVector.fileId == ""
        ) {
          this.flagNew = true;
          return;
        }
        this.loadingTable = true;
        let { page, itemsPerPage, sortBy } = this.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }

        let temp = {
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
          name: this.KeyTopic,
          fileId: this.requestVector.fileId,
          sortDesc: sortOrder,
          sortBy: sortField,
        };

        this.Axios_VECTOR = new AbortController();

        let Config = {
          signal: this.Axios_VECTOR.signal,
        };

        this.$call.ReFreshVector_FullStream(
          temp,
          Config,
          this.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dataUpdate = dataResponse.data.dataUpdate;
              this.dataAll = dataResponse.data.dataAll;
              this.exceptionFlag = dataResponse.data.exceptionFlag;
              this.hasVectorRefreshResponse = true;
              this.searchTotalTable = dataResponse.data.table.total;
              this.dataTable = dataResponse.data.table.data;
              this.totalTable = dataResponse.data.table.total;
              this.tempgroupReplaceID = dataResponse.data.groupReplaceID;
              if (this.$route.query.name) {
                this.requestVector.customCharacter =
                  dataResponse.data.customCharacter;
                this.requestVector.modelType = dataResponse.data.modelType;
                this.requestVector.DetectLanguage =
                  dataResponse.data.detectLanguage;
                this.requestVector.MaxLimitedCharacter =
                  dataResponse.data.maxLimitedCharacter;
              }

              // }

              this.UpdateUploadFileCompleteStatus();
              this.AutoRefresh();
            } else {
              this.dataTable = [];
              this.searchTotalTable = 0;
              this.totalTable = 0;
              this.actionEdit = false;
            }
            this.loadingTable = false;
            this.isSearch = false;
            this.showTable = true;
            this.dataTable.forEach((element) => {
              element.show = this.showAllText;
            });
          },
          (errorResource) => {
            this.loadingTable = false;
            this.isSearch = false;
            console.error(errorResource);
          }
        );
      });
    },
    ReProcess() {
      if (
        this.requestVector.MaxLimitedCharacter == null ||
        this.requestVector.MaxLimitedCharacter == "" ||
        this.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      this.$swal
        .fire({
          icon: "warning",
          title: this.$t("vectorReprocess"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              let data = {
                VectordbName: this.KeyTopic,
                FileId: this.requestVector.fileId,
                MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
                groupReplaceID:
                  this.tempgroupReplaceID == null
                    ? null
                    : JSON.stringify(this.tempgroupReplaceID),
                DetectLanguage: this.requestVector.DetectLanguage,
              };
              this.$call.ReProcessedVector_FullStream(
                data,
                this.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetByVector();
                  }
                },
                (errorResource) => {
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              console.error("catch : ReProcess", error);
            }
          } else {
            return;
          }
        });
    },
    ReFresh() {
      try {
        if (this.KeyTopic != null && this.KeyTopic != "") {
          let { page, itemsPerPage } = this.options;
          this.sortBy =
            this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
          this.sortDesc =
            this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];
          let temp = {
            page: this.isSearch ? 1 : page,
            perPage: itemsPerPage == -1 ? null : itemsPerPage,
            name: this.KeyTopic,
            TopicID: this.Log_History_TopicID,
            fileId: this.requestVector.fileId,
            text_org: this.searchtext_org,
            sortDesc: this.sortDesc,
            sortBy: this.sortBy,
          };
          this.Axios_VECTOR = new AbortController();

          let Config = {
            signal: this.Axios_VECTOR.signal,
          };

          this.$call.ReFreshVector_FullStream(
            temp,
            Config,
            this.auth_token_local,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.dataUpdate = dataResponse.data.dataUpdate;
                this.dataAll = dataResponse.data.dataAll;
                this.exceptionFlag = dataResponse.data.exceptionFlag;
                this.hasVectorRefreshResponse = true;
                this.searchTotalTable = dataResponse.data.table.total;
                this.dataTable = dataResponse.data.table.data;
                this.totalTable = dataResponse.data.table.total;
                this.modelType = dataResponse.data.modelType;
                this.requestVector.MaxLimitedCharacter =
                  dataResponse.data.maxLimitedCharacter;
                this.UpdateUploadFileCompleteStatus();
              }
              this.totalTable = this.totalTable + 1;
              this.isSearch = false;
            },
            (errorResource) => {
              this.isSearch = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {

        console.error("catch : ReFresh", error);
      }
    },
    async AutoRefresh() {
      let death_waiting = true;
      do {
        if (this.KeyTopic != null && this.KeyTopic != "") {
          if (this.dataUpdate == this.dataAll || this.exceptionFlag)
            death_waiting = false;
          else this.ReFresh();
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    UpdateUploadFileCompleteStatus() {
      if (this.pickedFileType == null) {
        this.uploadFileComplete = false;
        return;
      }

      const hasProgress =
        this.dataUpdate !== null &&
        this.dataUpdate !== undefined &&
        this.dataAll !== null &&
        this.dataAll !== undefined;

      this.uploadFileComplete =
        this.hasVectorRefreshResponse &&
        hasProgress &&
        this.dataUpdate == this.dataAll &&
        !this.exceptionFlag;
    },
    closeUploaddialogAdd() {
      this.AddVector = false;
      this.Add.id = null;
      this.Add.textORG = null;
    },

    SaveAdd() {
      const resolvedModelType = this.modelType == null ? 1 : this.modelType;
      this.requestVector.modelType =
        this.requestVector.modelType == null || !this.requestVector.modelType
          ? resolvedModelType
          : this.requestVector.modelType;

      if (
        !this.Add.textORG ||
        !this.requestVector.modelType ||
        !this.requestVector.searchVectorDBName2
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (!this.validateVectorCommonFields()) {
        return;
      }
      if (
        this.requestVector.searchVectorDBName2 == "" ||
        this.requestVector.searchVectorDBName2.replaceAll(" ", "") == ""
      ) {
        this.requestVector.searchVectorDBName2 =
          this.Add.textORG == null ? "" : this.Add.textORG;
      }
      this.requestVector.vectordbName = this.KeyTopic;

      let temp = {
        vectordbName: this.requestVector.vectordbName,
        modelType: this.requestVector.modelType,
        detectLanguage: this.requestVector.DetectLanguage,
        groupReplaceID:
          this.tempgroupReplaceID == null
            ? null
            : JSON.stringify(this.tempgroupReplaceID),
        Content: this.Add.textORG,
        flagNew: this.flagNew,
        customCharacter: this.requestVector.customCharacter,
        USER_CHANNEL: this.User_Id,
        TopicID: this.Log_History_TopicID,
        topVDB: this.requestVector.topVDB,
        cosine: this.requestVector.cosine,
        fileId: this.requestVector.fileId,
        fileName: this.requestVector.searchVectorDBName2,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
      };
      this.dialog = true;

      try {
        this.$call.SaveAddVector_FullStream(
          temp,
          this.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.GetTopicFullStream("Start");
              this.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;
              this.GetByVector();
              this.closeUploaddialogAdd();

              this.requestVector.fileId = dataResponse.data.fileId;
            } else {
              this.GetTopicFullStream("Start");
              // }
              this.VectorDBNameDuplicate = this.KeyTopic;
              this.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.GetTopicFullStream("Start");
            // }
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.GetTopicFullStream("Start");
        console.error("catch : DeleteGroup", error);
      }
    },
    Search() {
      this.isSearch = true;
      this.options.page = 1;
      this.ReFresh();
    },
    ShowAll() {
      this.showAllText = !this.showAllText;
      this.dataTable.forEach((element) => {
        element.show = this.showAllText;
      });
    },
    CloseShowAll() {
      this.showAllText = !this.showAllText;
      this.dataTable.forEach((element) => {
        element.show = this.showAllText;
      });
    },
    checkValidate() {
      if (
        this.requestVector.searchVectorDBName2 == "" ||
        this.requestVector.searchVectorDBName2 == null
      ) {
        return "Required.";
      } else if (
        this.VectorDBNameDuplicate == this.requestVector.searchVectorDBName2
      ) {
        return "Duplicate.";
      }
      return true;
    },

    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (validCharactersRegex.test(String.fromCodePoint(charCode))) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    GetMaxLimitedCharacter() {
      this.dialog = true;
      this.$call.GetMaxLimitedCharacter_FullStream(
        this.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.MaxLimitedCharacter = dataResponse.data;
          } else {
            this.MaxLimitedCharacter = this.requestVector.MaxLimitedCharacter;
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    SaveCosine_TopVDB() {
      try {
        let _Data = {
          TopicName: "Private Memory",
          KeyTopic: this.KeyTopic,
          TopicID: this.Log_History_TopicID,
          topVDB: this.requestVector.topVDB,
          cosine: this.requestVector.cosine,
          USER_CHANNEL: this.User_Id,
        };

        this.$call.SaveCosine_TopVDBFullStream(
          _Data,
          this.auth_token_local,
          (Response) => {
            if (Response.status == 0 && Response.data != null) {
              this.GetTopicFullStream("Start");
            }
            this.PrivateMemoryDialog = false;
          },
          () => {
            console.log("catch");
            this.PrivateMemoryDialog = false;
          }
        );
      } catch {
        console.log("catch");
        this.PrivateMemoryDialog = false;
      }
    },
    SaveFileName_PrivateMemoryFullStream() {
      try {
        let _Data = {
          FileId: this.requestVector.fileId,
          USER_CHANNEL: this.User_Id,
          FileName: this.requestVector.searchVectorDBName2,
        };
        this.$call.SaveFileName_PrivateMemoryFullStream(
          _Data,
          this.auth_token_local,
          (Response) => {
            if (Response.status == 0 && Response.data != null) {
              this.GetListFile_PrivateMemoryFullStream("");
            }
            this.PrivateMemoryDialog = false;
          },
          () => {
            console.log("catch");
            this.PrivateMemoryDialog = false;
          }
        );
      } catch {
        console.log("catch");
        this.PrivateMemoryDialog = false;
      }
    },

    CloseFileName_PrivateMemory() {
      this.GetListFile_PrivateMemoryFullStream("");
      this.PrivateMemoryDialog = false;
    },

    GetListFile_PrivateMemoryFullStream(StatusText) {
      try {
        if (this.KeyTopic != null && this.KeyTopic != "") {
          let { page, itemsPerPage } = this.options_ListFilePM;
          let temp = {
            page: this.isSearch_ListFilePM ? 1 : page,
            perPage:
              itemsPerPage == -1 ? this.totalTable_ListFilePM : itemsPerPage,
            KeyTopic: this.KeyTopic,
            USER_CHANNEL: this.User_Id,
          };
          this.$call.GetListFile_PrivateMemoryFullStream(
            temp,
            this.auth_token_local,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.searchTotalTable_ListFilePM =
                  dataResponse.data.table.total;
                this.dataTable_ListFilePM = dataResponse.data.table.data;
                this.totalTable_ListFilePM = dataResponse.data.table.total;

                if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
                  this.PrivateMemoryDialog_ListFile = true;
                }
              } else {
                this.NotificationTokenExpired();
              }
            },
            (errorResource) => {
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
                this.PrivateMemoryDialog_ListFile = true;
              }
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
          this.PrivateMemoryDialog_ListFile = true;
        }
        console.log("catch : GetListFile_PrivateMemoryFullStream");
      }
    },

    click_account_voice() {
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process != "END" &&
        this.listMessage[this.listMessage.length - 1].status_Process !=
        "Stop" &&
        this.listMessage[this.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        this.TypeInputAudio = "M";
        this.Uploaddialog = true;
      }
    },

    click_music_box() {
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process != "END" &&
        this.listMessage[this.listMessage.length - 1].status_Process !=
        "Stop" &&
        this.listMessage[this.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        this.TypeInputAudio = "F";
        this.Uploaddialog = true;
      }
    },

    SetTimeout(time) {
      return setTimeout(() => {
        this.Click_StopVoice();
      }, time);
    },
    async checkMicrophonePermission() {
      try {
        // ตรวจสอบว่าเบราว์เซอร์รองรับ permissions API หรือไม่
        if (navigator.permissions) {
          const permission = await navigator.permissions.query({ name: 'microphone' });
          return permission.state === 'granted';
        }
        
        // หาฝไม่รองรับ permissions API ให้ลองเข้าถึงโดยตรง
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.log('Microphone permission denied or not available:', error);
        return false;
      }
    },

    async requestMicrophonePermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.log('Failed to get microphone permission:', error);
        return false;
      }
    },

    async Click_StartVoice() {

      // ตรวจสอบ permission ฝ่อนเริ่ม
      const hasPermission = await this.checkMicrophonePermission();
      if (!hasPermission) {
        const granted = await this.requestMicrophonePermission();
        if (!granted) {
          this.listMessage.push({
            messageUser: "พูด...",
            messageBot: "ไม่สามารถเข้าถึงไมโครโฟนได้ ฝรุณาอนุฝาตฝารใช้งานไมโครโฟน",
            status_Process: "END",
          });
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
          return;
        }
      }

      this.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(
        this.SubscriptionKey,
        this.Region
      );
      speechConfig.setProperty(
        _SpeechSDK.PropertyId[
        _SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs
        ],
        "1500"
      );
      speechConfig.setProperty(
        _SpeechSDK.PropertyId[
        _SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode
        ],
        "Continuous"
      );
      let autoDetectSourceLanguageConfig =
        _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([this.LangPop]);
      this.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(
        speechConfig,
        autoDetectSourceLanguageConfig,
        audioConfig
      );
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
      let _temp_text = "";
      let _temp_textOld = "";
      this.SpeechRecognizer.recognizing = (s, e) => {
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        if (this.listMessage.length > 0) {
          if (this.listMessage[this.listMessage.length - 1].messageBot == "-") {
            this.listMessage[this.listMessage.length - 1].messageBot = "*";
            this.listMessage[this.listMessage.length - 1].messageUser = "";
          }
          this.listMessage[this.listMessage.length - 1].messageUser =
            _temp_textOld + (_temp_textOld == "" ? "" : " ") + e.result.text;
        }
      };
      this.SpeechRecognizer.recognized = (s, e) => {
        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {
          if (this.listMessage.length > 0) {
            if (
              this.listMessage[this.listMessage.length - 1].messageBot == "-"
            ) {
              this.listMessage[this.listMessage.length - 1].messageBot = "*";
              this.listMessage[this.listMessage.length - 1].messageUser = "";
            }
            this.listMessage[this.listMessage.length - 1].messageUser =
              _temp_text + e.result.text;
            _temp_text += e.result.text;
            _temp_textOld =
              this.listMessage[this.listMessage.length - 1].messageUser;
          }
        } else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");
        } else {
          console.log("ss " + e.result.reason);
        }
      };
      this.SpeechRecognizer.canceled = (s, e) => {
        console.log("canceled.");
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
      };
      this.SpeechRecognizer.sessionStarted = (s, e) => {
        console.log("sessionStarted.");
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON());
        this.TimeOutStop = this.SetTimeout(this.TimeoutFirst);
      };
      this.SpeechRecognizer.sessionStopped = (s, e) => {
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (
          this.listMessage.length > 0 &&
          this.listMessage[this.listMessage.length - 1].messageBot == "*"
        ) {
          this.messageData =
            this.listMessage[this.listMessage.length - 1].messageUser;
          if (
            this.listMessage.length > 0 &&
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            this.listMessage.pop();
          }
          this.SendOpenAi("Click");
        } else if (this.listMessage.length > 0) {
          if (
            this.listMessage.length > 0 &&
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            this.listMessage.pop();
          }
        }
      };
      this.SpeechRecognizer.speechStartDetected = (s, e) => {
        console.log("(StartDetected) SessionId: " + e.sessionId);
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
        }
      };
      this.SpeechRecognizer.speechEndDetected = (s, e) => {
        console.log("(EndDetected) SessionId: " + e.sessionId);
        if (this.TimeOutStop != null) {
          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON());
        this.TimeOutStop = this.SetTimeout(this.Timeout);
      };
      this.SpeechRecognizer.startContinuousRecognitionAsync(
        (e) => { },
        (error) => {
          if (
            this.listMessage.length > 0 &&
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "VoiceStart" &&
            error ==
            "Error occurred during microphone initialization: NotAllowedError: Permission denied"
          ) {
            this.listMessage[this.listMessage.length - 1].status_Process =
              "END";
            this.listMessage[this.listMessage.length - 1].messageBot =
              "ไม่มีสิทธ์เข้าถึงไมค์";
          } else if (
            this.listMessage.length > 0 &&
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            this.listMessage[this.listMessage.length - 1].status_Process =
              "END";
            this.listMessage[this.listMessage.length - 1].messageBot =
              "เฝิดข้อผิดพลาด";
          } else {
            this.listMessage.push({
              messageUser: "พูด...",
              messageBot: "เฝิดข้อผิดพลาด",
              status_Process: "END",
            });
          }
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
        }
      );
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == "END" &&
        this.messageRes.length > 0
      ) {
        if (
          this.listMessage[this.listMessage.length - 1].messageBot.length <
          this.messageRes[this.messageRes.length - 1].length
        ) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.messageRun = "";
          this.listMessage[this.listMessage.length - 1].messageBot =
            this.messageRes[this.messageRes.length - 1];
          this.messageRes[this.messageRes.length - 1] = "";
        }
      }
      this.listMessage.push({
        messageUser: "พูด...",
        messageBot: "-",
        status_Process: "VoiceStart",
      });
    },
    Click_StopVoice() {
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {
        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
    },
    Convest_Speech_To_Text(Ob_DataFile) {
      let formData = new FormData();
      let OB_DF = Ob_DataFile;
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == "END" &&
        this.messageRes.length > 0
      ) {
        if (
          this.listMessage[this.listMessage.length - 1].messageBot.length <
          this.messageRes[this.messageRes.length - 1].length
        ) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.messageRun = "";
          this.listMessage[this.listMessage.length - 1].messageBot =
            this.messageRes[this.messageRes.length - 1];
          this.messageRes[this.messageRes.length - 1] = "";
        }
      }
      if (OB_DF.Status == false) { //NOSONAR
        this.listMessage.push({
          messageUser: "ไฟล์เสียง",
          messageBot: OB_DF.manualContent,
          status_Process: "END",
        });
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return;
      } else {
        this.listMessage.push({
          messageUser: "ไฟล์เสียง " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process",
        });
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      }
      this.Axios_ControllerAduio = new AbortController();
      let Config = {
        signal: this.Axios_ControllerAduio.signal,
      };
      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", this.LangPop);
      this.$call.GetConvest_Speech_To_Text(
        formData,
        Config,
        (response) => {
          if (response.status == 0 && response.data.status == true) { //NOSONAR
            this.listMessage.pop();
            if (response.data.data == "") {
              this.listMessage.push({
                messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
                messageBot: "",
                status_Process: "END",
              });
            } else {
              this.messageData = response.data.data;
              this.SendOpenAi("Click");
            }
          } else if (this.listMessage.length > 0) {
              this.listMessage[this.listMessage.length - 1].messageBot =
                response.data.textError;
              this.listMessage[this.listMessage.length - 1].status_Process =
                "END";
              this.removeBlinkingCursorAt(this.listMessage.length - 1);
          }
        },
        () => {
          if (this.listMessage.length > 0) {
            this.listMessage[this.listMessage.length - 1].messageBot =
              "๝ปลงไฟล์เสียงไม่ได้";
            this.listMessage[this.listMessage.length - 1].status_Process =
              "END";
            this.removeBlinkingCursorAt(this.listMessage.length - 1);
          }
        }
      );
    },
    Click_FileButtonVoid() {
      if (
        this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process != "END" &&
        this.listMessage[this.listMessage.length - 1].status_Process != "Stop"
      ) {
        return;
      }

      document.getElementById("inputFileVoid").click();
    },
    Chang_InputFileVoid(e) {
      const files = e.target.files;

      if (files[0] == undefined) {
        return;
      }
      if (
        files[0] !== undefined &&
        (files[0].type == "audio/wav" ||
          files[0].type == "audio/mpeg" ||
          files[0].type == "audio/x-m4a")
      ) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          let Output = {
            Status: true,
            NameFile: files[0].name,
            DataFile: files[0],
            manualContent: files[0].type,
          };
          document.getElementById("inputFileVoid").value = "";
          this.Convest_Speech_To_Text(Output);
        });
      } else {
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "รองรับไฟล์ MP3, WAV ๝ละ M4A เท่านั้น",
        };
        document.getElementById("inputFileVoid").value = "";

        this.Convest_Speech_To_Text(Output);
      }
    },

    GetUuidAll() {
      if (
        this.parameterURL.userid == null ||
        this.parameterURL.userid == undefined ||
        this.parameterURL.userid == ""
      ) {
        if (this.role.ID == "5") {
          this.GetMSTeam();
        }
        else {
          this.GetUuidv4();
          this.GetModelQuickGroupInModelGroup();
        }
        this.Flag_Start = false;
      } else {
        
          this.Flag_Start = true;
          this.User_Id = this.parameterURL.userid;
          this.User_Id_Show = this.parameterURL.userid;
          this.GetModelQuickGroupInModelGroup();
        
      }
    },

    GetUuidv4_BK() {
      if (
        this.User_Id == null ||
        this.User_Id == undefined ||
        this.User_Id == ""
      ) {
        let Uuid = "10000000-1000-4000-8000-100000000000".replace(
          /[018]/g,
          (c) =>
            (
              c ^
              (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
            ).toString(16)
        );
        this.User_Id = Uuid;
        this.User_Id_Show = Uuid;
      }
    },

    GetUuidv4() {
      if (
        this.User_Id == null ||
        this.User_Id == undefined ||
        this.User_Id == ""
      ) {
        let Uuid;
        if (this.ShouldPersistAnonUid()) {
          // ลำดับ 3-4: ใช้ anonymous GUID เดิมที่ persist ไว้ ถ้าไม่มีค่อย gen ใหม่แล้ว persist
          let persistedUid = this.GetPersistedAnonUid();
          Uuid = persistedUid == "" ? this.GetUuidv4_Fun() : persistedUid;
          this.SetPersistedAnonUid(Uuid);
        }
        else {
          Uuid = this.GetUuidv4_Fun();
        }
        this.User_Id = Uuid;
        this.User_Id_Show = Uuid;
        this.GetTopicFullStream("Start");
      }
    },

    // Anonymous GUID / host userId persistence methods moved byte-identical to
    // src/mixins/snippetIdentityPersistenceMixin.js (shared with Snippet.vue).

    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
      return Uuid;
    },

    GetUuidv4_Fun_User_Id_Null() {
      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(
        /[018]/g,
        (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16)
      );

      return Uuid;
    },
    async GetMSTeam() {
      const isInIframe = globalThis.self !== globalThis.top;

      const initMSTeams = async () => {
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('MS Teams timeout')), 5000);
        });

        const msTeamPromise = async () => {
          try {
            await app.initialize();
            this.msContext = await app.getContext();

            // ขอ permission สำหรับ microphone โดยตรวจสอบว่าอยู่ใน iframe หรือไม่
            if (isInIframe) {
              // หาฝอยู่ใน iframe ให้ส่งข้อความไปยัง parent window เพื่อขอ permission
              try {
                window.parent.postMessage({
                  type: 'REQUEST_MICROPHONE_PERMISSION'
                }, '*');
              } catch (e) {
                console.log('Cannot request permission from iframe:', e);
              }
            } else {
              try {
                await media.requestPermission();
              } catch (permissionError) {
                console.log('Permission request failed:', permissionError);
              }
            }

            this.isMsTeam = true;
            const context = this.msContext;
            const userPrincipalName = context.user.userPrincipalName;
            this.User_Id = userPrincipalName;
            this.User_Id_Show = userPrincipalName;
            this.isUseForMSTeam = true;
            this.GetModelQuickGroupInModelGroup();
            this.GetTopicFullStream("Start");
            return true;
          } catch (e) {
            console.error('MS Teams initialization failed:', e);
            this.isMsTeam = false;
            throw e;
          }
        };

        try {
        await Promise.race([msTeamPromise(), timeoutPromise]);
        } catch (error) {
          console.log('MS Teams initialization timeout or failed:', error.message);
          this.isMsTeam = false;
        }
      };

      // เรียฝใช้ MS Teams initialization พร้อม timeout
      await initMSTeams();

      // เพิ่ม fallback สำหรับฝรณีที่ไม่ใช่ MS Teams
      if (!this.isMsTeam) {
        if (this.role.ID === "5") {
          this.NotificationMSTeamOnly();
        } else {
          this.GetUuidv4();
          this.GetModelQuickGroupInModelGroup();
        }
      }
    },

    // GetMSTeam() {
    //   let self = this;
    //   try {
    //     app.initialize().then(function () {

    //       app.getContext().then(function (context) {
    //         let UserPrincipalName = context.user.userPrincipalName;
    //         self.$root.User_Id = UserPrincipalName;

    //         self.$root.User_Id_Show = UserPrincipalName;
    //         self.isUseForMSTeam = true;
    //         self.GetModelQuickGroupInModelGroup();
    //         self.GetTopicFullStream("Start");
    //       }).catch(function () {
    //         self.GetUuidv4();
    //         self.GetModelQuickGroupInModelGroup();
    //       });
    //     }).catch(function (ex) {
    //       console.log(ex);
    //       if (self.role.ID == "5") {
    //         self.NotificationMSTeamOnly();
    //       }
    //       else {
    //         self.GetUuidv4();
    //         self.GetModelQuickGroupInModelGroup();
    //       }
    //     });
    //   }
    //   catch {
    //     self.GetUuidv4();
    //     self.GetModelQuickGroupInModelGroup();
    //   }
    // },

    Shift_Enter_MessageData() {
      this.point = this.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = this.$refs.RefMessageData.$refs.input.selectionStart - 1;

      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (
          this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >=
          this.messageData.length
        ) {
          const height = this.$refs.RefMessageData.$refs.input.scrollHeight;
          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      });
    },
    Ctrl_Enter_MessageData() {
      this.point = this.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = this.$refs.RefMessageData.$refs.input.selectionStart - 1;
      if (this.messageData.length > 0) {
        this.messageData =
          this.messageData.slice(0, _point + 1) +
          "\n" +
          this.messageData.slice(_point + 1);
      } else {
        this.messageData += "\n";
      }
      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (
          this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >=
          this.messageData.length
        ) {
          const height = this.$refs.RefMessageData.$refs.input.scrollHeight;
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      });
    },
    getLastStreamMessageIndex() {
      return this.listMessage.length == 0 ? 0 : this.listMessage.length - 1;
    },
    getLastStreamResponseIndex() {
      return this.messageRes.length == 0 ? 0 : this.messageRes.length - 1;
    },
    isTerminalStreamStatus(indexMessage) {
      return this.listMessage.length > 0 &&
        (this.listMessage[indexMessage].status_Process == "Stop" ||
          this.listMessage[indexMessage].status_Process == "END" ||
          this.listMessage[indexMessage].status_Process == "Error");
    },
    removeBlinkingCursorAt(indexMessage) {
      if (this.listMessage.length == 0 || this.listMessage[indexMessage] == undefined || this.listMessage[indexMessage].messageBot == null) {
        return;
      }

      let messageBot = this.listMessage[indexMessage].messageBot;
      if (messageBot.length > 0 && messageBot.substring(messageBot.length - 47, messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
        this.listMessage[indexMessage].messageBot = messageBot.substring(0, messageBot.length - 47);
      }
    },
    stopActiveVoiceAndUploads() {
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }

      if (this.SpeechRecognizer != null) {
        this.listMessage.pop();
        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }

      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
    },
    abortChatRequestAt(indexMessage) {
      if (this.Axios_Controller.length != 0 && this.Axios_Controller[indexMessage] != null) {
        this.Axios_Controller[indexMessage].abort();
      }
    },
    syncBufferedResponseAt(indexMessage, indexMessageRes) {
      if (this.listMessage.length > 0 && this.messageRes.length > 0 && this.listMessage[indexMessage].messageBot.length < this.messageRes[indexMessageRes].length) {
        this.listMessage[indexMessage].messageBot = this.messageRes[indexMessageRes];
      }
    },
    restoreCompletedBufferedResponseAt(indexMessage, indexMessageRes) {
      if (!(this.listMessage.length > 0 && this.listMessage[indexMessage].status_Process == "END" && this.listMessage[indexMessage].messageBot != null && this.messageRes.length > 0)) {
        return false;
      }

      if (this.listMessage[indexMessage].messageBot.length < this.messageRes[indexMessageRes].length) {
        this.Count_messageRes[indexMessage] = 0;
        this.StatusPro = true;
        this.messageRun = "";
        this.listMessage[indexMessage].messageBot = this.messageRes[indexMessageRes];
        this.messageRes[indexMessageRes] = "";
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return true;
      }

      return false;
    },
    clearBufferedResponseAt(indexMessageRes) {
      if (this.messageRes.length > 0) {
        this.messageRes[indexMessageRes] = "";
      } else {
        this.messageRes[0] = "";
      }
    },
    Chang_History() {
      let indexMessage = this.getLastStreamMessageIndex();

      this.stopActiveVoiceAndUploads();
      this.abortChatRequestAt(indexMessage);
      this.Stop_Flag = true;
      this.CountScroll = this.MaxCountScroll;
      this.messageData = "";
      this.messageRes = [];
      this.listMessage = [];
      this.Axios_Controller = [];
      this.Count_messageRes = [];
      this.StatusPro = false;
      this.flagTopHistory = true;

      this.ImageURL = null;
      this.fileDataUrl = null;
      this.loadingImage = false;
      this.requestUpload.entity = null;
      this.pickedFileType = null;
      this.pickedFileName = null;
      this.requestVector.entity = null;
      this.uploadFileComplete = false;
      this.hasVectorRefreshResponse = false;
      this.uploadedFileKeyTopic = null;
      this.isPrivateFileUploadActive = false;
      this.uploadedFiles = [];
      this.files = [];
      this.dataAll = 0;
      this.dataUpdate = 0;
      this.fileID = -1;
      this.products = [];
      this.hideProducts = false;
    },

    StopMessage() {
      let indexMessage = this.getLastStreamMessageIndex();
      let indexMessageRes = this.getLastStreamResponseIndex();

      if (this.listMessage.length == 0) {
        return;
      }

      if (this.isTerminalStreamStatus(indexMessage)) {
        this.removeBlinkingCursorAt(indexMessage);
        return;
      }

      if (this.TimeOutText_Run != null) {
        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }

      this.stopActiveVoiceAndUploads();
      this.abortChatRequestAt(indexMessage);
      this.Stop_Flag = true;
      this.syncBufferedResponseAt(indexMessage, indexMessageRes);

      if (this.restoreCompletedBufferedResponseAt(indexMessage, indexMessageRes)) {
        return;
      }

      if (this.listMessage.length > 0) {
        this.listMessage[indexMessage].status_Process = "Stop";
      }

      this.removeBlinkingCursorAt(indexMessage);
      this.messageData = "";
      this.clearBufferedResponseAt(indexMessageRes);
      this.Count_messageRes[indexMessage] = 0;
      this.StatusPro = false;
    },
    StopMessageByIndex(IndexMessage) {
      if (
        this.listMessage.length == 0 ||
        (this.listMessage.length > 0 &&
          (this.listMessage[IndexMessage].status_Process == "Stop" ||
            this.listMessage[IndexMessage].status_Process == "END" ||
            this.listMessage[IndexMessage].status_Process == "Error"))
      ) {
        return;
      }

      if (this.TimeOutText_Run != null) {
        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }

      this.abortChatRequestAt(IndexMessage);

      if (
        this.listMessage.length > 0 &&
        this.listMessage[IndexMessage].messageBot.length <
        this.messageRes[IndexMessage].length
      ) {
        this.listMessage[IndexMessage].messageBot = this.messageRes[IndexMessage];
      }

      if (
        this.listMessage.length > 0 &&
        this.listMessage[IndexMessage].status_Process == "END" &&
        this.listMessage[IndexMessage].messageBot != null &&
        this.listMessage[IndexMessage].messageBot.length <
        this.messageRes[IndexMessage].length
      ) {
        this.Count_messageRes[this.listMessage.length - 1] = 0;
        this.StatusPro = true;
        this.loading = true;
        this.messageRun = "";
        this.listMessage[IndexMessage].messageBot = this.messageRes[IndexMessage];
        this.messageRes[IndexMessage] = "";
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }

      if (this.listMessage.length > 0) {
        this.listMessage[IndexMessage].status_Process = "ChatChain";
      }

      this.listMessage[IndexMessage].messageBot = this.listMessage[IndexMessage].messageBot.replace(
        '<span class="blinking-cursor" style="">|</span>',
        ""
      );
    },
    Clear_listMessage() {
      let indexMessage = this.getLastStreamMessageIndex();
      if (
        this.listMessage.length == 0 ||
        (this.listMessage.length > 0 &&
          (this.listMessage[this.listMessage.length - 1].status_Process ==
            "Process" ||
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "Send_Message" ||
            this.listMessage[this.listMessage.length - 1].status_Process ==
            "VoiceStart"))
      ) {
        return;
      }

      this.flagTopHistory = true;
      let dataPost = {
        events: [
          {
            replyToken: "dummyToken",
            type: "message",
            timestamp: 1462629479859,
            fullStream: true,
            stream: false,
            SessionID: this.SessionID,
            source: {
              type: "user",
              userId: this.User_Id,
            },
            message: {
              id: "325708",
              type: "text",
              topicModelID: this.TopicModelID_long,
              topicID: this.Log_History_TopicID,
              keyTopic: this.KeyTopic,
              text: ":clearhistory",
            },
          },
        ],
      };
      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");
        },

        maxRedirects: 0, // avoid buffering the entire stream
      };
      //#region Send data to backend
      // if (self.snippet_Status != true) {
      //   self.$call.GptFullStreamPOST(dataPost, Config, () => {
      //     self.listMessage = [];
      //     self.messageData = "";
      //     self.messageRes[IndexMessage] = "";
      //     self.Count_messageRes = [];
      //     self.StatusPro = false;
      //   },
      //     () => {
      //     });
      // }
      // else {
      this.$call.GptFullStreamPostToken(
        dataPost,
        Config,
        this.auth_token_local,
        () => {
          this.listMessage = [];
          this.messageData = "";
          this.messageRes[indexMessage] = "";
          this.Count_messageRes = [];
          this.StatusPro = false;
        },
        () => { }
      );
      //#endregion
    },

    Keydown_Enter_MessageData() { },
    ChatRef_ScrollIntoView() {
      const chatScreen = this.$refs.ChatScreRef;
      const chatContentEnd = this.$refs.ChatContainerRef;
      if (chatScreen && chatContentEnd) {
        const scrollThreshold = 10; // ฝำหนด threshold สำหรับฝารตรวจสอบว่าอยู่ใฝล้ด้านล่างหรือไม่ (หน่วยเป็น pixel)
        // ตรวจสอบว่าผู้ใช้ได้ scroll ไปใฝล้ด้านล่างสุดของ chat container หรือไม่
        const isScrolledEffectivelyToBottom =
          chatScreen.scrollHeight -
          chatScreen.scrollTop -
          chatScreen.clientHeight <
          scrollThreshold;

        let shouldScroll = false;
        if (
          this.CountScroll >= this.MaxCountScroll ||
          isScrolledEffectivelyToBottom
        ) {
          shouldScroll = true;
        }

        if (shouldScroll) {
          // ใช้ $nextTick เพื่อให้๝น่ใจว่า DOM ได้ update ฝ่อนที่จะทำฝาร scroll
          this.$nextTick(() => {
            chatContentEnd.scrollIntoView({
              behavior: "auto", // หาฝ 'smooth' ยังมีปัฝหา ลองเปลี่ยนเป็น 'auto'
              block: "end",
              inline: "start",
            });
          });
          this.CountScroll = 0; // Reset counter เมื่อมีฝาร scroll เฝิดขึ้น
        }
      }
      this.CountScroll++; // เพิ่มค่า CountScroll ทุฝครั้งที่ถูฝเรียฝ
    },
    SkipTextRendering() {
      let indexMessage = this.listMessage.length - 1;
      let indexMessageRes = this.messageRes.length - 1;
      
      // ตรวจสอบว่าสามารถ skip ได้หรือไม่
      if (this.listMessage.length > 0 && 
          this.messageRes.length > 0 &&
          this.listMessage[indexMessage].status_Process == 'END' &&
          this.listMessage[indexMessage].messageBot != null &&
          this.listMessage[indexMessage].messageBot.length < this.messageRes[indexMessageRes].length) {
        
        // Skip text rendering โดยให้๝สดงข้อความเต็มทันที
        this.Count_messageRes[indexMessage] = 0;
        this.StatusPro = true;
        this.messageRun = "";
        this.listMessage[indexMessage].messageBot = this.messageRes[indexMessageRes];
        this.messageRes[indexMessageRes] = "";
        
        // Scroll to bottom
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        
        // Update render key
        this.rerenderKey++;
      }
    },
    appendNextStreamChunkAt(indexMessage) {
      if (
        this.Count_messageRes[indexMessage] >= this.messageRes[indexMessage].length
      ) {
        return;
      }

      if (
        this.messageRes[indexMessage].length >
          this.Count_messageRes[indexMessage] + 5 &&
        this.messageRes[indexMessage][this.Count_messageRes[indexMessage]] == "<"
      ) {
        if (
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage]] +
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 1] +
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 2] +
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 3] +
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 4] +
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 5] ==
          "<br />"
        ) {
          this.listMessage[indexMessage].messageBot += "<br />";
          this.Count_messageRes[indexMessage] += 5;
        } else {
          this.listMessage[indexMessage].messageBot +=
            this.messageRes[indexMessage][this.Count_messageRes[indexMessage]];
        }
      } else if (
        this.messageRes[indexMessage][this.Count_messageRes[indexMessage]] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 1] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 2] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 3] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 4] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 5] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 6] +
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage] + 7] ==
          "![Image]" ||
        this.messageImage != ""
      ) {
        let count = 0;
        for (
          let index = this.Count_messageRes[indexMessage];
          index < this.messageRes[indexMessage].length;
          index++
        ) {
          const element = this.messageRes[indexMessage][index];
          this.messageImage += element;
          count++;
          if (element == ")") {
            break;
          }
        }
        if (
          this.messageRes[indexMessage][
            this.Count_messageRes[indexMessage] + (count - 1)
          ] == ")"
        ) {
          this.listMessage[indexMessage].messageBot += this.messageImage;
          this.messageImage = "";
        }
        this.Count_messageRes[indexMessage] += count - 1;
      } else {
        this.listMessage[indexMessage].messageBot +=
          this.messageRes[indexMessage][this.Count_messageRes[indexMessage]];
        this.messageImage = "";
      }

      this.Count_messageRes[indexMessage]++;
    },
    finalizeCompletedTextRunAt(indexMessage) {
      if (
        this.Count_messageRes[indexMessage] == this.messageRes[indexMessage].length &&
        this.listMessage[indexMessage].status_Process == "END"
      ) {
        this.removeBlinkingCursorAt(indexMessage);
        this.listMessage[indexMessage].messageBot = this.listMessage[indexMessage].messageBot.replace(
          '<span class="blinking-cursor" style="">|</span>',
          ""
        );
        return true;
      }

      return false;
    },
    _normalizeStreamMarkdownWhitespace(text) {
      text = text.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");
      text = text.replace(/(?: {6}\n| {5}\n| {4}\n| {3}\n| {2}\n| \n)/g, "\n");
      text = text.replace(/(?:\n {6}```|\n {5}```|\n {4}```|\n {3}```|\n {2}```|\n ```)/g, "\n```");
      return text;
    },
    _tokenizeStreamMarkdownFences(text) {
      text = text.replaceAll(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
      text = text.replaceAll(/(?:\n```\n\n)/g, "\n<||End||>\n\n");
      text = text.replace(/(?:\n```\n```python|\n {3}```\n {3}```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
      text = text.replace(/(?:\n```\n```javascript|\n {3}```\n {3}```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");
      text = text.replaceAll(/(?:\n```\n)/g, "\n<||StarAll||>\n");
      text = text.replaceAll(/(?:\n```python)/g, "\n<||StarPython||>");
      text = text.replaceAll(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
      text = text.replaceAll(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");
      return text;
    },
    _resolveEndToken(splitResponseText, responseIndex, splitValue, previousSplitValue) {
      for (let previousIndex = responseIndex - 1; previousIndex > 0; previousIndex--) {
        try {
          let previousLoopSplitValue = splitResponseText[previousIndex].split("||>");
          if (previousSplitValue.length > 1 && previousLoopSplitValue.length > 1) {
            if (previousSplitValue[0].includes("Star")) {
              let replacedValue = previousSplitValue[0].replace("Star", "End");
              splitResponseText[responseIndex] = splitResponseText[responseIndex].replace("End||>", replacedValue + "||>");
              break;
            } else if (
              previousSplitValue[0].includes("End") &&
              previousLoopSplitValue[0].includes("Star") &&
              !previousLoopSplitValue[0].includes(previousSplitValue[0].replace("End", "Star"))
            ) {
              let replacedValue = previousLoopSplitValue[0].replace("Star", "End");
              splitResponseText[responseIndex] = splitResponseText[responseIndex].replace("End||>", replacedValue + "||>");
              break;
            }
          }
        } catch (e) { //NOSONAR
          // error intentionally ignored — no rethrow required
        }
      }
    },
    _resolveStarAllToken(splitResponseText, responseIndex, previousSplitValue) {
      let nextSplitValue = splitResponseText[responseIndex + 1].split("||>");
      if (previousSplitValue[0].includes("Star") && nextSplitValue.length > 1 && nextSplitValue[0].includes("Star")) {
        let replacedValue = previousSplitValue[0].replace("Star", "End");
        splitResponseText[responseIndex] = splitResponseText[responseIndex].replace("StarAll||>", replacedValue + "||>");
      }
    },
    _prefixUnpairedTokens(splitResponseText) {
      for (let finalIndex = 0; finalIndex < splitResponseText.length; finalIndex++) {
        if (splitResponseText[finalIndex].includes("||>")) {
          splitResponseText[finalIndex] = "<||" + splitResponseText[finalIndex];
        }
      }
    },
    _resolveStreamMarkdownTokenPairs(splitResponseText) {
      for (let responseIndex = 0; responseIndex < splitResponseText.length; responseIndex++) {
        let splitValue = splitResponseText[responseIndex].split("||>");
        if (responseIndex >= 1 && splitValue.length > 1) {
          let previousSplitValue = splitResponseText[responseIndex - 1].split("||>");
          if (splitValue[0].includes("End")) {
            this._resolveEndToken(splitResponseText, responseIndex, splitValue, previousSplitValue);
          } else if ((responseIndex + 1) < splitResponseText.length && splitValue[0].includes("StarAll")) {
            this._resolveStarAllToken(splitResponseText, responseIndex, previousSplitValue);
          }
        }
      }
      this._prefixUnpairedTokens(splitResponseText);
      return splitResponseText.join("");
    },
    _detokenizeStreamMarkdown(text) {
      text = text.replaceAll("<||StarMarkdown||>", "\n`````\n");
      text = text.replaceAll("<||EndMarkdown||>", "`````\n");
      text = text.replaceAll("<||StarAll||>", "```");
      text = text.replaceAll("<||EndAll||>", "```");
      text = text.replaceAll("<||StarJavascript||>", "```javascript");
      text = text.replaceAll("<||EndJavascript||>", "```");
      text = text.replaceAll("<||StarPython||>", "```python");
      text = text.replaceAll("<||EndPython||>", "```");
      text = text.replaceAll("<||Star||>", "```");
      text = text.replaceAll("<||End||>", "```");
      return text;
    },
    normalizeStreamMarkdownBlocks(responseText) {
      let normalizedResponseText = this._normalizeStreamMarkdownWhitespace(responseText);
      normalizedResponseText = this._tokenizeStreamMarkdownFences(normalizedResponseText);
      let splitResponseText = normalizedResponseText.split("<||");
      normalizedResponseText = this._resolveStreamMarkdownTokenPairs(splitResponseText);
      return this._detokenizeStreamMarkdown(normalizedResponseText);
    },
    scopeMarkdownHtmlStyle(responseText) {
      if (
        responseText.indexOf("<!DOCTYPE html>") == 0 &&
        !responseText.includes("```html\n<!DOCTYPE html>") &&
        !responseText.includes("```\n<!DOCTYPE html>") &&
        responseText.indexOf("<style>" != -1)
      ) {
        let splitResponseTextStart = responseText.split("<style>");
        let splitResponseTextEnd = splitResponseTextStart[1].split("</style>");

        if (splitResponseTextEnd.length > 0) {
          splitResponseTextEnd[0] = splitResponseTextEnd[0].replaceAll("}\n", "}\n  #V_markDown ");
        }

        responseText =
          splitResponseTextStart[0] +
          "<style> #V_markDown " +
          splitResponseTextEnd[0] +
          (splitResponseTextEnd.length > 1 ? " </style> " + splitResponseTextEnd[1] : "");
      }

      return responseText;
    },
    normalizeStreamResponseText(responseText) {
      let normalizedResponseText = responseText.replaceAll("data: [DONE]", "");

      if (normalizedResponseText.includes("|Products|[")) {
        let splitProductsResponse = normalizedResponseText.split("|Products|");
        normalizedResponseText = splitProductsResponse[0];
        this.products = JSON.parse(splitProductsResponse[1]);
        this.hideProducts = false;
      }

      normalizedResponseText = this.normalizeStreamMarkdownBlocks(normalizedResponseText);
      normalizedResponseText = normalizedResponseText.replace(/(?:\\n\\n|\n\n)/g, "\n");
      normalizedResponseText = normalizedResponseText.replace(/(?:\\```|\\```|```)/g, "<||TextMarkdown||>");
      normalizedResponseText = normalizedResponseText.replace(/(?:\\`|\\`)/g, "\\`");
      normalizedResponseText = normalizedResponseText.replaceAll("<||TextMarkdown||>", "```");
      normalizedResponseText = normalizedResponseText.replaceAll("(```", "(\\```");
      normalizedResponseText = normalizedResponseText.replaceAll("(``", "(\\``");
      normalizedResponseText = normalizedResponseText.replaceAll("(`", "(\\`");
      normalizedResponseText = normalizedResponseText.replaceAll("` ` `", "`` ` ``");

      return this.scopeMarkdownHtmlStyle(normalizedResponseText);
    },
    applyStreamResponseTextAt(indexMessage, responseText) {
      if (responseText.includes("|Text|*Streaming:true*|")) {
        responseText = responseText.replaceAll("|Text|*Streaming:true*|", "");
        this.listMessage[indexMessage].messageBot = responseText;
        this.messageRes[indexMessage] = "";
        this.Count_messageRes[indexMessage] = 0;
        this.StatusPro = false;
      } else if (responseText.includes("|Text|*Streaming:false*|")) {
        responseText = responseText.replaceAll("|Text|*Streaming:false*|", "");
        this.listMessage[indexMessage].messageBot = responseText;
        this.messageRes[indexMessage] = "";
        this.Count_messageRes[indexMessage] = 0;
        this.StatusPro = false;
      } else {
        this.messageRes[indexMessage] = responseText;
        this.StatusPro = true;
      }
    },
    handleSendOpenAiDownloadProgress(indexMessage, progressEvent) {
      const xhr =
        progressEvent.target == undefined
          ? progressEvent.event.target
          : progressEvent.target;
      // response ที่เป็น error (เช่น 400 ข้อความยาวเกิน) ไม่ใช่สตรีมคำตอบ ห้ามเอา body มาเรนเดอร์ลงฟองแชท
      if (xhr && xhr.status >= 400) {
        return;
      }
      try {
        if (
          this.listMessage[indexMessage].messageBot == "" ||
          this.listMessage[indexMessage].messageBot == '<span class="blinking-cursor" style="">|</span>'
        ) {
          try {
            this.GetTopicFullStream("Steam");
          } catch {
          }
        }

        this.GetDateTime();
        const { responseText } = xhr;
        this.listMessage[indexMessage].status_Process = "Send_Message";
        this.listMessage[indexMessage].responseTime = this.today;
        this.listMessage[indexMessage].isFeedback = this.isFeedback;

        let normalizedResponseText = this.normalizeStreamResponseText(responseText);
        this.applyStreamResponseTextAt(indexMessage, normalizedResponseText);
      } catch (e) { //NOSONAR
        // error intentionally ignored — no rethrow required
        console.log("e");
      }
    },
    queueChatScroll() {
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
    },
    handlePendingFileUploadSend(kIn) {
      if (!this.isFileUploadPending) {
        return false;
      }

      if (kIn == "Enter") {
        let point = this.$refs.RefMessageData.$refs.input.selectionStart - 1;

        if (this.messageData.length > 0 && this.messageData[point] == "\n") {
          this.messageData = this.messageData.slice(0, point) + this.messageData.slice(point + 1);
        }
      }

      return true;
    },
    restoreBufferedSendOpenAiMessage() {
      if (!(this.listMessage.length > 0 && this.messageRes.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'END' && this.listMessage[this.listMessage.length - 1].messageBot != null)) {
        return false;
      }

      if (this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes[this.messageRes.length - 1].length) {
        this.Count_messageRes[this.listMessage.length - 1] = 0;
        this.StatusPro = true;
        this.messageRun = "";
        this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes[this.messageRes.length - 1];
        this.messageRes[this.messageRes.length - 1] = "";
        this.queueChatScroll();
        return this.messageData == "";
      }

      return false;
    },
    canSendOpenAiProceed(kIn) {
      if (this.messageData == "" || kIn == "Skip") {
        return false;
      }

      return !((this.messageData == "" && this.fileDataUrl == null) ||
        (this.listMessage.length > 0 &&
          this.listMessage[this.listMessage.length - 1].status_Process != "END" &&
          this.listMessage[this.listMessage.length - 1].status_Process != "Error" &&
          this.listMessage[this.listMessage.length - 1].status_Process != "Stop" &&
          !this.IsChainMassage));
    },
    pushLocalModelCommandReplyMessage(messageData, localModelCommandReply) {
      this.listMessage.push({
        messageUser: messageData,
        messageBot: localModelCommandReply,
        status_Process: "END",
        requestTime: this.today,
        responseTime: this.today,
        status: null,
        comment: "",
        commentDialog: false,
        moreComment: false,
        isFeedback: false,
      });

      this.queueChatScroll();
    },
    resolveSendOpenAiKeyTopic(messageData) {
      if (this.uploadedFileKeyTopic != null && this.uploadedFileKeyTopic != "") {
        this.KeyTopic = this.uploadedFileKeyTopic;
      } else if (this.KeyTopic == null || this.KeyTopic == "") {
        this.KeyTopic = this.GetUuidv4_Fun();
      }

      const messageKeyTopic = this.KeyTopic;
      if (this.listTopic.length > 0 && this.listTopic[0].topicID == -1) {
        this.listTopic[0].topicName = messageData;
        this.listTopic[0].keyTopic = messageKeyTopic;
      }

      return messageKeyTopic;
    },
    prepareSendOpenAiState(messageData) {
      let messageImage = "";
      let messagePickedFile = "";
      let indexMessageOld = this.listMessage.length - 1;
      const imageUrl = this.ImageURL;

      if (imageUrl != "" && imageUrl != null) {
        messageImage = `![image](${imageUrl})\n`;
      }
      if (this.pickedFileType != null && this.uploadFileComplete) {
        messagePickedFile = `<img src="${this.GetFileTypeImg(
          this.requestVector.doctype
        )}" width="16" height="16" style="vertical-align: middle;"> <small>${this.pickedFileName}</small>\n`;
      }
      if (this.listMessage[indexMessageOld] != undefined && this.IsChainMassage) {
        if (this.listMessage[indexMessageOld].status_Process != "END") {
          this.StopMessageByIndex(indexMessageOld);
          this.StopForChain = true;
        }
      }

      this.listMessage.push({
        messageUser: messagePickedFile + messageImage + messageData,
        messageBot: "",
        status_Process: "Process",
        requestTime: this.today,
        responseTime: null,
        status: null,
        comment: "",
        commentDialog: false,
        moreComment: false,
        isFeedback: this.isFeedback,
      });

      let indexMessage = this.listMessage.length - 1;
      this.queueChatScroll();

      const messageKeyTopic = this.resolveSendOpenAiKeyTopic(messageData);
      const messageText = messagePickedFile + messageData;
      const tempModelID = Number(this.currentQuickModel?.modelDisplayID) || Number.parseInt(this.unwrapInjectedValue(this.TopicModelID)) || Number.parseInt(this.modelDisplayID) || null;

      return {
        indexMessage,
        originalMessageData: messageData,
        messageKeyTopic,
        messageText,
        tempModelID,
        imageUrl,
      };
    },
    buildSendOpenAiDataPost(messageText, messageKeyTopic, tempModelID, personalInfoToken = this.personalInfoToken, allowImageFlag = this.IsAllowImage, imageUrl = this.ImageURL) {
      return {
        events: [
          {
            replyToken: "dummyToken",
            type: "message",
            timestamp: 1462629479859,
            fullStream: true,
            stream: false,
            snippet: this.snipet_flag ?? false,
            SessionID: this.SessionID,
            source: {
              type: "users",
              userId: this.User_Id,
              groupModel: this.parameterURL.groupmodel,
              domainName: this.URL_Domain,
              modelDisplayID: tempModelID,
              selectedLLM: this.activeSelectedLLMId,
              tokenParam: this.tokenParam,
              LLMsConfig: {
                selectedLLM: this.activeSelectedLLMId,
                reasoning_effort: this.getReasoningEffortPayload(),
              },
            },

            message: {
              id: "325708",
              type: "text",
              ImageURL:
                imageUrl == "" || imageUrl == null || allowImageFlag == false //NOSONAR
                  ? null
                  : imageUrl,
              topicModelID: this.TopicModelID_long,
              topicID: this.Log_History_TopicID,
              keyTopic: messageKeyTopic,
              text: messageText,
              productSelect: this.productsSelect,
            },
            PersonalInfoToken: personalInfoToken,
          },
        ],
      };
    },
    initializeSendOpenAiRequest(indexMessage) {
      this.hideProducts = true;
      this.Stop_Flag = false;
      this.messageRes[indexMessage] = "";
      this.Count_messageRes[indexMessage] = 0;
      this.StatusPro = true;
      this.messageRun = "";
      this.Axios_Controller[indexMessage] = new AbortController();
      this.ClearImage();
      this.ClearUploadedFile();
    },
    createSendOpenAiConfig(indexMessage) {
      return {
        signal: this.Axios_Controller[indexMessage].signal,
        onUploadProgress: () => {
          this.Text_Run(indexMessage);
          if (this.listMessage[indexMessage].messageBot == "") {
            try {
              /* intentionally empty */
            } catch { }
          }
        },
        onDownloadProgress: (progressEvent) => {
          this.handleSendOpenAiDownloadProgress(indexMessage, progressEvent);
        },
        maxRedirects: 0,
      };
    },
    applyBufferedMessageIfPresent(indexMessage) {
      if (this.messageRes[indexMessage] != "" && this.messageRes[indexMessage] != null && this.messageRes[indexMessage] != undefined) {
        this.listMessage[indexMessage].messageBot = this.messageRes[indexMessage];
      }
    },
    markSendOpenAiMessageEnded(indexMessage, responseData, applyBufferedMessage) {
      if (applyBufferedMessage) {
        this.applyBufferedMessageIfPresent(indexMessage);
      }

      this.listMessage[indexMessage].status_Process = "END";
      if (responseData != null) {
        this.listMessage[indexMessage].id = responseData.id;
        this.listMessage[indexMessage].modelDisplayID = responseData.modelDisplayID;
      }
      this.listMessage[indexMessage].isFeedback = this.isFeedback;
      this.removeBlinkingCursorAt(indexMessage);
      this.Loading_History_Status = false;
    },
    fetchLastLogAndFinalizeSendOpenAi(indexMessage, userChannel, applyBufferedMessage) {
      let userPayload = {
        TopicID: this.Log_History_TopicID,
        USER_CHANNEL: userChannel,
        ID: this.Log_History_ID,
        Take: this.Log_History_Take,
      };

      this.$call.GetLastLogID(
        userPayload,
        this.auth_token_local,
        (response) => {
          if (response.status == 0) {
            this.markSendOpenAiMessageEnded(indexMessage, response.data, applyBufferedMessage);
          } else if (response.status == 1) {
            this.markSendOpenAiMessageEnded(indexMessage, null, applyBufferedMessage);
          }
        },
        () => {
          this.markSendOpenAiMessageEnded(indexMessage, null, applyBufferedMessage);
        }
      );

      this.queueChatScroll();
    },
    clearSendOpenAiHistoryState() {
      this.Clear_listMessage();
      this.listMessage = [];
      this.messageData = "";
      if (this.messageRes.length > 0) {
        this.messageRes[this.messageRes.length - 1] = "";
      } else {
        this.messageRes[0] = "";
      }
      this.Count_messageRes[this.listMessage.length - 1] = 0;
      this.StatusPro = false;
    },
    handleSendOpenAiRequestError(sendState, _response, shouldLogResponse = true) {
      this.erroralert = true;

      // backend ปฏิเสธเพราะข้อความยาวเกินเพดานของโมเดล ไม่ใช่ error ทั่วไป
      const isTooLong = isInputTooLongError(_response);
      const serverLimit = isTooLong ? parseServerCharLimit(_response, this.maximumChatInput) : this.maximumChatInput;
      if (isTooLong) {
        this.maximumChatInput = serverLimit; // sync เพดานจริงจาก backend
      }
      const errorText = isTooLong
        ? this.$t('_chatMessageTooLong', { max: serverLimit })
        : "Error something went wrong ...";
      if (this.listMessage.length == 0) {
        /* intentionally empty */
      } else if (this.Stop_Flag && this.listMessage.length > 0) {
        this.listMessage[sendState.indexMessage].status_Process = "Stop";
      } else {
        this.StatusPro = this.StopForChain;
        this.Count_messageRes[sendState.indexMessage] = 0;
        this.messageData = "";
        if (isTooLong && this.listMessage[sendState.indexMessage].status_Process != "Stop") {
          // body ที่ progress handler เขียนไว้เป็นรหัส INPUT_TOO_LONG ดิบ ต้องทับทั้งก้อน ห้ามต่อท้าย
          this.listMessage[sendState.indexMessage].messageBot = errorText;
        } else if (
          this.listMessage.length > 0 &&
          this.listMessage[sendState.indexMessage].messageBot.length <
          this.messageRes[sendState.indexMessage].length &&
          this.listMessage[sendState.indexMessage].status_Process != "ChatChain" &&
          !this.StopForChain
        ) {
          this.listMessage[sendState.indexMessage].messageBot =
            this.messageRes[sendState.indexMessage] +
            "<br />" + errorText;
        } else if (
          !this.StopForChain &&
          this.listMessage[sendState.indexMessage].status_Process != "Stop"
        ) {
          this.listMessage[sendState.indexMessage].messageBot += errorText;
        }
        this.messageRes[sendState.indexMessage] = "";
        if (this.listMessage[sendState.indexMessage].status_Process != "Stop") {
          this.listMessage[sendState.indexMessage].status_Process = this.StopForChain
            ? "ChatChain"
            : "Error";
        }
      }
      this.Stop_Flag = false;
      if (shouldLogResponse) {
        console.log("Error : " + _response);
      }
      this.queueChatScroll();
    },
    handlePersonalInfoSendOpenAiSuccess(sendState) {
      this.StatusPro = false;
      this.StopForChain = false;
      this.successalert = true;
      this.productsSelect = [];
      this.fetchLastLogAndFinalizeSendOpenAi(sendState.indexMessage, this.$root.User_Id, true);
    },
    submitPersonalInfoSendOpenAiRequest(sendState, allowImageFlag = this.IsAllowImage) {
      const dataPost = this.buildSendOpenAiDataPost(
        sendState.messageText,
        sendState.messageKeyTopic,
        sendState.tempModelID,
        this.personalInfoToken,
        allowImageFlag,
        sendState.imageUrl
      );

      this.$call.GptFullStreamPostToken(
        dataPost,
        sendState.config,
        this.auth_token_local,
        () => {
          this.handlePersonalInfoSendOpenAiSuccess(sendState);
        },
        (_response) => {
          console.log("catch");
          this.handleSendOpenAiRequestError(sendState, _response, false);
        }
      );
    },
    startPersonalInfoSendOpenAiFlow(sendState) {
      this.listMessage[sendState.indexMessage].status_Process = "Process";
      window.open(`${this.urlApi}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

      const handleMessage = (event) => {
        try {
          if (!event.data || !event.data.message) {
            return;
          }

          this.personalInfoToken = event.data.message;
          this.submitPersonalInfoSendOpenAiRequest(sendState, this.$root.IsAllowImage);
        } catch (error) {
          console.log("🝞 ใน handleMessage:", error);
        } finally {
          console.log("🛑 EventListener message");
          window.removeEventListener('message', handleMessage);
        }
      };

      window.addEventListener('message', handleMessage);

      let checkTokenInterval = setInterval(() => {
        const token = localStorage.getItem("personalInfoToken");
        if (token) {
          try {
            this.personalInfoToken = token;
            this.submitPersonalInfoSendOpenAiRequest(sendState);
          } catch (e) {
            console.error("❌ Error parsing token:", e);
          }
          clearInterval(checkTokenInterval);
        }
      }, 500);
    },
    handleSendOpenAiRequestSuccess(sendState) {
      if (this.listMessage[sendState.indexMessage].messageBot == "**#Personal Information**") {
        this.startPersonalInfoSendOpenAiFlow(sendState);
        return;
      }

      if (sendState.originalMessageData.trim() == ":clearhistory") {
        this.clearSendOpenAiHistoryState();
        return;
      }

      this.StatusPro = false;
      this.StopForChain = false;
      this.successalert = true;
      this.productsSelect = [];
      this.fetchLastLogAndFinalizeSendOpenAi(sendState.indexMessage, this.User_Id, false);
    },
    SendOpenAi(K_in) {
      this.CheckCurrentModelTextToImage();
      if (this.handlePendingFileUploadSend(K_in)) {
        return;
      }

      if (this.restoreBufferedSendOpenAiMessage()) {
        return;
      }

      if (!this.canSendOpenAiProceed(K_in)) {
        return;
      }

      this.GetDateTime();

      let messageData = this.messageData;
      this.messageData = "";

      const localModelCommandReply = this.buildModelCommandReply(messageData);
      if (localModelCommandReply != null) {
        this.pushLocalModelCommandReplyMessage(messageData, localModelCommandReply);
        return;
      }

      let sendState = this.prepareSendOpenAiState(messageData);
      this.initializeSendOpenAiRequest(sendState.indexMessage);

      let dataPost = this.buildSendOpenAiDataPost(
        sendState.messageText,
        sendState.messageKeyTopic,
        sendState.tempModelID,
        this.personalInfoToken,
        this.IsAllowImage,
        sendState.imageUrl
      );
      let config = this.createSendOpenAiConfig(sendState.indexMessage);
      sendState.config = config;

      this.$call.GptFullStreamPostToken(
        dataPost,
        config,
        this.auth_token_local,
        () => {
          this.handleSendOpenAiRequestSuccess(sendState);
        },
        (_response) => {
          this.handleSendOpenAiRequestError(sendState, _response);
        }
      );
    },

    Text_Run(IndexMessage) {
      this.TimeOutText_Run = setTimeout(() => {
        if (this.listMessage.length == 0) {
          this.StopMessage();
          return;
        }

        if (
          (this.Count_messageRes[IndexMessage] >= this.messageRes[IndexMessage].length &&
            !this.StatusPro) ||
          this.listMessage[IndexMessage].status_Process == "ChatChain"
        ) {
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
          }, 5);

          this.rerenderKey++;
        }

        if (
          (this.Count_messageRes[IndexMessage] < this.messageRes[IndexMessage].length ||
            this.StatusPro) &&
          this.listMessage[IndexMessage].status_Process != "ChatChain"
        ) {
          this.removeBlinkingCursorAt(IndexMessage);

          if (this.Count_messageRes[IndexMessage] < this.messageRes[IndexMessage].length) {
            this.appendNextStreamChunkAt(IndexMessage);
          }

          if (this.finalizeCompletedTextRunAt(IndexMessage)) {
            return;
          }

          this.Text_Run(IndexMessage);
        }
      }, this.Time_Delay);
    },

    async CHK_Auth_Token() {
      try {
        let _auth_token = { auth_token: this.auth_token_local };
        // this.auth_token_local = "";
        // เปลี่ยนฝารใช้ callback เป็น Promise
        let response = await new Promise((resolve, reject) => {
          this.$call.ChkTokenFullStream(
            _auth_token,
            (response) => {
              if (response.status == 0 && response.data.chk) {
                resolve(response);
                this.comID = response.data.companyID;
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Authorization token is missing or has expired.",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  showConfirmButton: false,
                  width: '600px',
                  customClass: {
                  popup: 'swal-modern-popup',
                  title: 'swal-modern-title',
                  content: 'swal-modern-content',
                  }
                });
                reject(new Error("ไม่พบ Auth"));
              }
            },
            () => {
              reject(new Error("ไม่พบ Auth"));
            }
          );
        });
        // ดำเนินฝารต่อเมื่อ Promise สำเร็จ
        this.Time_Delay = response.data.timeDelay;
        this.role.ID = response.data.roleId;
        this.role.Name = response.data.roleName;
        this.Status_Error = false;

        this.GetUuidAll();
      } catch (error) {
        this.Status_Error = true;
        this.Text_Status = error.message;
      }
    },

    GetHistoryFullStream(Status) {
      if (this.Loading_History_Status == true && this.startLoading == true) { //NOSONAR
        return;
      }
      try {
        if (Status == "Start") {
          this.Log_History_ID = 0;
        }
        let _User_Id = {
          TopicID: this.Log_History_TopicID,
          USER_CHANNEL: this.User_Id,
          ID: this.Log_History_ID,
          Take: this.Log_History_Take,
        };

        this.Loading_History_Status = true;
        this.$call.GetHistoryFullStream(
          _User_Id,
          this.auth_token_local,
          (response) => {
            this.startLoading = true;
            if (response.status == 0) {
              let response_data = response.data;
              const thisData = response_data.map((v) => ({
                ...v,
                comment: "",
                commentDialog: false,
                moreComment: false,
                feedback: null,
                status: null,
              }));
              if (Status == "Start") {
                this.listMessage = thisData;
                this.$nextTick(() => {
                  this.SetBottom_Page();
                });
              } else if (Status == "ScrollUp") {
                if (this.listMessage.length > 0 && this.listMessage[0].id == undefined) {
                  this.flagTopHistory = false;
                } else {
                  const mergedMessages = thisData.concat(this.listMessage);
                  this.listMessage = mergedMessages.filter((msg, index, arr) =>
                    index === arr.findIndex(m => m.id === msg.id)
                  );
                }

                if (this.flagTopHistory) {
                  setTimeout(() => {
                    const element1 = document.getElementById(
                      "ChatId_" + this.Log_History_ID
                    );
                    if (element1 != undefined && element1 != null) {
                      this.$refs.ChatScreRef.scrollTop =
                        element1.offsetTop - 20;
                    }
                    this.Loading_History_Status = false;
                  }, 1);
                }
              }
              thisData.map(() => {
                this.messageRes.push("");
              });
            }
            this.Loading_History_Status = false;
          },
          () => {
            this.Loading_History_Status = false;
          }
        );
      } catch {
        /* intentionally empty */
      }
    },

    _assignTopicSettings(response_data) {
      if (this.Log_History_TopicID == -1) {
        this.Time_Delay = response_data[0].timeDelay;
        this.maximumChatInput = response_data[0].maximumChatInput;
        this.IsAllowImage = response_data[0].isAllowImage;
        this.FileUploadLimit = response_data[0].fileUploadLimit;
        this.IsChainMassage = response_data[0].isChainMassage;
        this.isAllowLLMChange = response_data[0].isAllowLLMChange;
      } else {
        this.Time_Delay = response_data.find((e) => e.topicID == this.Log_History_TopicID).timeDelay;
        this.maximumChatInput = response_data.find((e) => e.topicID == this.Log_History_TopicID).maximumChatInput;
        this.IsAllowImage = response_data.find((e) => e.topicID == this.Log_History_TopicID).isAllowImage;
        this.FileUploadLimit = response_data.find((e) => e.topicID == this.Log_History_TopicID).fileUploadLimit;
        this.IsChainMassage = response_data.find((e) => e.topicID == this.Log_History_TopicID).isChainMassage;
        this.isAllowLLMChange = response_data.find(e => e.topicID == this.Log_History_TopicID).isAllowLLMChange;
      }
    },
    _applyTopicSettingsFromResponseData(response_data) {
      if (this.listMessage.length > 0) {
        if (
          [":model"].some((keyword) =>
            this.listMessage[this.listMessage.length - 1].messageUser
              .toLowerCase()
              .includes(keyword.toLowerCase())
          )
        ) {
          this._assignTopicSettings(response_data);
        }
      } else if (response_data.length > 0) {
        this._assignTopicSettings(response_data);
      }
    },
    _applyTopicHeader(response_data) {
      this.Log_History_TopicID = response_data[0].topicID;
      this.TopicName = response_data[0].topicName;
      this.TopicModelID = response_data[0].topicModelID;
      this.isFeedback = response_data[0].isFeedback;
      if (response_data[0].topicModelID_long != null) {
        this.TopicModelID_long = response_data[0].topicModelID_long;
      }
      if (
        response_data[0].keyTopic != null &&
        response_data[0].keyTopic != undefined
      ) {
        this.KeyTopic = response_data[0].keyTopic;
      }
      this.ModelFirst = response_data[0].topicModelID;
    },
    _handleTopicFullStreamStartStatus(response_data) {
      if (response_data.length > 0) {
        this._applyTopicHeader(response_data);
        if (this.GetLogStreamStart_Flag) {
          this.GetLogStreamStart_Flag = false;
        }
      } else {
        this.GetModelFirst(this.parameterURL.groupmodel, this.User_Id, this.comID);
      }
    },
    _handleTopicFullStreamSteamStatus(response_data) {
      if (response_data.length > 0) {
        this._applyTopicHeader(response_data);
      } else {
        this.GetModelFirst(null, this.User_Id);
      }
    },
    GetTopicFullStream(status) {
      try {
        try {
          if (status === "ChangHistory" || status === "Start") {
            this.Loading_History_Status = true;
            this.startLoading = false;
            this.GetShortcutMenu();
          }
        } catch { }

        let _User_Id = {
          USER_CHANNEL: this.User_Id,
          status: status,
        };
        this.$call.GetTopicStreamToken(
          _User_Id,
          this.auth_token_local,
          (response) => {
            if (response.status == 0 && _User_Id.USER_CHANNEL == this.User_Id) {
              let response_data = response.data;
              this.listTopic = response_data;
              this.$nextTick(() => {
                this._applyTopicSettingsFromResponseData(response_data);
              });
              if (status == "Steam") {
                this._handleTopicFullStreamSteamStatus(response_data);
              } else {
                if (status == "Start") {
                  this._handleTopicFullStreamStartStatus(response_data);
                }
                this.GetHistoryFullStream("Start");
              }
            } else {
              this.listTopic = [];
              this.GetModelFirst(null, this.User_Id);
            }
            this.flagShowTopic = false;
          },
          () => {
            this.GetModelFirst(null, this.User_Id);
            this.listTopic = [];
            this.flagShowTopic = false;
          }
        );
      } catch {
        this.GetModelFirst(this.parameterURL.groupmodel, this.User_Id);
        this.listTopic = [];
        this.flagShowTopic = false;
      }
    },
    SetBottom_Page() {
      let attempts = 0;
      const maxAttempts = 1;
      const intervalTime = 200;

      const tryScrollToBottom = () => {
        attempts++;
        const actualScrollContainer = this.$refs.MainScrollArea; // ใช้ ref ใหม่

        if (actualScrollContainer) {
          actualScrollContainer.scrollTo({
            top: actualScrollContainer.scrollHeight,
            behavior: "smooth",
          });
        }

        if (attempts < maxAttempts) {
          setTimeout(tryScrollToBottom, intervalTime);
        }
      };
      setTimeout(tryScrollToBottom, 100);
    },

    GetTopicIDStream(_messageData) {
      try {
        let _User_Id = {
          USER_CHANNEL: this.User_Id,
          messageData: _messageData,
          KeyTopic: this.KeyTopic,
        };

        this.$call.GetTopicIDStream(
          _User_Id,
          (response) => {
            if (response.status == 0 && response.data.status == true) { //NOSONAR
              let DataLog_Data = response.data.data;
              this.flagTopHistory = true;
              try {
                if (DataLog_Data != null) {
                  this.Log_History_TopicID = DataLog_Data.topicID;
                  this.KeyTopic = DataLog_Data.keyTopic;
                  this.TopicName = DataLog_Data.topicName;

                  this.TopicModelID = DataLog_Data.topicModelID;

                  this.TopicModelID_long = DataLog_Data.topicModelID_long;
                }
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    GetShortcutMenu() {
      try {
        if (!this.parameterURL.groupmodel) {
          return;
        }
        let _groupmodel = {
          groupModel: this.parameterURL.groupmodel,
        };
        this.$call.GetShortcutMenu(
          _groupmodel,
          this.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let responseData = response.data;
              if (responseData) {
                this.ShortcutMenu = responseData;
              }
            }
          },
          () => {
            console.log("GetShortcutMenu : false");
          }
        );
      } catch (ex) {
        console.log(ex);
      }
    },

    GetModelQuickGroupInModelGroup() {
      try {
        let _groupmodel = {
          groupmodel: this.parameterURL.groupmodel,
          USER_CHANNEL: this.User_Id,
          snippet: this.normalizeSnippetFlag(this.snipet_flag),
          domainName: this.URL_Domain,
        };
        this.$call.GetModelQuickGroupInModelGroup(
          _groupmodel,
          this.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let DataLog_Data = response.data;
              try {
                this.ModelQuick = DataLog_Data;
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    GetModelQuickGroupInModelGroupPostToken() {
      try {
        let _groupmodel = {
          groupmodel: this.parameterURL.groupmodel,
          USER_CHANNEL: this.User_Id,
          snippet: this.normalizeSnippetFlag(this.snipet_flag),
          domainName: this.URL_Domain,
        };
        this.$call.GetModelQuickGroupInModelGroupPostToken(
          _groupmodel,
          this.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let DataLog_Data = response.data;
              try {
                this.ModelQuick = DataLog_Data;
                this.showModelQuick = DataLog_Data.filter(
                  (item) => item.typeModel === 1
                );
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    Themecolor() {
      this.selectedColor = this.normalizeThemeColor(
        this.FullstreamChatColorTheme || this.colorThemeChat,
        "#FFA41E"
      );
    },
    normalizeThemeColor(value, fallbackColor) {
      if (!value) {
        return fallbackColor;
      }

      const colorValue = String(value);
      return colorValue.startsWith("#") ? colorValue : `#${colorValue}`;
    },
    getReadableTextColor(colorValue) {
      const color = this.normalizeThemeColor(colorValue, "#FFA41E").replace("#", "");
      if (color.length !== 6) {
        return "#FFFFFF";
      }

      const red = Number.parseInt(color.substring(0, 2), 16);
      const green = Number.parseInt(color.substring(2, 4), 16);
      const blue = Number.parseInt(color.substring(4, 6), 16);
      const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

      return brightness > 150 ? "#111827" : "#FFFFFF";
    },
    getUserMessageBubbleStyle() {
      const bubbleStyle = {
        background: this.fullstreamChatAccentColor,
        color: this.fullstreamChatContrastColor,
      };

      if (this.xsOnly) {
        return {
          ...bubbleStyle,
          maxWidth: "100%",
        };
      }

      return {
        ...bubbleStyle,
        maxWidth: "80%",
        marginTop: "2px",
        marginRight: "6px",
      };
    },
    async loadSvg() {
      try {
        await fetch(modelSVG).then(async (response) => {
          if (response.ok) {
            const svgText = await response.text();
            this.svgContent = svgText;
            //  await this.$nextTick(async () => {
            await this.changeStrokeColor(this.fullstreamChatAccentColor);
            // });
          } else {
            this.loadColor = true;
          }
        });
      } catch (error) {
        console.error("Error loading SVG:", error);
      }
    },
    async changeStrokeColor(color) {
      const svgElement = await document.querySelector("div#quickGroup svg");
      if (svgElement) {
        const btnElement = await document.querySelector("div#quickGroup");
        btnElement.style.justifyContent = "center";
        let check = 0;
        svgElement.querySelectorAll("*").forEach((el, index, arr) => {
          el.setAttribute("stroke", color);
          el.setAttribute("stroke-width", 2);
          svgElement.style.width = "24px";
          svgElement.style.height = "24px";
          check++;
          if (check === arr.length) {
            this.loadColor = true;
          }
        });
      }
    },
    GetDateTime() {
      let month_names_short = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!

      let hh = today1.getHours();
      let m = today1.getMinutes();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (m < 10) {
        m = "0" + m;
      }
      this.today = dd + " " + month_names_short[mm] + " " + hh + ":" + m;
    },
    ThisFeedBackResponse(item, status) {
      this.listMessage = this.listMessage.map((v) => ({
        ...v,
        status: item.id == v.id ? status : v.status,
        commentDialog: false,
        comment: item.comment,
      }));
      let temp = {
        data: {
          LogID: item.id,
          Comment: item.comment,
          Score: status,
          CreateBy: this.User_Id,
          ModelDisplayID: item.modelDisplayID,
        },
        token: this.auth_token_local,
      };
      this.$call.FeedbackFromClient(
        temp,
        (response) => {
          if (response.status == 0) {
            this.listMessage = this.listMessage.map((v) => ({
              ...v,
              commentDialog: false,
              SelectComment: null,
              comment: null,
            }));
          }
          this.closeDialog(item);
        },
        () => {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
      );
    },
    openCommentDialog(item, index) {
      this.listMessage = this.listMessage.map((v, _index) => ({
        ...v,
        status: index == _index ? 0 : v.status,
        commentDialog: index == _index,
      }));

      item.status = 0;
      item.commentDialog = true;
    },
    closeDialog(item) {
      item.commentDialog = false;
      item.SelectComment = null;
      item.comment = null;
    },
    Clipboard(item) {
      let text = document.createElement("textarea");
      text.value = this.listMessage.find((v) => item.id == v.id).messageBot;
      if (
        text.value.substring(text.value.length - 47, text.value.length) ==
        '<span class="blinking-cursor" style="">|</span>'
      ) {
        text.value = text.value.substring(0, text.value.length - 47);
      }
      text.focus();
      document.body.appendChild(text);
      text.select();

      document.execCommand("copy");
      text.remove();
    },
    NotificationMSTeamOnly() {
      this.$swal.fire({
        icon: "error",
        title: "Please use in MS Team only.",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      });
    },
    // ตรวจสอบว่ามี overflow ใน๝นวนอนหรือไม่
    checkOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (!el) return;
        // ถ้า scrollWidth > clientWidth ๝ปลว่ามีส่วนเฝินต้องเลื่อน
        this.showScrollButtons = el.scrollWidth > el.clientWidth;
      });
    },
    onScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      // เช็คว่าถึงซ้ายสุดหรือยัง
      this.showLeftButton =
        this.ShortcutMenu.length > 0 &&
        el.scrollLeft > 0 &&
        el.scrollWidth > el.clientWidth;
      // เช็คว่าถึงขวาสุดหรือยัง
      this.showRightButton =
        this.ShortcutMenu.length > 0 &&
        el.scrollLeft + el.clientWidth < el.scrollWidth &&
        el.scrollWidth > el.clientWidth;
    },
    scrollLeft() {
      // เลื่อน container ไปทางซ้าย 250px
      this.$refs.scrollContainer.scrollLeft -= 250 + 24;
    },
    scrollRight() {
      // เลื่อน container ไปทางขวา 250px
      this.$refs.scrollContainer.scrollLeft += 250 + 24;
    },
    _initMountedStateVars() {
      this.Log_History_Take = 5;
      this.Log_History_ID = null;
      this.KeyTopic = null;
      this.TopicModelID_long = -1;
      this.StatusKeyRename = false;
      this.ModelFirst = "-";
      this.TopicName = "";
      this.TopicModelID = "";
      this.Log_History_TopicID = -1;
    },
    _initSnippetParam() {
      if (this.parameterURL.snippet != undefined) {
        let snippet_temp = this.parameterURL.snippet;
        this.snipet_flag = this.normalizeSnippetFlag(snippet_temp);
        sessionStorage.setItem("snippet", snippet_temp);
      } else if (
        sessionStorage.getItem("snippet") != undefined &&
        sessionStorage.getItem("snippet") != null
      ) {
        this.snipet_flag = this.normalizeSnippetFlag(sessionStorage.getItem("snippet"));
      } else {
        sessionStorage.setItem("snippet", false);
      }
    },
    _initDomainParam() {
      if (this.parameterURL.domainname != undefined) {
        let Domain = this.parameterURL.domainname;
        this.URL_Domain = Domain;
        sessionStorage.setItem("Domain", Domain);
      } else if (
        sessionStorage.getItem("Domain") != undefined &&
        sessionStorage.getItem("Domain") != null
      ) {
        this.URL_Domain = sessionStorage.getItem("Domain");
      }
    },
    _initModelIdParam() {
      if (this.parameterURL.modelid != undefined) {
        let modelDisplayID = this.parameterURL.modelid;
        this.modelDisplayID = modelDisplayID;
        sessionStorage.setItem("modelID", modelDisplayID);
      } else if (
        sessionStorage.getItem("modelID") != undefined &&
        sessionStorage.getItem("modelID") != null &&
        sessionStorage.getItem("modelID") != ""
      ) {
        this.modelDisplayID = sessionStorage.getItem("modelID");
      }
    },
    // Param-init helpers (sessioncontinuity / user_ch / chk_token) moved byte-identical to
    // src/mixins/snippetIdentityPersistenceMixin.js under their applySnippet* names.
    _initSnippetTokenAuth() {
      if (
        sessionStorage.getItem("token_Snippet") != null ||
        localStorage.getItem("token_Snippet") != null ||
        Cookies.get("token_Snippet") != null
      ) {
        if (sessionStorage.getItem("token_Snippet") != null) {
          this.auth_token_local = sessionStorage.getItem("token_Snippet");
          this.User_Id = sessionStorage.getItem("email_Snippet");
          this.username = sessionStorage.getItem("username_Snippet");
          this.auth_token = this.auth_token_local;
        } else if (Cookies.get("token_Snippet") != null) {
          this.auth_token_local = Cookies.get("token_Snippet");
          this.User_Id = Cookies.get("email_Snippet");
          this.username = Cookies.get("username_Snippet");
          this.auth_token = this.auth_token_local;
        } else if (localStorage.getItem("token_Snippet") != null) {
          this.auth_token_local = localStorage.getItem("token_Snippet");
          this.User_Id = localStorage.getItem("email_Snippet");
          this.username = localStorage.getItem("username_Snippet");
          this.auth_token = this.auth_token_local;
        }
        this.GetModelQuickGroupInModelGroupPostToken();
        this.GetTopicFullStream("Start");
      } else if (
          sessionStorage.getItem("userChanel") != undefined &&
          sessionStorage.getItem("userChanel") != null &&
          sessionStorage.getItem("userChanel") != "" &&
          sessionStorage.getItem("userChanel") != "null"
        ) {
          this.userChanel = sessionStorage.getItem("userChanel");
          this.User_Id_Show = sessionStorage.getItem("userChanel");
          this.User_Id = sessionStorage.getItem("userChanel");
          // userId ที่เว็บส่ง/restore มา ต้องโหลด history เอง (GetUuidv4 จะ skip เพราะ User_Id ไม่ว่าง)
          this.GetTopicFullStream("Start");
        } else {
          this.GetUuidv4();
        }
    },
    _initSnippetMode() {
      seedLineSsoSnippetStorage(this.parameterURL, Cookies);
      this._initSnippetParam();
      this._initDomainParam();
      this._initModelIdParam();
      this.applySnippetSessionContinuityParam();
      this.applySnippetUserChannelParam();
      this.applySnippetTokenParam();
      this._initSnippetTokenAuth();
      this.Status_Error = false;
      this.snippet_Status = true;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
    if (this.$refs.MainScrollArea) {
      this.$refs.MainScrollArea.removeEventListener(
        "scroll",
        this.checkScrollPosition
      );
    }
  },
  async mounted() {
    this.GetDDGroupReplaceDB_FullStream();
    this.onScroll();
    this.Loading_History_Status = true;
    this.flagGetAllTopic = false;
    // ตรวจสอบทันทีที่ mount (เผื่อหน้าต่างเล็ฝ/ใหฝ่)
    this.checkOverflow();
    // ลองฟัง event resize เพื่อเช็คเมื่อหน้าต่างถูฝย่อ/ขยาย
    window.addEventListener("resize", this.checkOverflow);
    this.SessionID = this.GetUuidv4_Fun();
    if (
      sessionStorage.getItem("Domain") != undefined &&
      sessionStorage.getItem("Domain") != null &&
      sessionStorage.getItem("Domain") != "null"
    ) {
      this.URL_Domain = sessionStorage.getItem("Domain");
    }
    if (
      sessionStorage.getItem("snippet") != undefined &&
      sessionStorage.getItem("snippet") != null
    ) {
      this.snipet_flag = this.normalizeSnippetFlag(sessionStorage.getItem("snippet"));
    }
    if (
      sessionStorage.getItem("modelID") != undefined &&
      sessionStorage.getItem("modelID") != null &&
      sessionStorage.getItem("modelID") != "null"
    ) {
      this.modelDisplayID = sessionStorage.getItem("modelID");
    }
    if (
      sessionStorage.getItem("userChanel") != undefined &&
      sessionStorage.getItem("userChanel") != null &&
      sessionStorage.getItem("userChanel") != "null"
    ) {
      this.userChanel = sessionStorage.getItem("userChanel");
    }
    if (
      sessionStorage.getItem("tokenParam") != undefined &&
      sessionStorage.getItem("tokenParam") != null &&
      sessionStorage.getItem("tokenParam") != "null"
    ) {
      this.tokenParam = sessionStorage.getItem("tokenParam");
    }

    this.$nextTick(async () => {
      this._initMountedStateVars();
      for (let key in this.$route.query) {
        this.parameterURL[key.toLowerCase()] = this.$route.query[key];
      }
      if (this.parameterURL.snippet == "true") {
        this._initSnippetMode();
      } else {
        this.URL_Domain = "";
        if (
          this.parameterURL.auth_token == null ||
          this.parameterURL.auth_token == undefined ||
          this.parameterURL.auth_token == ""
        ) {
          this.Status_Error = true;
          this.Text_Status = "à¹„à¸¡à¹ˆà¸žà¸š token";
          return;
        } else {
          this.auth_token_local = this.parameterURL.auth_token;
          this.auth_token = this.parameterURL.auth_token;
          await this.CHK_Auth_Token();

        }
      }
      this.$nextTick(() => {
        if (this.$refs.MainScrollArea) {
          this.$refs.MainScrollArea.addEventListener(
            "scroll",
            this.checkScrollPosition
          );
          // Initial check
          this.checkScrollPosition();
        }
      });
    });
    if (this.$route.query.name) {
      this.requestVector.searchVectorDBName2 = this.$route.query.name;
      this.showTable = true;
      this.actionEdit = true;
      this.flagNew = false;
    } else {
      this.dataUpdate = 0;
      this.GetMaxLimitedCharacter();
    }
    if (this.requestVector.MaxLimitedCharacter == null) {
      this.ReFresh();
    }
  },
  beforeUpdate() {
    if (!this.loadColor) {
      this.Themecolor();
      this.loadSvg();
    }
  },
};
</script>

<style scoped>
.custom-footer {
  position: sticky;
  bottom: 0 !important;
  width: 100%;
  height: auto !important;
}

@keyframes blinker {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* .blink-cursor{ */
.blinking-cursor {
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
  animation-name: blinker;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}

.btn_PrivateMemoryDialog_ListFile .col-6 button {
  width: 100%;
}

@media (min-width: 600px) {

  .btn_PrivateMemoryDialog_ListFile .col-sm-6 button,
  .btn_PrivateMemoryDialog_ListFile .col-md-6 button {
    width: 120px;
  }

  .btn_PrivateMemoryDialog_ListFile .row {
    display: inline-flex;
  }
}

.v_data_table_Private_Memory .v-data-table__empty-wrapper td {
  text-align: center;
}

.Cls_Text_field_TopicName {
  padding-top: 0px;
  height: 32px;
  z-index: 99999;
  display: flex;
}

.Cls_Text_field_TopicName .v-input__slot {
  background-color: white !important;
  min-height: 32px !important;
}

.Cls_Text_field_TopicName input {
  font-size: 15px;
}

.FullStream_Status_Margin {
  position: fixed;
  margin-top: calc(60px);
}

.FullStream_Status_Margin2 {
  height: calc(100dvh - 112px);
}

.Snippet_StatusData_Margin {
  height: 100% !important;
}

.Snippet_StatusData_Margin #Col_Snippet {
  margin-bottom: 0px !important;
}

.Snippet_StatusData_Margin #D_MessageData {
  max-height: 83px !important;
  font-size: 12px;
  margin-bottom: 12px;
}

#V_markDown {
  display: grid;
}

#V_markDown p {
  margin: 0;
  display: block;
}

#V_markDown table {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0;
}

#V_markDown tr {
  border-top: 1px solid #c6cbd1;
  background: #fff;
}

#V_markDown td,
#V_markDown th {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

#V_markDown table tr:nth-child(2n) {
  background: #f6f8fa;
}

#V_markDown li code,
#V_markDown p code {
  background-color: transparent;
  color: blue;
}

#V_markDown code.language-markdown,
#V_markDown pre code {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff;
}

#V_markDown code {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff;
}

#V_markDown pre code {
  margin: 10px 0px;
}

#V_markDown img {
  max-width: 100%;
  max-height: 320px;
}

#V_markDown ul.contains-task-list li {
  margin-top: -20px;
}

#V_markDown br {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%;
}

#V_markDown li {
  margin-top: -1em;
}

#V_markDown li p {
  margin-top: -22px;
}

#V_markDown li p strong {
  margin-top: 0px;
  display: block;
}

#V_markDown ul {
  margin-bottom: -20px;
}

#V_markDown ol li ul {
  margin-bottom: -40px;
}

#V_markDown h1,
#V_markDown h2,
#V_markDown h3,
#V_markDown h4,
#V_markDown h5 {
  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

#V_markDown ol {
  margin-bottom: -25px;
}

#V_markDown blockquote {
  margin-top: -35px;
}

#V_markDown .container {
  margin-top: 0px;
}

#ModelQuickId::-webkit-scrollbar,
#Editdialog_ID::-webkit-scrollbar {
  height: 10px;
}

#Editdialog_ID::-webkit-scrollbar,
#PrivateMemory::-webkit-scrollbar,
#PrivateMemory_ListFile::-webkit-scrollbar,
#ChatScreId::-webkit-scrollbar,
#ModelQuickId::-webkit-scrollbar,
#toppic_list_id::-webkit-scrollbar,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px;
}

#Editdialog_ID::-webkit-scrollbar-track,
#PrivateMemory::-webkit-scrollbar-track,
#PrivateMemory_ListFile::-webkit-scrollbar-track,
#ChatScreId::-webkit-scrollbar-track,
#ModelQuickId::-webkit-scrollbar-track,
#toppic_list_id::-webkit-scrollbar-track,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-track {
  background-color: gainsboro;
  border-radius: 5px;
}

#Editdialog_ID::-webkit-scrollbar-thumb,
#PrivateMemory::-webkit-scrollbar-thumb,
#PrivateMemory_ListFile::-webkit-scrollbar-thumb,
#ChatScreId::-webkit-scrollbar-thumb,
#ModelQuickId::-webkit-scrollbar-thumb,
#toppic_list_id::-webkit-scrollbar-thumb,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: rgb(0, 78, 140);
  border-radius: 5px;
}

@media only screen and (min-width: 1263px) {
  .widthNav {
    padding: 0px 0px 0px 0px;
  }
}

.v-navigation-drawer {
  border-radius: 0px 5px 5px 0px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}

/* ปรับ v-col ที่เป็น container-chat */
.v-col.container-chat {
  height: 100vh !important;
  max-height: 100vh !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
}

/* Responsive สำหรับหน้าจอเล็ฝ */
@media (max-width: 768px) {
  .container-chat {
    grid-template-rows: 56px 1fr auto auto;
    /* หน้าจอเล็ฝใช้ 56px */
  }

  v-row[style*="grid-area: header"] {
    height: 56px !important;
    min-height: 56px !important;
    max-height: 56px !important;
  }
}

::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}
</style>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card {
  border-radius: 10px !important;
  height: 90dvh;
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}

.v-text-field .v-input__append-inner {
  align-self: end !important;
}

.textarea-container {
  position: sticky;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* counter text-area */
.icon-container {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.icon-container-mobile {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.v-textarea__slot {
  padding: 10px;
  /* à¸›à¸£à¸±à¸šà¸„à¹ˆà¸²à¸•à¸²à¸¡à¸—à¸µà¹ˆà¸•à¹‰à¸­à¸‡à¸�à¸²à¸£ */
}

.custom-textarea .v-input__slot {
  position: relative;
}

textarea.custom-textarea {
  max-height: 7rem;
}

:deep(.custom-textarea .v-input__control .v-input__slot .v-text-field__slot) {
  padding: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
}

/* menu text-area */
.custom-icon {
  position: relative;
  bottom: 0;
  right: 0;
}

.custom-icon-mobile {
  bottom: 0;
  right: 0;
}

:deep(.custom-textarea .v-input__prepend-outer) {
  margin-top: 10px !important;
}

:deep(.custom-textarea .v-input__append-outer) {
  margin-top: 0px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot textarea) {
  font-size: 16px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot fieldset) {
  background-color: #f6f8fa !important;
}

:deep(#book) {
  background-color: white !important;
}

.rounded-circle {
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.image-container {
  transition: 0.5s ease;
  position: absolute;
  top: 28%;
  right: 0.7%;
  width: 35px;
  height: 35px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 52%;
  left: 52%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.middle-progress {
  transition: 0.5s ease;
  position: absolute;
  top: 0%;
  left: 0%;
  color: rgb(247, 179, 78) !important;
  height: 35px !important;
  width: 35px !important;
}

.image-container:hover .middle {
  opacity: 1;
}

.delete-btn {
  background-color: rgb(247, 179, 78, 0.5) !important;
  color: #333333;
  font-size: 16px;
  height: 35px !important;
  width: 35px !important;
}

ul[data-checked="true"] {
  background-color: green;
}

.responsive-table td {
  white-space: nowrap;
  /* Prevent line breaks within cells */
  overflow: hidden;
  /* Hide overflowed content */
  text-overflow: ellipsis;
  /* Show ellipsis for overflowed content */
  overflow-wrap: anywhere;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;

  /* margin-right: 8px; Adjust space between text and button if needed */
}

.text-content-show {
  overflow: hidden;
  /*-webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

/* HTML: <div class="cloader"></div> */
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation-name: bblFadInOut;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.loader {
  color: #ffd000;
  font-size: 5px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.1s;
}

.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}

.loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}

.loader:after {
  left: 3.5em;
}

@keyframes bblFadInOut {

  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

.content-button {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Standard syntax */
  transition: box-shadow 0.3s ease;
}

.content-button:hover {
  box-shadow: 5px 5px 10px -5px rgba(0, 0, 0, 0.15) !important;
}

.content-button.v-card--link:focus::before {
  opacity: 0;
}

.container-chat {
  height: 100vh !important;
  max-height: 100vh !important;
  display: grid !important;
  grid-template-columns: 80dvw 10dvw 5dvw;
  grid-template-rows: auto 1fr auto auto;
  grid-template-areas:
    "header header header"
    "main main main"
    "products products products"
    "footer footer footer";
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
  align-content: space-between;
  justify-content: space-between;
  gap: 0;
}

v-row[style*="grid-area: header"] {
  grid-area: header;
  height: 64px !important;
  /* เพิ่มความสูงเป็น 64px */
  min-height: 64px !important;
  max-height: 64px !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0;
  border-bottom: 1px solid #e0e0e0;
  /* เพิ่มเส้นขอบด้านล่าง */
}

v-row[style*="grid-area: main"] {
  grid-area: main;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  min-height: 0;
}

/* à¸�à¸³à¸«à¸™à¸” container à¸«à¸¥à¸±à¸�à¹ƒà¸«à¹‰ position: relative
   à¹€à¸žà¸·à¹ˆà¸­à¸ˆà¸°à¸§à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ (position: absolute) à¸—à¸±à¸š */
.carousel-container {
  position: relative;
  /* à¹€à¸žà¸·à¹ˆà¸­à¹ƒà¸«à¹‰à¸›à¸¸à¹ˆà¸¡à¸›à¸£à¸²à¸�à¸�à¹€à¸‰à¸žà¸²à¸°à¹€à¸¡à¸·à¹ˆà¸­ hover */
  max-width: calc(300px * 3 + 100px);
}

.carousel-container:hover .scroll-btn {
  opacity: 1;
  /* à¹‚à¸Šà¸§à¹Œà¸›à¸¸à¹ˆà¸¡à¹€à¸¡à¸·à¹ˆà¸­ hover */
}

.carousel-track {
  scroll-behavior: smooth;
  max-width: calc(300px * 3);
  gap: 24px;
}

/* à¸›à¸¸à¹ˆà¸¡à¹€à¸¥à¸·à¹ˆà¸­à¸™à¸‹à¹‰à¸²à¸¢/à¸‚à¸§à¸²à¹€à¸«à¸¡à¸·à¸­à¸™ carousel */
.scroll-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  /* à¸ˆà¸±à¸”à¹ƒà¸«à¹‰à¸­à¸¢à¸¹à¹ˆà¸�à¸¶à¹ˆà¸‡à¸�à¸¥à¸²à¸‡à¹�à¸™à¸§à¸•à¸±à¹‰à¸‡ */
  margin-bottom: auto;
  /* à¸ˆà¸±à¸”à¹ƒà¸«à¹‰à¸­à¸¢à¸¹à¹ˆà¸�à¸¶à¹ˆà¸‡à¸�à¸¥à¸²à¸‡à¹�à¸™à¸§à¸•à¸±à¹‰à¸‡ */
  width: 48px;
  /* à¸„à¸§à¸²à¸¡à¸�à¸§à¹‰à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ */
  height: 48px;
  /* à¸„à¸§à¸²à¸¡à¸�à¸§à¹‰à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ */
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.1);
  color: #fff;
  cursor: pointer;

  /* à¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸²à¹€à¸£à¸´à¹ˆà¸¡à¸•à¹‰à¸™à¹ƒà¸«à¹‰à¸›à¸¸à¹ˆà¸¡à¹€à¸›à¹‡à¸™à¹‚à¸›à¸£à¹ˆà¸‡à¹ƒà¸ª à¹�à¸¥à¹‰à¸§à¸„à¹ˆà¸­à¸¢à¹‚à¸œà¸¥à¹ˆà¸¡à¸²à¹€à¸¡à¸·à¹ˆà¸­ hover */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scroll-btn:first-of-type {
  left: calc(0%);
}

.scroll-btn:last-of-type {
  right: calc(0%);
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

.minimal-fab {
  box-shadow: none !important;
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
  margin-left: 4px;
  border: 0 !important;
  background-color: transparent !important;
}

.minimal-fab .v-icon {
  font-size: 16px;
  color: #71717a;
}

/* product card */

.product-recommendations {
  margin: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 12px;
  animation: fadeIn 0.5s ease-out;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.product-title {
  margin: 0;
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
}

.product-title::before {
  content: "";
  width: 4px;
  height: 16px;
  background-color: var(--v-primary-base);
  margin-right: 8px;
  display: inline-block;
  border-radius: 2px;
}

.product-carousel {
  padding: 12px 16px;
}

.product-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 5px 0 16px 10px;
}

.product-item {
  flex: 0 0 auto;
  margin-right: 12px;
  width: 250px;
}

.product-card-compact {
  display: flex;
  height: 100px;
  position: relative;
  cursor: pointer;
}

.product-img-container {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 10px;
}

.product-thumbnail {
  border-radius: 4px;
  object-fit: cover;
}

.product-info {
  flex: 1;
  padding: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name-compact {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  max-height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  color: var(--v-primary-base);
  font-weight: 600;
  font-size: 14px;
}

.product-interest-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.product-full-description {
  white-space: pre-line;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Update chat container to allow for proper space */
#ChatScreId {
  width: 100%;
  overflow-x: hidden;
  flex-grow: 1;
  display: flex;
  height: 100% !important;
  max-height: 100% !important;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 0 !important;
  padding-bottom: 16px;
}

/* Adjust row styling to remove margins */
v-row[style*="grid-area: products"] {
  grid-area: products;
  margin: 0 !important;
  padding: 0 !important;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  z-index: 5;
}

/* Fix the textarea container top margin */
v-row[style*="grid-area: footer"] {
  grid-area: footer;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

:deep(.v-footer) {
  overflow: visible !important;
}

/* Modern chatbox container */
.textarea-container-modern {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: visible;
  position: relative;
  width: 80%;
  max-height: 300px !important;
}

/* Modern chatbox wrapper */
.chatbox-modern-wrapper {
  width: 100%;
  position: relative;
  animation: slideInUp 0.5s ease-out;
}

/* Modern chatbox styling */
.chatbox-modern {
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

:deep(.chatbox-modern .v-input__control) {
  min-height: 56px !important;
}

:deep(.chatbox-modern .v-input__slot) {
  border-radius: 20px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease;
}

:deep(.chatbox-modern .v-input__slot:hover) {
  border-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

:deep(.chatbox-modern.v-input--is-focused .v-input__slot) {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 0 3px rgba(var(--v-primary-base), 0.1),
    0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

:deep(.chatbox-modern .v-text-field__slot) {
  padding: 16px 20px !important;
}

:deep(.chatbox-modern textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  color: #333 !important;
}

/* Input label modern styling */
.input-label-modern {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 8px;
  backdrop-filter: blur(5px);
}

/* Model menu modern styling */
.model-menu-wrapper {
  margin-right: 8px;
}

.model-selector-btn {
  box-shadow: none !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.82) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.model-selector-btn :deep(.v-btn__overlay) {
  background-color: transparent !important;
}

.model-selector-btn:hover {
  transform: translateY(-1px);
  box-shadow: none !important;
  background-color: #ffffff !important;
  border-color: color-mix(in srgb, var(--model-accent-color, #ffa41e) 35%, transparent) !important;
}

.model-selector-icon {
  width: 20px;
  height: 20px;
}

.model-selector-trigger {
  box-shadow: none !important;
  min-width: 92px !important;
  width: auto !important;
  height: 36px !important;
  padding: 0 12px !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.82) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}

.model-selector-trigger :deep(.v-btn__overlay) {
  background-color: transparent !important;
}

.model-selector-trigger__content {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.model-selector-trigger__icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.model-selector-trigger__label {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #475569;
}

.model-selector-trigger:hover,
.model-selector-trigger--active {
  transform: translateY(-1px);
  box-shadow: none !important;
  background-color: #ffffff !important;
  border-color: color-mix(in srgb, var(--model-accent-color, #ffa41e) 35%, transparent) !important;
}

.model-selector-trigger--readonly {
  cursor: default !important;
  pointer-events: none;
}

.model-selector-trigger--readonly:hover {
  transform: none;
  background: rgba(255, 255, 255, 0.82) !important;
  border-color: rgba(15, 23, 42, 0.08) !important;
}

.model-selector-trigger__chevron {
  color: #94a3b8;
  flex-shrink: 0;
}

.dialog-header-icon {
  width: 32px;
  height: 32px;
  color: #ffffff;
}

.model-menu-card {
  border-radius: 16px !important;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.model-item-modern {
  transition: all 0.2s ease;
  border-radius: 12px !important;
}

.model-item-modern:hover {
  background: linear-gradient(135deg,
      var(--v-primary-base),
      var(--v-secondary-base)) !important;
  color: white !important;
  transform: translateX(4px);
}

.model-item-modern:hover .model-name,
.model-item-modern:hover .v-icon {
  color: white !important;
}

.model-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 18px;
  height: 18px;
}


.model-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.model-name {
  font-weight: 500;
  font-size: 14px;
}

/* Character counter modern styling */
.character-counter-modern {
  position: absolute;
  bottom: 8px;
  right: 80px;
}

.counter-chip {
  opacity: 0.8;
  transition: all 0.3s ease;
}

.counter-chip:hover {
  opacity: 1;
}

/* Action buttons modern styling */
.chatbox-actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
}

.chatbox-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.action-btn-modern {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease !important;
}

.action-btn-modern:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.action-btn-modern:disabled {
  opacity: 0.4 !important;
  transform: none !important;
}

.attachment-btn {
  background: linear-gradient(135deg, #667eea, #764ba2) !important;
}

.clear-btn {
  background: linear-gradient(135deg, #f093fb, #f5576c) !important;
}

.send-btn-modern {
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s ease !important;
}

.send-btn-modern:hover {
  transform: translateY(-2px) scale(1.05);
}

.stop-btn-modern {
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s ease !important;
}

.stop-btn-modern:hover {
  transform: translateY(-2px) scale(1.05);
}

/* Attachment preview modern styling */
.attachment-preview-modern {
  align-self: flex-start;
}

.attachment-image-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-height: 40px;
  max-width: 100px;
  border-radius: 4px;
}

.attachment-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.attachment-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px !important;
  height: 24px !important;
  background: rgba(0, 0, 0, 0.6) !important;
}

/* File preview modern styling */
.file-preview-modern {
  align-self: flex-start;
  width: 100%;
  max-width: 320px;
}

.file-info-wrapper {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 12px;
  backdrop-filter: blur(10px);
  gap: 12px;
}

.file-icon-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-type-icon {
  width: 32px;
  height: 32px;
  transition: all 0.3s ease;
}

.file-progress-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-progress-bar {
  border-radius: 2px;
}

.file-close-btn {
  width: 24px !important;
  height: 24px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

/* Attachment menu modern styling */
.attachment-menu-card {
  border-radius: 16px !important;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.attachment-menu-item {
  transition: all 0.2s ease;
  margin-bottom: 4px;
}

.attachment-menu-item:hover {
  background: linear-gradient(135deg,
      var(--v-primary-base),
      var(--v-secondary-base)) !important;
  color: white !important;
  transform: translateX(4px);
}

.attachment-menu-item:hover .attachment-item-title,
.attachment-menu-item:hover .v-icon {
  color: white !important;
}

.attachment-item-title {
  font-size: 14px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {

  .chatbox-actions-left,
  .chatbox-actions-right {
    gap: 4px;
  }

  .send-btn-modern,
  .stop-btn-modern {
    width: 40px !important;
    height: 40px !important;
  }

  .file-info-wrapper {
    padding: 8px;
  }

  .character-counter-modern {
    right: 60px;
  }
}

/* Animation for smooth transitions */
@keyframes slideInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.new-input-bar {
  display: flex;
  flex-direction: column !important;
  justify-content: flex-end;
  background-color: #b69143;
  border-radius: 24px;
  padding: 10px 12px;
  margin: 8px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  gap: 12px;
  transition: height 0.2s ease-out;
  width: 100%;
  height: auto;
  max-height: 300px !important;
}

.input-bar-preview-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* ระยะห่างระหว่าง previews ถ้ามีหลายอัน */
}

/* Styles for individual previews to look like chips */
.attachment-preview-modern,
.file-preview-modern {
  background-color: #f0f2f5;
  /* สีพื้นหลังอ่อนๆ สำหรับ preview chip */
  border-radius: 12px;
  padding: 8px 12px;
  display: flex;
  /* For internal alignment */
  align-items: center;
  position: relative;
  /* For progress bar positioning in file preview */
  overflow: hidden;
  /* Ensure progress bar stays within rounded corners */
}

.attachment-close-btn-light {
  background-color: #d8dadd !important;
  color: #33363b !important;
}

.attachment-close-btn-light .v-icon {
  color: #5f6368 !important;
}

.file-info-wrapper-light {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
}

.file-type-icon-light {
  width: 32px;
  /* ขนาดไอคอนไฟล์ */
  height: 32px;
  object-fit: contain;
}

.file-details-light {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  /* Prevent long filenames from breaking layout */
}

.file-name-light {
  font-size: 0.875rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-type-description {
  font-size: 0.75rem;
  color: #666;
}

.file-close-btn-light {
  color: #5f6368 !important;
  background-color: transparent !important;
}

.file-close-btn-light .v-icon {
  color: #5f6368 !important;
}

.file-progress-bar-light {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0 0 12px 12px !important;
  /* Match parent's bottom radius */
}

.attachment-progress,
.file-progress-overlay-light {
  color: #007bff !important;
  /* สีของ progress spinner */
}

.input-actions-left,
.input-actions-right {
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 9px;
  flex-shrink: 0;
}

.chatbox-redesigned :deep(.v-field) {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  font-size: 20px;
  max-height: 100px !important;
  overflow-y: auto !important;
}

.chatbox-redesigned :deep(.v-field__outline) {
  border: none !important;
  opacity: 0 !important;
}

.chatbox-redesigned :deep(.v-field__overlay) {
  background-color: transparent !important;
  opacity: 0 !important;
}

.chatbox-redesigned :deep(.v-field__field) {
  border: none !important;
  background-color: transparent !important;
}

/* Remove all focus states */
.chatbox-redesigned :deep(.v-field--focused) {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.chatbox-redesigned :deep(.v-field--focused .v-field__outline) {
  border: none !important;
  opacity: 0 !important;
}

/* Remove any default input control styling */
.chatbox-redesigned :deep(.v-input__control) {
  min-height: auto !important;
  background-color: transparent !important;
}

.chatbox-redesigned :deep(.v-input__slot) {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.input-bar-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.action-btn-flat {
  color: #5f6368 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 38px;
  /* ขนาดปุ่มขั้นต่ำ */
  height: 38px;
  padding: 0 8px;
  /* Padding สำหรับปุ่มที่มีข้อความ */
}

.action-btn-flat.tools-btn .v-icon {
  /* สำหรับปุ่ม Tools ที่มี icon ๝ละ text */
  margin-right: 4px;
}

.action-btn-flat:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  /* สีพื้นหลังเมื่อ hover */
}

.action-btn-flat .v-icon {
  font-size: 20px;
}

.send-btn-redesigned.v-btn--fab.v-btn--size-small {
  height: 38px !important;
  width: 38px !important;
  min-width: 38px !important;
}

.send-btn-redesigned.v-btn--fab .v-icon {
  font-size: 20px;
}

/* Main ChatGPT-style container */
.chatgpt-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* 1. ส่วนบนสุด (Fixed Top Div) */
.custom-fixed-top-area {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  inset-inline: 0;
  width: 100%px;
  background-color: white;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px 0 16px;
  margin: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  z-index: 10;
}

.fullstream-header-right {
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
}

.fullstream-header-label {
  max-width: min(100%, 560px);
  min-width: 0;
  gap: 8px;
  justify-content: flex-end;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  font-weight: 700;
}

.fullstream-header-model {
  flex-shrink: 0;
}

.fullstream-header-topic {
  min-width: 0;
  max-width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 2. ส่วนฝลาง (Scrollable Middle Content) */
.main-scrollable-content-area {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
  background-color: white;
}

/* Messages container (scrollable area) */
.messages-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

.messages-wrapper {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
}

.messages-scroll-area {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 24px;
  scroll-behavior: smooth;
}

.messages-content {
  min-height: 100%;
  width: min(100%, 920px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

.bot-message-bubble {
  min-width: min(100%, 180px);
  box-sizing: border-box;
}

.bot-message-bubble--error {
  min-width: min(100%, 180px);
}

.fullstream-quota-warning p {
  margin: 0;
}

.fullstream-quota-warning p + p {
  margin-top: 6px;
}

.bot-message-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  margin-right: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bot-message-actions-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
  margin-left: 50px;
}

.bot-message-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

/* Welcome screen styling */
.welcome-screen {
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 70vh;
  justify-content: center;
}

.welcome-content {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.welcome-subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  font-weight: 400;
  max-width: min(100%, 42rem);
  margin: 0 auto;
  white-space: normal;
  overflow-wrap: anywhere;
  overflow-wrap: break-word;
}


/* Product recommendations section */
.product-recommendations-section {
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  padding: 16px;
  margin: 0 16px;
  border-radius: 12px 12px 0 0;
  max-width: 100%;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.product-card {
  background: white;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  max-width: 100%;
  height: 100%;
}

.product-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.product-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}


.product-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 8px;
}

.container-product-image {
  width: 100%;
  height: 120px;
}

.no-product-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  margin-bottom: 8px;
  border-radius: 20px;
  background-color: #e5e7eb;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-description {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 640px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .product-image {
    height: 100px;
  }
}

@media (max-width: 400px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
}

.recommendations-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* Fixed bottom input container */
.fixed-input-container {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: white;
  padding: 0 16px;
  padding-bottom: 10px;
  z-index: 100;
  border-top: 0px solid #e0e0e0;
  box-shadow: 0 -24px 15px -5px rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-wrapper-chatgpt {
  width: min(100%, 880px);
  max-width: 880px;
  margin: 0 auto;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  margin-bottom: 20px;
  position: relative;
  /* ลบหรือคอมเมนต์บรรทัดนี้ออฝ ถ้ามีอยู่ */
}

.input-wrapper-chatgpt:focus-within {
  border-color: #0000007c;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* File preview container */
.file-preview-container {
  padding: 12px 16px 8px;
  border-bottom: 1px solid #e2e2e2;
  position: relative;
  margin-bottom: 12px;
  border-radius: 0px;
  background: transparent;
  box-shadow: none;
}

.file-preview-container:hover {
  transform: translateY(0px);
  box-shadow: none;
}

.image-preview-wrapper,
.file-preview-wrapper {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
}

.image-preview-card {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.preview-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  z-index: 3;
}

.file-preview-card {
  display: flex;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  max-width: 300px;
  position: relative;
  overflow: hidden;
}

.file-preview-content {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 12px;
}

.file-icon-section {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-info-section {
  flex: 1;
  min-width: 0;
}

.file-name-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  margin-bottom: 4px;
}

.file-upload-progress {
  border-radius: 2px;
  max-width: 80%;
}

.file-progress-section {
  width: 100%;
}

.file-progress-text,
.file-ready-text {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.2;
  color: #6b7280;
}

.file-progress-text {
  justify-content: space-between;
  max-width: 80%;
}

.file-ready-text {
  color: #16a34a;
  font-weight: 500;
}

/* Main input row */
.input-row-container {
  display: flex;
  align-items: flex-end;
  padding: 0px 12px;
  gap: 8px;
  min-height: 45px;
}

.input-action-btn {
  color: var(--fullstream-action-color, #6b7280) !important;
  transition: all 0.2s ease;
}

.input-action-btn:hover {
  background-color: color-mix(in srgb, currentColor 12%, transparent) !important;
}

.fullstream-input-icon {
  width: 20px;
  height: 20px;
}

.fullstream-input-icon--error {
  color: #dc2626;
}

/* Textarea container */
.textarea-container-chatgpt {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  align-self: flex-start;
  min-height: unset !important;
}

.chatgpt-textarea {
  background: transparent !important;
}

.chatgpt-textarea :deep(.v-input__control) {
  width: 100%;
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field__field) {
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field__input) {
  -webkit-mask-image: none !important;
  mask-image: none !important;
}

.chatgpt-textarea :deep(.v-field__outline) {
  display: none !important;
}

.chatgpt-textarea :deep(.v-field__overlay) {
  display: none !important;
}

.chatgpt-textarea :deep(textarea) {
  font-size: 16px !important;
  line-height: 1.4 !important;
  color: #374151 !important;
  border: none !important;
  outline: none !important;
  background: transparent !important;
  resize: none !important;
  overflow: hidden !important;
  overflow-y: auto !important;
  height: auto !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar) {
  width: 5px !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar-thumb) {
  background-color: #b4c7d6 !important;
  border-radius: 3px !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar-track) {
  background-color: transparent !important;
}

.chatgpt-textarea :deep(textarea::placeholder) {
  color: #000000 !important;
  font-size: 16px !important;
}

/* Send button */
.send-button-chatgpt {
  background-color: #374151 !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
}

.send-button-chatgpt:hover {
  background-color: #1f2937 !important;
  transform: scale(1.05);
}

.send-button-chatgpt:disabled {
  background-color: #d1d5db !important;
  color: #4b5563 !important;
  transform: none !important;
}

/* Stop button - inherit from send button */
.stop-button-variant {
  background-color: var(--send-color) !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--send-color) 28%, transparent) !important;
}

.stop-button-variant:hover {
  background-color: color-mix(in srgb, var(--send-color) 88%, #0f172a) !important;
  transform: scale(1.05);
}

.stop-button-variant:disabled {
  background-color: #d1d5db !important;
  color: #4b5563 !important;
  transform: none !important;
}

.send-button-chatgpt.themed-send-button {
  background-color: var(--send-color) !important;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--send-color) 28%, transparent) !important;
}

.send-button-chatgpt.themed-send-button:hover {
  background-color: color-mix(in srgb, var(--send-color) 88%, #0f172a) !important;
}

/* Skip button - inherit from send button */
.skip-button-variant {
  background-color: var(--send-color) !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--send-color) 28%, transparent) !important;
}

.skip-button-variant:hover {
  background-color: color-mix(in srgb, var(--send-color) 88%, #0f172a) !important;
  transform: scale(1.05);
}

.skip-button-variant:disabled {
  background-color: #d1d5db !important;
  color: #4b5563 !important;
  transform: none !important;
}

.reasoning-effort-trigger {
  box-shadow: none !important;
  min-width: 92px !important;
  width: auto !important;
  height: 36px !important;
  padding: 0 10px !important;
  border-radius: 999px !important;
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white) !important;
  border: 1px solid color-mix(in srgb, var(--reasoning-tone-color, #64748b) 24%, rgba(15, 23, 42, 0.08)) !important;
}

.reasoning-effort-trigger :deep(.v-btn__overlay) {
  background-color: transparent !important;
}

.reasoning-effort-trigger__content {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.reasoning-effort-trigger__icon {
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-trigger__label {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-trigger__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--reasoning-tone-color, #64748b);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--reasoning-tone-color, #64748b) 18%, white);
}

.reasoning-effort-trigger:hover,
.reasoning-effort-trigger--active {
  transform: translateY(-1px);
  box-shadow: none !important;
  background-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 14%, white) !important;
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 34%, rgba(15, 23, 42, 0.08)) !important;
}

.reasoning-effort-menu {
  width: min(268px, calc(100vw - 24px));
  padding: 10px;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background:
    radial-gradient(circle at top left, color-mix(in srgb, var(--reasoning-accent-color, #ffa41e) 9%, white) 0%, rgba(255, 255, 255, 0) 38%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(250, 250, 250, 0.98));
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.1) !important;
}

.reasoning-effort-menu__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  padding: 2px 2px 0;
}

.reasoning-effort-menu__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.reasoning-effort-menu__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  color: var(--reasoning-tone-color, #64748b);
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white);
  border: 1px solid color-mix(in srgb, var(--reasoning-tone-color, #64748b) 24%, rgba(148, 163, 184, 0.18));
}

.reasoning-effort-menu__options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reasoning-effort-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.reasoning-effort-option:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 35%, rgba(148, 163, 184, 0.18));
  background: linear-gradient(180deg, rgba(255, 255, 255, 1), color-mix(in srgb, var(--reasoning-tone-color, #64748b) 4%, white));
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
}

.reasoning-effort-option--active {
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 50%, rgba(148, 163, 184, 0.24));
  background: linear-gradient(180deg, color-mix(in srgb, var(--reasoning-tone-color, #64748b) 8%, white), rgba(255, 255, 255, 0.98));
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.07);
}

.reasoning-effort-option__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white);
  color: var(--reasoning-tone-color, #64748b);
  transition: background 0.18s ease, color 0.18s ease;
}

.reasoning-effort-option--active .reasoning-effort-option__icon {
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 18%, white);
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-option__copy {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.reasoning-effort-option__label {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.reasoning-effort-option__meta {
  font-size: 11px;
  line-height: 1.3;
  color: #64748b;
}

.reasoning-effort-option__status {
  margin-left: auto;
  flex-shrink: 0;
  color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 45%, #cbd5e1);
  transition: color 0.18s ease, transform 0.18s ease;
}

.reasoning-effort-option--active .reasoning-effort-option__status {
  color: var(--reasoning-tone-color, #64748b);
}

@media (max-width: 600px) {
  .reasoning-effort-option {
    padding: 10px 11px;
  }
}

/* Attachment and model menus */
.attachment-menu,
.model-selection-menu {
  border-radius: 16px !important;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

.attachment-list,
.model-list {
  padding: 8px !important;
}

.attachment-list-item,
.model-list-item {
  border-radius: 8px !important;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.attachment-list-item:hover,
.model-list-item:hover {
  background-color: #f3f4f6 !important;
}

.attachment-item-text,
.model-name-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.model-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.model-expand-item {
  border-top: 1px solid #e5e7eb;
  margin-top: 8px;
  padding-top: 8px;
}

/* AI disclaimer */
.footer-chatbox-section {
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding: 8px 16px;
  font-size: 12px;
  color: #6b7280;
}

.limit-input-text {
  font-size: 12px;
  color: #9ca3af;
  position: absolute;
  right: 50px;
  transform: translateX(50%);
  margin-bottom: -22px;
  bottom: 0;
}

.disclaimer-text {
  font-size: 12px;
  color: #9ca3af;
  position: absolute;
  left: 50%;
  width: 500px;
  transform: translateX(-50%);
  margin-bottom: -22px;
  bottom: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .bot-message-bubble,
  .bot-message-bubble--error {
    min-width: 100%;
  }

  .bot-message-actions-row {
    margin-top: 8px;
    margin-left: 0;
  }

  .input-wrapper-chatgpt {
    width: 100%;
    border-radius: 20px;
  }

  .fixed-input-container {
    padding: 16px 8px 12px;
  }

  .input-row-container {
    padding: 8px 12px;
    gap: 8px;
  }

  .input-actions-left,
  .input-actions-right {
    gap: 2px;
  }

  .send-button-chatgpt {
    width: 28px !important;
    height: 28px !important;
  }

  .chatgpt-textarea :deep(textarea) {
    font-size: 16px !important;
  }
}

@media (max-width: 480px) {
  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-subtitle {
    font-size: 1rem;
  }
  .product-grid {
    grid-template-columns: 1fr;
  }

  .disclaimer-text {
    font-size: 10px;
    width: 160px;
    bottom: -6px;
    line-height: 1;
  }
}

.modern-dialog :deep(.v-overlay__content) {
  margin: 24px;
}

.upload-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #60aaff 100%);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  pointer-events: none;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.header-content {
  flex: 1;
  color: white;
  z-index: 1;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
  color: white;
}

.dialog-content {
  padding: 32px 24px !important;
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.language-selector :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.language-selector :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.language-selector :deep(.v-field--focused) {
  box-shadow: 0 0 0 3px rgba(103, 126, 234, 0.1), 0 4px 12px rgba(0, 0, 0, 0.12);
}

.language-selector :deep(.v-field__outline) {
  border-color: #e5e7eb;
}

.language-selector :deep(.v-field--focused .v-field__outline) {
  border-color: #667eea;
  border-width: 2px;
}

.dialog-actions {
  padding: 16px 24px 24px !important;
  gap: 12px;
}

.lang-action-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 12px 20px !important;
  min-width: 100px;
  transition: all 0.3s ease !important;
}

.secondary-btn {
  border-color: #d1d5db !important;
  color: #6b7280 !important;
}

.secondary-btn:hover {
  background-color: #f9fafb !important;
  border-color: #9ca3af !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.primary-btn {
  background: linear-gradient(135deg, #3949c0 0%, #2a66c4 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(103, 126, 234, 0.3) !important;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(103, 126, 234, 0.4) !important;
}

.primary-btn:active {
  transform: translateY(0);
}

/* Animation for dialog entrance */
.modern-dialog :deep(.v-dialog-transition-enter-active),
.modern-dialog :deep(.v-dialog-transition-leave-active) {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modern-dialog :deep(.v-dialog-transition-enter-from) {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

.modern-dialog :deep(.v-dialog-transition-leave-to) {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

/* Responsive design */
@media (max-width: 600px) {
  .modern-dialog :deep(.v-overlay__content) {
    margin: 16px;
  }

  .dialog-header {
    padding: 20px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .dialog-content {
    padding: 24px 20px !important;
  }

  .dialog-actions {
    flex-direction: column;
    gap: 8px;
  }

  .lang-action-btn {
    width: 100%;
  }
}

.scroll-bottom-btn {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: -50px;
  right: 50%;
  z-index: 10;
  transform: translateX(50%);
  border-radius: 20px;
  width: 40px !important;
  height: 40px !important;
  background-color: rgba(255, 255, 255, 0.967) !important;
  border: 1px solid rgba(0, 0, 0, 0.369);
  box-shadow: none;
  transition: box-shadow 0.3s ease;
}

.scroll-bottom-btn:hover {
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.3);
}

.model-card-container {
  position: relative;
  width: auto;
  min-width: 300px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18) !important;
}

.model-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px 8px;
}

.model-card-header-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: var(--model-accent-color, #ffa41e);
  background: color-mix(in srgb, var(--model-accent-color, #ffa41e) 13%, white);
}

.model-card-header-icon svg {
  width: 18px;
  height: 18px;
}

.model-card-header-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.model-card-header-text span {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.model-card-header-text small {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.2;
}

.model-list-container {
  scrollbar-width: thin;
}

.model-list-container::-webkit-scrollbar {
  width: 3px;
}

.model-list-container::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.15);
  border-radius: 1.5px;
}

.model-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.model-item:hover {
  background-color: color-mix(in srgb, var(--model-accent-color, #ffa41e) 8%, transparent) !important;
  transform: translateX(2px);
}

.model-item-active {
  background-color: rgba(0, 0, 0, 0.05);
}
.model-avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.model-avatar-icon {
  width: 11px;
  height: 11px;
  color: var(--model-accent-color, #ffa41e);
}

.model-search-icon,
.model-check-icon {
  width: 16px;
  height: 16px;
  color: var(--model-accent-color, #ffa41e);
}
.model-item.minimal {
  transition: all 0.15s ease-in-out;
  border-radius: 6px !important;
  margin: 2px 4px !important;
}

.model-item.minimal:hover {
  background-color: rgba(0,0,0,0.03) !important;
}

.model-content {
  flex-grow: 1;
}

.model-title {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.model-action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider-light {
  border-color: rgba(0,0,0,1) !important;
}

.model-view-toggle .v-input--selection-controls__input {
  margin-right: 0px;
}

.model-view-toggle .v-label {
  font-size: 12px !important;
  color: rgba(0,0,0,0.6) !important;
}
.modern-model-search :deep(.v-field) {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px !important; /* เล็ฝลง */
  min-height: 32px !important;
  border-radius: 8px !important; /* โค้งมนน้อยลง */
  background: #f8f9fa !important;
  border: 1px solid #e9ecef !important;
  box-shadow: none !important;
  width: 100% !important; /* เต็มความฝว้าง */
}
.modern-model-search :deep(.v-field__field) {
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  padding: 0 8px !important; /* padding เล็ฝลง */
}
.modern-model-search :deep(.v-field .v-icon) {
  color: rgb(163, 163, 163) !important;
}
.modern-model-search :deep(.v-field--focused) {
  border-color: var(--v-primary-base, #007bff) !important;
  background: #fff !important;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1) !important;
}
.modern-model-search :deep(input::placeholder) {
  font-size: 13px !important;
  color: #adb5bd !important;
}

.modern-model-search :deep(.v-field--focused .v-icon) {
  color: var(--v-primary-base, #007bff) !important;
}
.modern-model-search :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  font-size: 13px !important; /* ฟอนต์เล็ฝลง */
  color: #495057 !important;
  height: 32px !important;
  padding: 0 !important;
  min-height: 32px !important;
}
.modern-model-search :deep(.v-field .v-field__input) {
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
}
.modern-model-search :deep(.v-field__outline) {
  display: none !important;
}

.modern-model-search :deep(.v-field__overlay) {
  display: none !important;
}
.modern-model-search :deep(.v-field--focused .v-field--variant-filled .v-field__overlay) {
  background-color: transparent !important;
}
.modern-model-search :deep(.v-icon) {
  margin-left: 10px !important;
  font-size: 16px !important;
  color: #6c757d !important;
  margin-right: 4px !important;
}
.custom-card-actions {
  height: 30px !important;
  display: flex;
  align-items: center;
  padding: 4px 0px !important;
}

.model-view-toggle {
  transform: scale(0.8) !important; /* ลดขนาด checkbox */
  margin-left: -13px !important;
  margin-right: 4px !important;
}

.model-view-toggle :deep(.v-input--selection-controls__input) {
  margin-right: 2px !important;
}

.model-view-toggle :deep(.v-label) {
  font-size: 11px !important; /* ลดขนาดฟอนต์ */
  color: rgba(0,0,0,0.6) !important;
}

.model-view-toggle :deep(.v-icon) {
  font-size: 16px !important; /* ลดขนาด icon checkbox */
}

/* ปุ่ม Close เล็ฝลง */
.model-close-btn {
  font-size: 11px !important;
  min-width: 40px !important;
  padding-bottom: 5px;
  margin-right: 5px;
  background-color: transparent !important;
}

.frameloader {
  width: 160px;
  aspect-ratio: 1;
  border-radius: 8px;
  background:
    linear-gradient(to bottom right,#0000 calc(50% - 40px),#fffdf5a1 50%,#0000 calc(50% + 40px)) 
    bottom right/calc(200% + 80px) calc(200% + 80px) 
    rgba(0, 0, 0, 0.068);
  animation: l8 2s infinite ;
}
@keyframes l8 {
    100% {background-position: top left}
}

.imgloader {
  width: 84px;
  height: 84px;
  position: relative;
  background: #fff2c8;
  border-radius: 4px;
  overflow: hidden;
  z-index: 5;
}
.imgloader:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  transform: rotate(45deg) translate(30%, 40%);
  background: #ffd971;
  box-shadow: 32px -34px 0 5px #ffae00;
  animation: slide 2s infinite ease-in-out alternate;
}
.imgloader:after {
  content: "";
  position: absolute;
  left: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffa600;
  transform: rotate(0deg);
  transform-origin: 35px 145px;
  animation: rotate 2s infinite ease-in-out;
}
@keyframes slide {
  0% , 100%{ bottom: -55px}
  25% , 75%{ bottom: -2px}
  20% , 80%{ bottom: 2px}
}
@keyframes rotate {
  0% { transform: rotate(-15deg)}
  25% , 75%{ transform: rotate(0deg)}
  100% {  transform: rotate(35deg)}
}

.botloader {
    width: 30px;
    height: 30px;
    background: linear-gradient(45deg, #ffddb0, #f19d00, #ffa621);
    border-radius: 50%;
    position: relative;
    box-shadow: 0 0 20px 3px rgba(255, 172, 47, 0.5) inset,
      0 3px 2px rgba(255, 159, 124, 0.3),
      0 0 6px rgba(255, 252, 248, 0.6);
    overflow: hidden;
  }
  .botloader:before,
  .botloader:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 45%;
    top: 0;
    background: linear-gradient(45deg, rgba(255, 219, 152, 0.8), rgba(255, 175, 100, 0.6));
    animation: wave 5s linear infinite;
  }
  .botloader:before {
    border-radius: 30%;
    background: linear-gradient(45deg, rgba(255, 154, 22, 0.6), rgba(255, 190, 133, 0.4));
    animation: wave 5s linear infinite;
  }
  @keyframes wave {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
.botringloader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: 
    radial-gradient(farthest-side,#ffa516 94%,#0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%,#ffa516);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{ 
  100%{transform: rotate(1turn)}
}
@keyframes smoothRotate {
  0%, 100% {
    transform: rotate(325deg);
  }
  50% {
    transform: rotate(250deg);
  }
}
.rotating-element {
  animation: smoothRotate 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.model-label-fade-in {
  opacity: 0;
  animation: fadeInUp 0.2s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-default-image {
  width: 100%;
  height: 250px;
  object-fit: contain; 
}

.product-default-image-recommendation {
  width: 100%;
  height: 120px;
  object-fit: contain;  
}

.product-card-header {
    height: 100%;
    width: 100%;
    border-radius: 20px !important;
}

.product-card-actions {
  padding: 12px 20px !important;
}

.product-btn-actions {
  border-radius: 15px !important;
}

.product-btn-actions:hover {
  transform: scale(1.05);
}
</style>
